import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type AddSelectionInput = {
  cases: Scalars['Float']['input'];
  requestId: Scalars['Float']['input'];
  resourceId: Scalars['Float']['input'];
  singles: Scalars['Float']['input'];
};

export type AdditionalInfoInput = {
  hearUs: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  isOngoingMinistry: Scalars['Boolean']['input'];
  ministryDescription?: InputMaybe<Scalars['String']['input']>;
  ministryDetails: Scalars['String']['input'];
  planToUse: Scalars['String']['input'];
};

export type AdditionalInfoModel = IAdditionalInfo & {
  hearUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isOngoingMinistry?: Maybe<Scalars['Boolean']['output']>;
  ministryDescription?: Maybe<Scalars['String']['output']>;
  ministryDetails?: Maybe<Scalars['String']['output']>;
  planToUse?: Maybe<Scalars['String']['output']>;
};

export type AdditionalInfoResponse = {
  data?: Maybe<AdditionalInfoModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type BlockInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  parentId?: InputMaybe<Scalars['Float']['input']>;
  sideContent?: InputMaybe<Scalars['String']['input']>;
};

export type BlockModel = IBlock & {
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order: Scalars['Float']['output'];
  sideContent?: Maybe<Scalars['String']['output']>;
};

export type BlockResponse = {
  data?: Maybe<BlockModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type BooleanFilterArgType = {
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckoutRequestInput = {
  selections: Array<SelectionInput>;
};

export type CheckoutRequestResponse = {
  data?: Maybe<RequestModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type CommentInput = {
  comment: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  requestId?: InputMaybe<Scalars['Float']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type CommentModel = IComment & {
  comment: Scalars['String']['output'];
  createTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  updateTime?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UserModel>;
};

export type CommentResponse = {
  data?: Maybe<CommentModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type CreateRequestInput = {
  additionalInfo?: InputMaybe<AdditionalInfoInput>;
  officeUse?: InputMaybe<OfficeUseInput>;
  requestTime?: InputMaybe<Scalars['DateTime']['input']>;
  selections: Array<SelectionInput>;
  shippedTime?: InputMaybe<Scalars['DateTime']['input']>;
  shippingDetail?: InputMaybe<ShippingDetailInput>;
  shippingLocation?: InputMaybe<ShippingAddressInput>;
  signature?: InputMaybe<SignatureInput>;
  user: UserUpdateInput;
};

export type CreateUserAdditionalInfoInput = {
  additionalInfo?: InputMaybe<AdditionalInfoInput>;
  userId: Scalars['Float']['input'];
};

export type CreateUserShippingDetailInput = {
  shippingDetail?: InputMaybe<UserShippingDetailInput>;
  userId: Scalars['Float']['input'];
};

export type CreateUserShippingLocationInput = {
  shippingLocation?: InputMaybe<UserShippingAddressInput>;
  userId: Scalars['Float']['input'];
};

export type DateFilterArgType = {
  equalTo?: InputMaybe<Scalars['DateTime']['input']>;
  lessThan?: InputMaybe<Scalars['DateTime']['input']>;
  lessThanEqual?: InputMaybe<Scalars['DateTime']['input']>;
  moreThan?: InputMaybe<Scalars['DateTime']['input']>;
  moreThanEqual?: InputMaybe<Scalars['DateTime']['input']>;
  notEqualTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSubmissionInput = {
  content: Scalars['String']['input'];
  formId?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['Float']['input'];
};

export type FormSubmissionModel = IFormSubmission & {
  content: Scalars['String']['output'];
  formId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
};

export type FormSubmissionPaginatedResponse = {
  items: Scalars['String']['output'];
  keys: Array<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
};

export type FormSubmissionResponse = {
  data?: Maybe<FormSubmissionModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type FormsInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  bccEmails?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  emailBottom?: InputMaybe<Scalars['String']['input']>;
  emailHeader?: InputMaybe<Scalars['String']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  replyEmail?: InputMaybe<Scalars['String']['input']>;
};

export type FormsModel = IForms & {
  adminEmail?: Maybe<Scalars['String']['output']>;
  bccEmails?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createTime: Scalars['DateTime']['output'];
  emailBottom?: Maybe<Scalars['String']['output']>;
  emailHeader?: Maybe<Scalars['String']['output']>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  replyEmail?: Maybe<Scalars['String']['output']>;
  submissions?: Maybe<Array<FormSubmissionModel>>;
  updateTime: Scalars['DateTime']['output'];
};

export type FormsPaginatedResponse = {
  items: Array<FormsModel>;
  total: Scalars['Float']['output'];
};

export type FormsResponse = {
  data?: Maybe<FormsModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type IAdditionalInfo = {
  hearUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isOngoingMinistry?: Maybe<Scalars['Boolean']['output']>;
  ministryDescription?: Maybe<Scalars['String']['output']>;
  ministryDetails?: Maybe<Scalars['String']['output']>;
  planToUse?: Maybe<Scalars['String']['output']>;
};

export type IBlock = {
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order: Scalars['Float']['output'];
  sideContent?: Maybe<Scalars['String']['output']>;
};

export type IComment = {
  comment: Scalars['String']['output'];
  createTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  updateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type IFormSubmission = {
  content: Scalars['String']['output'];
  formId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
};

export type IForms = {
  adminEmail?: Maybe<Scalars['String']['output']>;
  bccEmails?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createTime: Scalars['DateTime']['output'];
  emailBottom?: Maybe<Scalars['String']['output']>;
  emailHeader?: Maybe<Scalars['String']['output']>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  replyEmail?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
};

export type IMinistry = {
  btnLabel?: Maybe<Scalars['String']['output']>;
  btnUrl?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  headLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isNav: Scalars['Boolean']['output'];
  isGallery: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  sideContent?: Maybe<Scalars['String']['output']>;
  sideImage?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  galleries?: Maybe<Array<GalleryResourceModel>>;
  updateTime: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type INewsCategoryModel = {
  headLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  newsCategoryId: Scalars['String']['output'];
  sideContent?: Maybe<Scalars['String']['output']>;
};

export type IOfficeUse = {
  category: Scalars['Boolean']['output'];
  feedbackFormRequested: Scalars['Boolean']['output'];
  feedbackReceived: Scalars['Boolean']['output'];
  freightDelivery: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  monitorTracking: Scalars['Boolean']['output'];
  moreInfo: Scalars['Boolean']['output'];
  previous: Scalars['Boolean']['output'];
  shippingCarrier?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trackingInfo?: Maybe<Scalars['String']['output']>;
  upsLocation?: Maybe<Scalars['String']['output']>;
  usps: Scalars['Boolean']['output'];
  validateShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  wsGmGs: Scalars['Boolean']['output'];
};

export type IOrganizationInfo = {
  affiliation?: Maybe<Scalars['String']['output']>;
  differentOrgName?: Maybe<Scalars['String']['output']>;
  employerId?: Maybe<Scalars['String']['output']>;
  hasWebsite?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  is501c3?: Maybe<Scalars['Boolean']['output']>;
  isManagedByOrg?: Maybe<Scalars['Boolean']['output']>;
  ministryCategory?: Maybe<Scalars['String']['output']>;
  originalMinistryCategory?: Maybe<Scalars['String']['output']>;
  ministryDetails?: Maybe<Scalars['String']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  overseeMinistry?: Maybe<Scalars['String']['output']>;
};

export type IPages = {
  adminEmail?: Maybe<Scalars['String']['output']>;
  bccEmails?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  dropMenu: Scalars['Boolean']['output'];
  emailBottom?: Maybe<Scalars['String']['output']>;
  emailHeader?: Maybe<Scalars['String']['output']>;
  formId?: Maybe<Scalars['Float']['output']>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  loginFromEmail?: Maybe<Scalars['String']['output']>;
  loginBccEmails?: Maybe<Scalars['String']['output']>;
  loginSubjectEmail?: Maybe<Scalars['String']['output']>;
  loginTitleEmail?: Maybe<Scalars['String']['output']>;
  loginEmailContent?: Maybe<Scalars['String']['output']>;
  loginEmailLongTermContent?: Maybe<Scalars['String']['output']>;
  loginLinkEmail?: Maybe<Scalars['String']['output']>;
  headLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isApplicationForm: Scalars['Boolean']['output'];
  isApplicationLogin?: Scalars['Boolean']['output'];
  isHome: Scalars['Boolean']['output'];
  isNav: Scalars['Boolean']['output'];
  isShow: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  pageTitle: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Float']['output']>;
  sideContent?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  isFeedbackForm: Scalars['Boolean']['output'];
  feedbackFormFromEmail?: Maybe<Scalars['String']['output']>;
  feedbackFormBccEmails?: Maybe<Scalars['String']['output']>;
  feedbackFormSubjectEmail?: Maybe<Scalars['String']['output']>;
  feedbackFormTitleEmail?: Maybe<Scalars['String']['output']>;
  feedbackFormEmailContent?: Maybe<Scalars['String']['output']>;
  isRequestEmail: Scalars['Boolean']['output'];
  requestFromEmail?: Maybe<Scalars['String']['output']>;
  requestBccEmails?: Maybe<Scalars['String']['output']>;
  requestSubjectEmail?: Maybe<Scalars['String']['output']>;
  requestTitleEmail?: Maybe<Scalars['String']['output']>;
  requestEmailContent?: Maybe<Scalars['String']['output']>;
  isCloseAppEmail?: Maybe<Scalars['Boolean']['output']>;
  closeAppFromEmail?: Maybe<Scalars['String']['output']>;
  closeAppBccEmails?: Maybe<Scalars['String']['output']>;
  closeAppSubjectEmail?: Maybe<Scalars['String']['output']>;
  closeAppTitleEmail?: Maybe<Scalars['String']['output']>;
  closeAppEmailContent?: Maybe<Scalars['String']['output']>;
};

export type IPost = {
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isEnabled: Scalars['Boolean']['output'];
  ministryId: Scalars['String']['output'];
  publishedTime: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type IRequest = {
  createTime: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  requestTime?: Maybe<Scalars['DateTime']['output']>;
  shippedTime?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type IRequestUser = {
  createTime: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  lastName: Scalars['String']['output'];
  ministryName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  rank?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type IResource = {
  author: Scalars['String']['output'];
  caseWeight: Scalars['Float']['output'];
  categoryId: Scalars['Float']['output'];
  createTime: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  exclusiveOffer: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  imageUrl: Scalars['String']['output'];
  inventory: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  quantityInCase: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
  sortingOrder: Scalars['Float']['output'];
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type IExclusionGroup = {
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  endDateDays: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  resources: Array<Scalars['Float']['output']>;
  loginFromEmail?: Maybe<Scalars['String']['output']>;
  loginBccEmails?: Maybe<Scalars['String']['output']>;
  loginSubjectEmail?: Maybe<Scalars['String']['output']>;
  loginTitleEmail?: Maybe<Scalars['String']['output']>;
  loginEmailContent?: Maybe<Scalars['String']['output']>;
  loginEmailLongTermContent?: Maybe<Scalars['String']['output']>;
};

export type IResourceCategory = {
  createTime: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  sortingOrder: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type IResourceDistribution = {
  costToAttendee?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  expectToServe?: Maybe<Scalars['String']['output']>;
  heldToDistribute?: Maybe<Scalars['String']['output']>;
  howDistributed?: Maybe<Scalars['String']['output']>;
  howManyPeople?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  publicNotice?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  requestForEvent?: Maybe<Scalars['Boolean']['output']>;
};

export type IResourceInventory = {
  createTime: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  resource: ResourceModel;
  updateTime: Scalars['DateTime']['output'];
  user: UserModel;
};

export type ISelection = {
  cases: Scalars['Float']['output'];
  createTime: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  resourceId: Scalars['Float']['output'];
  singles: Scalars['Float']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type IShippingAddress = {
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  lastName: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  state: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type IShippingDetail = {
  contactInfo: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  is501c3: Scalars['Boolean']['output'];
  loadingDock: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  rank?: Maybe<Scalars['String']['output']>;
  resourceUse?: Maybe<Scalars['String']['output']>;
};

export type ISignature = {
  id: Scalars['Float']['output'];
  requestId: Scalars['Float']['output'];
  sign: Scalars['String']['output'];
};

export type ITestimonial = {
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  headLine?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ministryId?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  pageTitle: Scalars['String']['output'];
  sideContent?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type IGalleryResource = {
  id?: Maybe<Scalars['Float']['output']>;
  createTime?: Scalars['DateTime']['output'];
  updateTime?: Scalars['DateTime']['output'];
  ministryId?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  sortingOrder?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type IUser = {
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  autoRedFlag?: Maybe<Scalars['Boolean']['output']>;
  autoYellowFlag?: Maybe<Scalars['Boolean']['output']>;
  createTime: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  ministryName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  priorApplicationKey?: Maybe<Scalars['Float']['output']>;
  redFlag: Scalars['Boolean']['output'];
  roleId?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
  yellowFlag?: Maybe<Scalars['Boolean']['output']>;
};



export type IApprovals = {
  id: NumberFilterArgType;
  acceptedDate?: InputMaybe<DateFilterArgType>;
  endDate?: InputMaybe<DateFilterArgType>;
  createTime?: InputMaybe<DateFilterArgType>;
  updateTime?: InputMaybe<DateFilterArgType>;
  requestId?: InputMaybe<NumberFilterArgType>;
  requestStatus?: InputMaybe<StringFilterArgType>;
  ministryCategory?: InputMaybe<StringFilterArgType>;
  requestTime?: InputMaybe<DateFilterArgType>;
  shippedTime?: InputMaybe<DateFilterArgType>;
  organization?: InputMaybe<StringFilterArgType>;
  firstName?: InputMaybe<StringFilterArgType>;
  lastName?: InputMaybe<StringFilterArgType>;
};


export type IUserRole = {
  addAdmin: Scalars['Boolean']['output'];
  approveUser: Scalars['Boolean']['output'];
  changePermission: Scalars['Boolean']['output'];
  changeProfile: Scalars['Boolean']['output'];
  changeUsersProfile: Scalars['Boolean']['output'];
  createTime: Scalars['DateTime']['output'];
  deleteUser: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  editCMS: Scalars['Boolean']['output'];
  editCategory: Scalars['Boolean']['output'];
  editRequest: Scalars['Boolean']['output'];
  editResource: Scalars['Boolean']['output'];
  editShippedRequest: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
  viewCMS: Scalars['Boolean']['output'];
  viewCategory: Scalars['Boolean']['output'];
  viewRequest: Scalars['Boolean']['output'];
  viewResource: Scalars['Boolean']['output'];
};

export type IUserServe = {
  agreeTerm?: Maybe<Scalars['Boolean']['output']>;
  appliedBefore?: Maybe<Scalars['Boolean']['output']>;
  approximateTime?: Maybe<Scalars['String']['output']>;
  howHearUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
};

export type IUserShippingDetail = {
  contactInfo?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  is501c3?: Maybe<Scalars['Boolean']['output']>;
  loadingDock?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
};

export type IUserShippingLocation = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum LocationTitles {
  Chaplain = 'Chaplain',
  Director = 'Director',
  Doctor = 'Doctor',
  Pastor = 'Pastor',
  President = 'President',
  Rank = 'Rank',
  Reverend = 'Reverend',
  VicePresident = 'VicePresident',
  None = 'None'
}

export enum MinistryCategoryEnum {
  AtRisk = 'AtRisk',
  ChildrenMinistry = 'ChildrenMinistry',
  FirstResponders = 'FirstResponders',
  Healthcare = 'Healthcare',
  Military = 'Military',
  Other = 'Other',
  PrisonMinistry = 'PrisonMinistry',
  Personal = 'Personal',
  Inmate = 'Inmate',
}

export type MinistryInput = {
  btnLabel?: InputMaybe<Scalars['String']['input']>;
  btnUrl?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isNav?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  pageTitle: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Float']['input']>;
  resourceIds?: Array<Scalars['Float']['input']>;
  sideContent?: InputMaybe<Scalars['String']['input']>;
  sideImage?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};


export type GalleryResourceInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  ministryId?: InputMaybe<Scalars['Float']['input']>;
};

export type MinistryModel = IMinistry & {
  btnLabel?: Maybe<Scalars['String']['output']>;
  btnUrl?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<MinistryModel>>;
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  headLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isNav: Scalars['Boolean']['output'];
  isGallery: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<MinistryModel>;
  parentId?: Maybe<Scalars['Float']['output']>;
  resources?: Maybe<Array<ResourceModel>>;
  sideContent?: Maybe<Scalars['String']['output']>;
  sideImage?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  testimonials?: Maybe<Array<TestimonialModel>>;
  galleries?: Maybe<Array<GalleryResourceModel>>;
  updateTime: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type MinistryPaginatedResponse = {
  items: Array<MinistryModel>;
  total: Scalars['Float']['output'];
};

export type GalleryResourceResponse = {
  data?: Maybe<GalleryResourceModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type MinistryResponse = {
  data?: Maybe<MinistryModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type Mutation = {
  AddBlock: BlockResponse;
  AddComment: CommentResponse;
  AddSelection: SelectionResponse;
  CheckoutRequest: CheckoutRequestResponse;
  CreateForm: FormsResponse;
  CreateMinistry: MinistryResponse;
  CreateGalleryResource: GalleryResourceResponse;
  CreateNewsCategory: StringResponse;
  CreatePage: PagesResponse;
  CreatePost: PostResponse;
  CreateRequest: StringResponse;
  CreateResource: ResourceResponse;
  CreateExclusionGroup: ExclusionGroupResponse;
  CreateResourceCategory: ResourceCategoryResponse;
  CreateTestimonial: TestimonialResponse;
  CreateUserAdditionalInfo: AdditionalInfoResponse;
  CreateUserRole: UserRoleResponse;
  CreateUserShippingDetail: UserShippingDetailResponse;
  CreateUserShippingLocation: UserShippingLocationResponse;
  DeleteBlock: StringResponse;
  DeleteCategory: StringResponse;
  DeleteComment: StringResponse;
  DeleteForm: StringResponse;
  DeleteFormSubmission: StringResponse;
  DeleteMinistry: StringResponse;
  DeleteGalleryResource: StringResponse;
  DeletePage: StringResponse;
  DeletePost: StringResponse;
  DeleteRequest: StringResponse;
  DeleteResource: StringResponse;
  DeleteSelection: StringResponse;
  DeleteTestimonial: StringResponse;
  DeleteUser: StringResponse;
  DeleteUserRole: StringResponse;
  DeletedRequests: StringResponse;
  DuplicateForm: FormsResponse;
  DuplicateMinistry: MinistryResponse;
  DuplicatePage: PagesResponse;
  ExportRequests: Scalars['String']['output'];
  GetPreSignedUrl: StringResponse;
  Login: TokenResponse;
  PrintApplications: Scalars['String']['output'];
  PrintApprovalsSelected: Scalars['String']['output'];
  PrintRequestForm: Scalars['String']['output'];
  PrintRequests: Scalars['String']['output'];
  RequestPasswordReset: StringResponse;
  ResetPassword: StringResponse;
  ShipRequests: StringResponse;
  ShippingAddress: ShippingAddressResponse;
  ShippingDetail: ShippingDetailResponse;
  SignUp: UserResponse;
  Signature: SignatureResponse;
  SubmitForm: FormSubmissionResponse;
  UpdateBlock: BlockResponse;
  UpdateComment: CommentResponse;
  UpdateForm: FormsResponse;
  UpdateInventory: ResourceResponse;
  UpdateMinistry: MinistryResponse;
  UpdateGalleryResource: GalleryResourceResponse;
  UpdateNewsCategory: StringResponse;
  UpdateOfficeUse: OfficeUseResponse;
  UpdatePage: PagesResponse;
  UpdatePost: PostResponse;
  UpdateRequest: StringResponse;
  UpdateResource: ResourceResponse;
  UpdateResourceCategory: ResourceCategoryResponse;
  UpdateSelection: SelectionResponse;
  UpdateShippingDetail: ShippingDetailResponse;
  UpdateShippingLocation: ShippingAddressResponse;
  UpdateTestimonial: TestimonialResponse;
  UpdateUser: UserResponse;
  UpdateUserAdditionalInfo: AdditionalInfoResponse;
  UpdateUserAllInfo: StringResponse;
  UpdateUserRole: UserRoleResponse;
  UpdateUserShippingDetail: UserShippingDetailResponse;
  UpdateUserShippingLocation: UserShippingLocationResponse;
  UpdateUserStatus: UserResponse;
  UpdateUsersStatus: StringResponse;
};


export type MutationAddBlockArgs = {
  data: BlockInput;
};


export type MutationAddCommentArgs = {
  comment: CommentInput;
};


export type MutationAddSelectionArgs = {
  selection: AddSelectionInput;
};


export type MutationCheckoutRequestArgs = {
  selections: CheckoutRequestInput;
};


export type MutationCreateFormArgs = {
  Forms: FormsInput;
};


export type MutationCreateMinistryArgs = {
  ministry: MinistryInput;
};

export type MutationCreateGalleryResourceArgs = {
  galleryResource: GalleryResourceInput;
};

export type MutationUpdateGalleryResourceArgs = {
  galleryResource: GalleryResourceInput;
};


export type MutationCreateNewsCategoryArgs = {
  newsCategory: NewsCategoryInput;
};


export type MutationCreatePageArgs = {
  pages: PagesInput;
};


export type MutationCreatePostArgs = {
  post: PostsInput;
};


export type MutationCreateRequestArgs = {
  request: CreateRequestInput;
};


export type MutationCreateResourceArgs = {
  resource: ResourceInput;
};


export type MutationCreateResourceCategoryArgs = {
  category: ResourceCategoryInput;
};


export type MutationCreateTestimonialArgs = {
  testimonial: TestimonialInput;
};


export type MutationCreateUserAdditionalInfoArgs = {
  data: CreateUserAdditionalInfoInput;
};


export type MutationCreateUserRoleArgs = {
  input: UserRoleInput;
};


export type MutationCreateUserShippingDetailArgs = {
  data: CreateUserShippingDetailInput;
};


export type MutationCreateUserShippingLocationArgs = {
  data: CreateUserShippingLocationInput;
};


export type MutationDeleteBlockArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteCategoryArgs = {
  categoryId: Scalars['Float']['input'];
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['Float']['input'];
};


export type MutationDeleteFormArgs = {
  formId: Scalars['Float']['input'];
};


export type MutationDeleteFormSubmissionArgs = {
  submissionId: Scalars['Float']['input'];
};


export type MutationDeleteMinistryArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeletePageArgs = {
  pageId: Scalars['Float']['input'];
};


export type MutationDeletePostArgs = {
  postId: Scalars['Float']['input'];
};


export type MutationDeleteRequestArgs = {
  requestId: Scalars['Float']['input'];
};


export type MutationDeleteResourceArgs = {
  resourceId: Scalars['Float']['input'];
};


export type MutationDeleteSelectionArgs = {
  selectionId: Scalars['Float']['input'];
};


export type MutationDeleteTestimonialArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteUserRoleArgs = {
  roleId: Scalars['Float']['input'];
};


export type MutationDeletedRequestsArgs = {
  requestIds: Array<Scalars['Float']['input']>;
};


export type MutationDuplicateFormArgs = {
  formId: Scalars['Float']['input'];
};


export type MutationDuplicateMinistryArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDuplicatePageArgs = {
  pageId: Scalars['Float']['input'];
};


export type MutationExportRequestsArgs = {
  requestIds: Array<Scalars['Float']['input']>;
};


export type MutationGetPreSignedUrlArgs = {
  key: PreSignedUrlInput;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationPrintApplicationsArgs = {
  applicationIds: Array<Scalars['Float']['input']>;
  timezone: Scalars['Float']['input'];
};


export type MutationPrintRequestsArgs = {
  requestIds: Array<Scalars['Float']['input']>;
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationShipRequestsArgs = {
  requestIds: Array<Scalars['Float']['input']>;
};


export type MutationShippingAddressArgs = {
  shippingAddress: ShippingAddressInput;
};


export type MutationShippingDetailArgs = {
  shippingDetail: ShippingDetailInput;
};


export type MutationSignUpArgs = {
  data: UserSignUpInput;
};


export type MutationSignatureArgs = {
  sign: SignatureInput;
};


export type MutationSubmitFormArgs = {
  Forms: FormSubmissionInput;
};


export type MutationUpdateBlockArgs = {
  data: BlockInput;
};


export type MutationUpdateCommentArgs = {
  comment: CommentInput;
};


export type MutationUpdateFormArgs = {
  Form: FormsInput;
};


export type MutationUpdateInventoryArgs = {
  input: UpdateInventoryInput;
};


export type MutationUpdateMinistryArgs = {
  data: MinistryInput;
};


export type MutationUpdateNewsCategoryArgs = {
  newsCategory: NewsCategoryInput;
};


export type MutationUpdateOfficeUseArgs = {
  officeUse: OfficeUseInput;
};


export type MutationUpdatePageArgs = {
  page: PagesInput;
};


export type MutationUpdatePostArgs = {
  Post: PostsInput;
};


export type MutationUpdateRequestArgs = {
  request: UpdateRequestInput;
};


export type MutationUpdateResourceArgs = {
  resources: ResourceUpdateInput;
};


export type MutationUpdateResourceCategoryArgs = {
  category: ResourceCategoryUpdateInput;
};


export type MutationUpdateSelectionArgs = {
  selection: SelectionInput;
};


export type MutationUpdateShippingDetailArgs = {
  shippingDetail: UpdateShippingDetailInput;
};


export type MutationUpdateShippingLocationArgs = {
  shippingLocation: UpdateShippingAddressInput;
};


export type MutationUpdateTestimonialArgs = {
  data: TestimonialInput;
};


export type MutationUpdateUserArgs = {
  user: UserUpdateInput;
};


export type MutationUpdateUserAdditionalInfoArgs = {
  additionalInfo: AdditionalInfoInput;
};


export type MutationUpdateUserAllInfoArgs = {
  user: UpdateUserAllInfo;
};


export type MutationUpdateUserRoleArgs = {
  input: UserRoleInput;
};


export type MutationUpdateUserShippingDetailArgs = {
  shippingDetail: UserShippingDetailInput;
};


export type MutationUpdateUserShippingLocationArgs = {
  shippingLocation: UserShippingAddressInput;
};


export type MutationUpdateUserStatusArgs = {
  input: UpdateUserStatusInput;
};


export type MutationUpdateUsersStatusArgs = {
  input: UpdateUsersStatusInput;
};

export type NewsCategoryInput = {
  headLine?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  newsCategoryId: Scalars['String']['input'];
  sideContent?: InputMaybe<Scalars['String']['input']>;
};

export type NewsCategoryModel = INewsCategoryModel & {
  headLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  newsCategoryId: Scalars['String']['output'];
  sideContent?: Maybe<Scalars['String']['output']>;
};

export type NewsCategoryResponse = {
  data?: Maybe<NewsCategoryModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type NumberFilterArgType = {
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanEqual?: InputMaybe<Scalars['Float']['input']>;
  moreThan?: InputMaybe<Scalars['Float']['input']>;
  moreThanEqual?: InputMaybe<Scalars['Float']['input']>;
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  valueIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  valueNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OfficeUseInput = {
  category?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackFormRequested?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackReceived?: InputMaybe<Scalars['Boolean']['input']>;
  freightDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  monitorTracking?: InputMaybe<Scalars['Boolean']['input']>;
  moreInfo?: InputMaybe<Scalars['Boolean']['input']>;
  previous?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCarrier?: InputMaybe<ShippingCarrier>;
  status?: OfficeUseState;
  trackingInfo?: InputMaybe<Scalars['String']['input']>;
  upsLocation?: InputMaybe<UpsLocation>;
  usps?: InputMaybe<Scalars['Boolean']['input']>;
  validateShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  wsGmGs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfficeUseModel = IOfficeUse & {
  category: Scalars['Boolean']['output'];
  feedbackFormRequested: Scalars['Boolean']['output'];
  feedbackReceived: Scalars['Boolean']['output'];
  freightDelivery: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  monitorTracking: Scalars['Boolean']['output'];
  moreInfo: Scalars['Boolean']['output'];
  previous: Scalars['Boolean']['output'];
  shippingCarrier?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trackingInfo?: Maybe<Scalars['String']['output']>;
  upsLocation?: Maybe<Scalars['String']['output']>;
  usps: Scalars['Boolean']['output'];
  validateShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  wsGmGs: Scalars['Boolean']['output'];
};

export type OfficeUseResponse = {
  data?: Maybe<OfficeUseModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export enum OfficeUseState {
  Received = 'Received', 
  Printed = 'Printed',
  OnHold = 'OnHold',
  Shipped = 'Shipped',
  Closed = 'Closed'
}

export type OrganizationInfoInput = {
  affiliation: Scalars['String']['input'];
  differentOrgName?: InputMaybe<Scalars['String']['input']>;
  employerId?: InputMaybe<Scalars['String']['input']>;
  hasWebsite: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  is501c3: Scalars['Boolean']['input'];
  isManagedByOrg: Scalars['Boolean']['input'];
  ministryCategory?: MinistryCategoryEnum;
  originalMinistryCategory?: MinistryCategoryEnum;
  ministryDetails: Scalars['String']['input'];
  orgName: Scalars['String']['input'];
  overseeMinistry?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationInfoModel = IOrganizationInfo & {
  affiliation?: Maybe<Scalars['String']['output']>;
  differentOrgName?: Maybe<Scalars['String']['output']>;
  employerId?: Maybe<Scalars['String']['output']>;
  hasWebsite?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  is501c3?: Maybe<Scalars['Boolean']['output']>;
  isManagedByOrg?: Maybe<Scalars['Boolean']['output']>;
  ministryCategory?: Maybe<Scalars['String']['output']>;
  MinistryCategoryEnum?: Maybe<Scalars['String']['output']>;
  ministryDetails?: Maybe<Scalars['String']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  overseeMinistry?: Maybe<Scalars['String']['output']>;
};

export type PagesInput = {
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  bccEmails?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  dropMenu?: InputMaybe<Scalars['Boolean']['input']>;
  emailBottom?: InputMaybe<Scalars['String']['input']>;
  emailHeader?: InputMaybe<Scalars['String']['input']>;
  formId?: InputMaybe<Scalars['Float']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  loginFromEmail?: Maybe<Scalars['String']['output']>;
  loginBccEmails?: Maybe<Scalars['String']['output']>;
  loginSubjectEmail?: Maybe<Scalars['String']['output']>;
  loginTitleEmail?: Maybe<Scalars['String']['output']>;
  loginEmailContent?: Maybe<Scalars['String']['output']>;
  loginEmailLongTermContent?: Maybe<Scalars['String']['output']>;
  loginLinkEmail?: Maybe<Scalars['String']['output']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isApplicationForm?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicationLogin?: InputMaybe<Scalars['Boolean']['input']>;
  isHome?: InputMaybe<Scalars['Boolean']['input']>;
  isNav?: InputMaybe<Scalars['Boolean']['input']>;
  isShow?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  pageTitle: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Float']['input']>;
  sideContent?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PagesModel = IPages & {
  adminEmail?: Maybe<Scalars['String']['output']>;
  bccEmails?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<PagesModel>>;
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  dropMenu: Scalars['Boolean']['output'];
  emailBottom?: Maybe<Scalars['String']['output']>;
  emailHeader?: Maybe<Scalars['String']['output']>;
  form?: Maybe<FormsModel>;
  formId?: Maybe<Scalars['Float']['output']>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  headLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isApplicationForm: Scalars['Boolean']['output'];
  isApplicationLogin?: Scalars['Boolean']['output'];
  isHome: Scalars['Boolean']['output'];
  isNav: Scalars['Boolean']['output'];
  isShow: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  pageTitle: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Float']['output']>;
  sideContent?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type PagesPaginatedResponse = {
  items: Array<PagesModel>;
  total: Scalars['Float']['output'];
};

export type PagesResponse = {
  data?: Maybe<PagesModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type PostModel = IPost & {
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isEnabled: Scalars['Boolean']['output'];
  ministryId: Scalars['String']['output'];
  publishedTime: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PostPaginatedResponse = {
  items: Array<PostModel>;
  total: Scalars['Float']['output'];
};

export type PostResponse = {
  data?: Maybe<PostModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type PostsInput = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ministryId: Scalars['String']['input'];
  publishedTime?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type PreSignedUrlInput = {
  id: Scalars['String']['input'];
};

export type Query = {
  Categories: ResourceCategoryPaginatedResponse;
  CheckSignUp: StringResponse;
  Form: FormsResponse;
  FormSubmission: FormSubmissionResponse;
  FormSubmissions: FormSubmissionPaginatedResponse;
  Forms: FormsPaginatedResponse;
  GetFormByName: FormsResponse;
  GetNewsCategory: NewsCategoryResponse;
  GetPostByUrl: PostResponse;
  GetPostNavigation: StringResponse;
  Me: UserResponse;
  Ministries: MinistryPaginatedResponse;
  Ministry: MinistryResponse;
  MinistryByUrl: MinistryResponse;
  Page: PagesResponse;
  PageByUrl: PagesResponse;
  Pages: PagesPaginatedResponse;
  Post: PostResponse;
  Posts: PostPaginatedResponse;
  PublicResources: ResourcePaginatedResponse;
  Request: RequestResponse;
  GetCommentsByRequestId: GetCommentResponse;
  RequestReport: StringResponse;
  RequestSelections: RequestSelectionsResponse;
  RequestShipReport: StringResponse;
  Requests: RequestPaginatedResponse;
  Resource: ResourceResponse;
  Resources: ResourcePaginatedResponse;
  ResourcesInventory: ResourcePaginatedResponse;
  Testimonial: TestimonialResponse;
  TestimonialByUrl: TestimonialResponse;
  Testimonials: TestimonialPaginatedResponse;
  User: UserResponse;
  UserRole: UserRoleResponse;
  UserRoles: UserRolePaginatedResponse;
  UserShippingDetail: UserShippingDetailResponse;
  UserShippingLocation: UserShippingLocationResponse;
  Users: UserPaginatedResponse;
  hello: Scalars['String']['output'];
  resourceInventories: ResourceInventoryPaginatedResponse;
};


export type QueryCategoriesArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckSignUpArgs = {
  email: Scalars['String']['input'];
};


export type QueryFormArgs = {
  FormId: Scalars['Float']['input'];
};


export type QueryFormSubmissionArgs = {
  submissionId: Scalars['Float']['input'];
};


export type QueryFormSubmissionsArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  formId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFormsArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFormByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetNewsCategoryArgs = {
  newsCategoryId: Scalars['String']['input'];
};


export type QueryGetPostByUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryGetPostNavigationArgs = {
  ministryId: Scalars['String']['input'];
};


export type QueryMinistriesArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  isNav?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMinistryArgs = {
  id: Scalars['Float']['input'];
};


export type QueryMinistryByUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryPageArgs = {
  pageId: Scalars['Float']['input'];
};


export type QueryPageByUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryPagesArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  dropMenu?: InputMaybe<Scalars['Boolean']['input']>;
  isNav?: InputMaybe<Scalars['Boolean']['input']>;
  isShow?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostArgs = {
  PostId: Scalars['Float']['input'];
};


export type QueryPostsArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  isEnable?: InputMaybe<Scalars['Boolean']['input']>;
  ministryId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublicResourcesArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRequestArgs = {
  requestId: Scalars['Float']['input'];
};


export type QueryRequestReportArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};


export type QueryRequestSelectionsArgs = {
  requestId: Scalars['Float']['input'];
};


export type QueryRequestShipReportArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
  sort?: InputMaybe<ReportSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
};


export type QueryRequestsArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<RequestFilterArgType>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RequestSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
};


export type QueryResourceArgs = {
  resourceId: Scalars['Float']['input'];
};


export type QueryResourcesArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ResourceSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
};


export type QueryResourcesInventoryArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  end: Scalars['DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['DateTime']['input'];
};


export type QueryTestimonialArgs = {
  id: Scalars['Float']['input'];
};


export type QueryTestimonialByUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryTestimonialsArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  isNav?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryUserRoleArgs = {
  userroleId: Scalars['Float']['input'];
};


export type QueryUserRolesArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<UserFilterArgType>;
  isSuperUser?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
};


export type QueryResourceInventoriesArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  resourceId?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestFilterArgType = {
  city?: InputMaybe<StringFilterArgType>;
  email?: InputMaybe<StringFilterArgType>;
  firstName?: InputMaybe<StringFilterArgType>;
  id?: InputMaybe<StringFilterArgType>;
  lastName?: InputMaybe<StringFilterArgType>;
  organization?: InputMaybe<StringFilterArgType>;
  ministryCategory?: InputMaybe<StringFilterArgType>;
  redFlag?: InputMaybe<BooleanFilterArgType>;
  requestTime?: InputMaybe<DateFilterArgType>;
  shippedTime?: InputMaybe<DateFilterArgType>;
  state?: InputMaybe<StringFilterArgType>;
  status?: InputMaybe<StringFilterArgType>;
  yellowFlag?: InputMaybe<BooleanFilterArgType>;
};

export type RequestModel = IRequest & {
  comments?: Maybe<Array<CommentModel>>;
  createTime: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  officeUse?: Maybe<OfficeUseModel>;
  requestTime?: Maybe<Scalars['DateTime']['output']>;
  shippedTime?: Maybe<Scalars['DateTime']['output']>;
  shippingDetail?: Maybe<ShippingDetailModel>;
  selections?: Maybe<Array<SelectionModel>>;
  shippingLocation?: Maybe<ShippingAddressModel>;
  signature?: Maybe<SignatureModel>;
  status: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
  user?: Maybe<UserModel>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export type RequestPaginatedResponse = {
  items: Array<RequestModel>;
  total: Scalars['Float']['output'];
};

export type RequestResponse = {
  data?: Maybe<RequestModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type GetCommentResponse = {
  items: Array<CommentModel>;
  total: Scalars['Float']['output'];
};

export type RequestSelectionsResponse = {
  items: Array<SelectionModel>;
  total: Scalars['Float']['output'];
};

export enum RequestSortField {
  City = 'City',
  Email = 'Email',
  FirstName = 'FirstName',
  LastName = 'LastName',
  Organization = 'Organization',
  ministryCategory = 'ministryCategory',
  RequestDate = 'RequestDate',
  RequestNumber = 'RequestNumber',
  ShippedDate = 'ShippedDate',
  State = 'State',
  Status = 'Status'
}

export enum ReportSortField {
  Sku = 'Sku',
  Title = 'Title',
  
}

export type RequestUserModel = IRequestUser & {
  createTime: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  lastName: Scalars['String']['output'];
  ministryName: Scalars['String']['output'];
  ministryCategory: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  rank?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type ResourceCategoryInput = {
  description: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type ResourceCategoryModel = IResourceCategory & {
  createTime: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  sortingOrder: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type ResourceCategoryPaginatedResponse = {
  items: Array<ResourceCategoryModel>;
  total: Scalars['Float']['output'];
};

export type ResourceCategoryResponse = {
  data?: Maybe<ResourceCategoryModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type ResourceCategoryUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sortingOrder?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceDistributionInput = {
  costToAttendee?: InputMaybe<Scalars['String']['input']>;
  eventDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectToServe?: InputMaybe<Scalars['String']['input']>;
  heldToDistribute?: InputMaybe<Scalars['String']['input']>;
  howDistributed: Scalars['String']['input'];
  howManyPeople?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  publicNotice?: InputMaybe<Scalars['String']['input']>;
  purpose: Scalars['String']['input'];
  requestForEvent: Scalars['Boolean']['input'];
};

export type ResourceDistributionModel = IResourceDistribution & {
  costToAttendee?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['DateTime']['output']>;
  expectToServe?: Maybe<Scalars['String']['output']>;
  heldToDistribute?: Maybe<Scalars['String']['output']>;
  howDistributed?: Maybe<Scalars['String']['output']>;
  howManyPeople?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  publicNotice?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  requestForEvent?: Maybe<Scalars['Boolean']['output']>;
};

export type ResourceInput = {
  author: Scalars['String']['input'];
  caseWeight?: InputMaybe<Scalars['Float']['input']>;
  categoryId: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  exclusiveOffer?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  imageUrl: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  quantityInCase?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
  sortingOrder?: InputMaybe<Scalars['Float']['input']>;
  subTitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ExclusionGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  endDateDays?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  resourceIds: Array<Scalars['Float']['input']>;
  loginFromEmail?: Maybe<Scalars['String']['output']>;
  loginBccEmails?: Maybe<Scalars['String']['output']>;
  loginSubjectEmail?: Maybe<Scalars['String']['output']>;
  loginTitleEmail?: Maybe<Scalars['String']['output']>;
  loginEmailContent?: Maybe<Scalars['String']['output']>;
  loginEmailLongTermContent?: Maybe<Scalars['String']['output']>;
};

export type ResourceInventoryModel = IResourceInventory & {
  createTime: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  resource: ResourceModel;
  updateTime: Scalars['DateTime']['output'];
  user: UserModel;
};

export type ResourceInventoryPaginatedResponse = {
  items: Array<ResourceInventoryModel>;
  total: Scalars['Float']['output'];
};

export type ResourceModel = IResource & {
  author: Scalars['String']['output'];
  caseWeight: Scalars['Float']['output'];
  category: ResourceCategoryModel;
  categoryId: Scalars['Float']['output'];
  createTime: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  exclusiveOffer: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  imageUrl: Scalars['String']['output'];
  inventory: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lastYearShipped?: Maybe<Scalars['Float']['output']>;
  quantityInCase: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
  sortingOrder: Scalars['Float']['output'];
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type ExclusionGroupModel = IExclusionGroup & {
  resources: Array<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  loginFromEmail: Maybe<Scalars['String']['output']>;
  loginBccEmails: Maybe<Scalars['String']['output']>;
  loginSubjectEmail: Maybe<Scalars['String']['output']>;
  loginTitleEmail: Maybe<Scalars['String']['output']>;
  loginEmailContent: Maybe<Scalars['String']['output']>;
  loginEmailLongTermContent: Maybe<Scalars['String']['output']>;
};

export type ResourcePaginatedResponse = {
  items: Array<ResourceModel>;
  total: Scalars['Float']['output'];
};

export type ResourceResponse = {
  data?: Maybe<ResourceModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type ExclusionGroupResponse = {
  data?: Maybe<ExclusionGroupModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export enum ResourceSortField {
  CaseWeight = 'caseWeight',
  Description = 'description',
  Id = 'id',
  IsActive = 'isActive',
  IsPublished = 'isPublished',
  QuantityInCase = 'quantityInCase',
  Sku = 'sku',
  Title = 'title'
}
export enum ExclusionGroupSortField {
  Description = 'description',
  Id = 'id',
  IsActive = 'isActive',
  Name = 'name'
}

export type ResourceUpdateInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  caseWeight?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  sortingOrder?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exclusiveOffer?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  quantityInCase?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExclusionGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  endDateDays?: InputMaybe<Scalars['Float']['input']>;
  resources?:  Array<InputMaybe<Scalars['Float']['input']>>;
  loginFromEmail?: Maybe<Scalars['String']['output']>;
  loginBccEmails?: Maybe<Scalars['String']['output']>;
  loginSubjectEmail?: Maybe<Scalars['String']['output']>;
  loginTitleEmail?: Maybe<Scalars['String']['output']>;
  loginEmailContent?: Maybe<Scalars['String']['output']>;
  loginEmailLongTermContent?: Maybe<Scalars['String']['output']>;
};

export type SelectionInput = {
  cases: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  resourceId: Scalars['Float']['input'];
  singles: Scalars['Float']['input'];
};

export type SelectionModel = ISelection & {
  cases: Scalars['Float']['output'];
  createTime: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  resource: ResourceModel;
  resourceId: Scalars['Float']['output'];
  singles: Scalars['Float']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type SelectionResponse = {
  data?: Maybe<SelectionModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type ShippingAddressInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  lastName: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  requestId?: InputMaybe<Scalars['Float']['input']>;
  state?: StateEnum;
  title?: InputMaybe<LocationTitles>;
  zipCode: Scalars['String']['input'];
};

export type ShippingAddressModel = IShippingAddress & {
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  lastName: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  state: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type ShippingAddressResponse = {
  data?: Maybe<ShippingAddressModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export enum ShippingCarrier {
  Freight = 'FREIGHT',
  Ups = 'UPS',
  Usps = 'USPS'
}

export type ShippingDetailInput = {
  contactInfo: Scalars['String']['input'];
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  is501c3?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDock: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
  rank?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['Float']['input']>;
  resourceUse?: InputMaybe<Scalars['String']['input']>
};

export type ShippingDetailModel = IShippingDetail & {
  contactInfo: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  is501c3: Scalars['Boolean']['output'];
  loadingDock: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  rank?: Maybe<Scalars['String']['output']>;
};

export type ShippingDetailResponse = {
  data?: Maybe<ShippingDetailModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type SignatureInput = {
  requestId?: InputMaybe<Scalars['Float']['input']>;
  sign: Scalars['String']['input'];
};

export type SignatureModel = ISignature & {
  id: Scalars['Float']['output'];
  requestId: Scalars['Float']['output'];
  sign: Scalars['String']['output'];
};

export type SignatureResponse = {
  data?: Maybe<SignatureModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export enum SortDirectionField {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum StateEnum {
  Aa = 'AA',
  Ae = 'AE',
  Ap = 'AP',
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY'
}

export type StringFilterArgType = {
  equalTo?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StringResponse = {
  data?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type TestimonialInput = {
  blocks?: InputMaybe<Array<BlockInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  ministryId?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  pageTitle: Scalars['String']['input'];
  sideContent?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type TestimonialModel = ITestimonial & {
  blocks?: Maybe<Array<BlockModel>>;
  content?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  headLine?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ministryId?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  pageTitle: Scalars['String']['output'];
  sideContent?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type GalleryResourceModel = IGalleryResource & {
  id?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['DateTime']['output'];
  updateTime: Scalars['DateTime']['output'];
  ministryId?: Maybe<Scalars['Float']['output']>;
  title: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  sortingOrder?: Maybe<Scalars['Float']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
};

export type TestimonialPaginatedResponse = {
  items: Array<TestimonialModel>;
  total: Scalars['Float']['output'];
};

export type TestimonialResponse = {
  data?: Maybe<TestimonialModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type Token = {
  accessToken: Scalars['String']['output'];
};

export type TokenResponse = {
  data?: Maybe<Token>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export enum UpsLocation {
  Commercial = 'Commercial',
  Residential = 'Residential',
  Unknown = 'Unknown'
}

export type UpdateAdditionalInfoInput = {
  hearUs?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isOngoingMinistry?: InputMaybe<Scalars['Boolean']['input']>;
  ministryDescription?: InputMaybe<Scalars['String']['input']>;
  ministryDetails?: InputMaybe<Scalars['String']['input']>;
  planToUse?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInventoryInput = {
  count: Scalars['Float']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  userId: Scalars['Float']['input'];
};

export type ApprovalsSelectedForPDF = Exact<{
  id?: InputMaybe<number>;
  acceptedDate?: InputMaybe<DateFilterArgType>;  
  createTime?: InputMaybe<DateFilterArgType>;
  endDate?: InputMaybe<DateFilterArgType>;
  ministryCategory?: InputMaybe<string>;
  requestId?: InputMaybe<number>;
  requestStatus?: InputMaybe<string>;
  requestTime?: InputMaybe<DateFilterArgType>;
  shippedTime?: InputMaybe<DateFilterArgType | null>;
  organization?: InputMaybe<string> | null;
  firstName?: InputMaybe<string> | null;
  lastName?: InputMaybe<string> | null;
}>;

export type UpdateRequestInput = {
  additionalInfo?: InputMaybe<UpdateAdditionalInfoInput>;
  id: Scalars['Float']['input'];
  officeUse?: InputMaybe<OfficeUseInput>;
  requestTime?: InputMaybe<Scalars['DateTime']['input']>;
  shippedTime?: InputMaybe<Scalars['DateTime']['input']>;
  shippingDetail?: InputMaybe<UpdateShippingDetailInput>;
  shippingLocation?: InputMaybe<UpdateShippingAddressInput>;
  signature?: InputMaybe<UpdateSignatureInput>;
  user: UserUpdateInput;
};

export type UpdateShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['Float']['input']>;
  state?: StateEnum;
  title?: InputMaybe<LocationTitles>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShippingDetailInput = {
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  is501c3?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDock?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSignatureInput = {
  id: Scalars['Float']['input'];
  requestId?: InputMaybe<Scalars['Float']['input']>;
  sign?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserAllInfo = {
  additionalInfo?: InputMaybe<UpdateAdditionalInfoInput>;
  organizationInfoInput?: InputMaybe<OrganizationInfoInput>;
  resourceDistributionInput?: InputMaybe<ResourceDistributionInput>;
  shippingDetail?: InputMaybe<UserShippingDetailInput>;
  shippingLocation?: InputMaybe<UserShippingAddressInput>;
  user?: InputMaybe<UserUpdateInput>;
  userServeInput?: InputMaybe<UserServeInput>;
};

export type RequestLoginInput = {
  ids: Array<Scalars['Int']['input']>;
  content: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  title: Scalars['String']['input'];
  link: Scalars['String']['input'];
  from: Scalars['String']['input'];
  bcc: Scalars['String']['input'];
};
export type UpdateUserStatusInput = {
  id: Scalars['Float']['input'];
  status: Scalars['String']['input'];
};

export type UpdateUsersStatusInput = {
  ids: Array<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
};

export type UserFilterArgType = {
  acceptedDate?: InputMaybe<DateFilterArgType>;
  createTime?: InputMaybe<DateFilterArgType>;
  email?: InputMaybe<StringFilterArgType>;
  firstName?: InputMaybe<StringFilterArgType>;
  status?: InputMaybe<StringFilterArgType>;
  id?: InputMaybe<NumberFilterArgType>;
  isActive?: InputMaybe<StringFilterArgType>;
  lastName?: InputMaybe<StringFilterArgType>;
  organization?: InputMaybe<StringFilterArgType>;
  ministryCategory?: InputMaybe<StringFilterArgType>;
  phone?: InputMaybe<StringFilterArgType>;
};

export type ApprovalsFilterArgType = {
  id?: InputMaybe<NumberFilterArgType>;
  acceptedDate?: InputMaybe<DateFilterArgType>;
  endDate?: InputMaybe<DateFilterArgType>;
  createTime?: InputMaybe<DateFilterArgType>;
  updateTime?: InputMaybe<DateFilterArgType>;
  requestId?: InputMaybe<NumberFilterArgType>;
  requestStatus?: InputMaybe<StringFilterArgType>;
  ministryCategory?: InputMaybe<StringFilterArgType>;
  requestTime?: InputMaybe<DateFilterArgType>;
  shippedTime?: InputMaybe<DateFilterArgType>;
};

export type UserInput = {
  acceptedDate?: InputMaybe<Scalars['DateTime']['input']>;
  autoRedFlag?: InputMaybe<Scalars['Boolean']['input']>;
  autoYellowFlag?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  ministryName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  priorApplicationKey?: InputMaybe<Scalars['Float']['input']>;
  redFlag?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  yellowFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserModel = IUser & {
  acceptedDate?: Maybe<Scalars['DateTime']['output']>;
  autoRedFlag?: Maybe<Scalars['Boolean']['output']>;
  autoYellowFlag?: Maybe<Scalars['Boolean']['output']>;
  createTime: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  ministryName?: Maybe<Scalars['String']['output']>;
  organizationInfo?: Maybe<OrganizationInfoModel>;
  phone: Scalars['String']['output'];
  priorApplicationKey?: Maybe<Scalars['Float']['output']>;
  redFlag: Scalars['Boolean']['output'];
  requests?: Maybe<Array<RequestModel>>;
  resourceDistribution?: Maybe<ResourceDistributionModel>;
  role?: Maybe<UserRoleModel>;
  roleId?: Maybe<Scalars['Float']['output']>;
  shippingDetails?: Maybe<Array<UserShippingDetailModel>>;
  shippingLocations?: Maybe<Array<UserShippingLocationModel>>;
  exclusionGroup?: Maybe<ExclusionGroupModel>;
  status: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
  userServe?: Maybe<UserServeModel>;
  yellowFlag?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Array<CommentModel>>;
};

export type UserPaginatedResponse = {
  items: Array<UserModel>;
  total: Scalars['Float']['output'];
};

export type UserResponse = {
  data?: Maybe<UserModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type UserRoleInput = {
  addAdmin: Scalars['Boolean']['input'];
  approveUser: Scalars['Boolean']['input'];
  changePermission: Scalars['Boolean']['input'];
  changeProfile: Scalars['Boolean']['input'];
  changeUsersProfile: Scalars['Boolean']['input'];
  deleteUser: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  editCMS: Scalars['Boolean']['input'];
  editCategory: Scalars['Boolean']['input'];
  editRequest: Scalars['Boolean']['input'];
  editResource: Scalars['Boolean']['input'];
  editShippedRequest: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  viewCMS: Scalars['Boolean']['input'];
  viewCategory: Scalars['Boolean']['input'];
  viewRequest: Scalars['Boolean']['input'];
  viewResource: Scalars['Boolean']['input'];
};

export type UserRoleModel = IUserRole & {
  addAdmin: Scalars['Boolean']['output'];
  approveUser: Scalars['Boolean']['output'];
  changePermission: Scalars['Boolean']['output'];
  changeProfile: Scalars['Boolean']['output'];
  changeUsersProfile: Scalars['Boolean']['output'];
  createTime: Scalars['DateTime']['output'];
  deleteUser: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  editCMS: Scalars['Boolean']['output'];
  editCategory: Scalars['Boolean']['output'];
  editRequest: Scalars['Boolean']['output'];
  editResource: Scalars['Boolean']['output'];
  editShippedRequest: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updateTime: Scalars['DateTime']['output'];
  viewCMS: Scalars['Boolean']['output'];
  viewCategory: Scalars['Boolean']['output'];
  viewRequest: Scalars['Boolean']['output'];
  viewResource: Scalars['Boolean']['output'];
};

export type UserRolePaginatedResponse = {
  items: Array<UserRoleModel>;
  total: Scalars['Float']['output'];
};

export type UserRoleResponse = {
  data?: Maybe<UserRoleModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type UserServeInput = {
  agreeTerm: Scalars['Boolean']['input'];
  appliedBefore: Scalars['Boolean']['input'];
  approximateTime?: InputMaybe<Scalars['String']['input']>;
  howHearUs: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type UserServeModel = IUserServe & {
  agreeTerm?: Maybe<Scalars['Boolean']['output']>;
  appliedBefore?: Maybe<Scalars['Boolean']['output']>;
  approximateTime?: Maybe<Scalars['String']['output']>;
  howHearUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
};

export type UserShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserShippingDetailInput = {
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  is501c3?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDock?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
};

export type UserShippingDetailModel = IUserShippingDetail & {
  contactInfo?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  is501c3?: Maybe<Scalars['Boolean']['output']>;
  loadingDock?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
};

export type UserShippingDetailResponse = {
  data?: Maybe<UserShippingDetailModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type UserShippingLocationModel = IUserShippingLocation & {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createTime: Scalars['DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updateTime: Scalars['DateTime']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserShippingLocationResponse = {
  data?: Maybe<UserShippingLocationModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type UserSignUpInput = {
  organizationInfoInput?: InputMaybe<OrganizationInfoInput>;
  resourceDistributionInput?: InputMaybe<ResourceDistributionInput>;
  shippingDetail?: InputMaybe<UserShippingDetailInput>;
  shippingLocation?: InputMaybe<UserShippingAddressInput>;
  user: UserInput;
  userServeInput?: InputMaybe<UserServeInput>;
};

export enum UserSortField {
  CreateTime = 'createTime',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  IsActive = 'isActive',
  LastName = 'lastName',
  Phone = 'phone'
}

export enum ApprovalSortField {
  id = 'id',
  createTime = 'createTime',
  updateTime = 'updateTime',
  acceptedDate = 'acceptedDate',
  email = 'email',
  endDate = 'endDate',
  ministryCategory = 'ministryCategory',
  requestId = 'requestId', 
  requestStatus = 'requestStatus', 
  requestTime = 'requestTime',
  shippedTime = 'shippedTime'
}

export type UserUpdateInput = {
  autoRedFlag?: InputMaybe<Scalars['Boolean']['input']>;
  autoYellowFlag?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  ministryCategory?: InputMaybe<Scalars['String']['input']>;
  originalMinistryCategory?: InputMaybe<Scalars['String']['input']>;
  ministryName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priorApplicationKey?: InputMaybe<Scalars['Float']['input']>;
  redFlag?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Float']['input']>;
  yellowFlag?: InputMaybe<Scalars['Boolean']['input']>;
  exclusionGroup?: InputMaybe<Scalars['Float']['input']>;
  acceptedDate?: InputMaybe<Scalars['String']['input']>;
};

export type UserFragmentFragment = { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any };

export type UserRoleFragmentFragment = { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean };

export type ShippingLocationFragmentFragment = { __typename: 'ShippingAddressModel', id: number, organization: string, title?: string | null, firstName: string, lastName: string, address1: string, address2: string, city: string, state: string, zipCode: string };

export type ShippingDetailFragmentFragment = { __typename: 'ShippingDetailModel', id: number, phone: string, email: string, loadingDock: boolean, is501c3: boolean, contactInfo: string, rank?: string | null };

export type OrganizationInfoFragmentFragment = { __typename: 'OrganizationInfoModel', id: number, ministryCategory?: string | null, originalMinistryCategory?: string | null, orgName?: string | null, isManagedByOrg?: boolean | null, affiliation?: string | null, is501c3?: boolean | null, hasWebsite?: string | null, ministryDetails?: string | null, differentOrgName?: string | null, overseeMinistry?: string | null, employerId?: string | null };

export type ResourceDistributionFragmentFragment = { __typename: 'ResourceDistributionModel', id: number, requestForEvent?: boolean | null, purpose?: string | null, howDistributed?: string | null, eventDate?: any | null, expectToServe?: string | null, costToAttendee?: string | null, heldToDistribute?: string | null, publicNotice?: string | null, howManyPeople?: string | null };

export type UserServeFragmentFragment = { __typename: 'UserServeModel', id: number, appliedBefore?: boolean | null, howHearUs?: string | null, agreeTerm?: boolean | null, approximateTime?: string | null };

export type OfficeUseFragmentFragment = { __typename: 'OfficeUseModel', id: number, freightDelivery: boolean, feedbackReceived: boolean, feedbackFormRequested: boolean, category: boolean, monitorTracking: boolean, previous: boolean, moreInfo: boolean, shippingCarrier?: string | null, status?: string | null, trackingInfo?: string | null, usps: boolean, validateShippingAddress?: boolean | null, upsLocation?: string | null, wsGmGs: boolean };

export type ResourceCategoryFragment = { __typename: 'ResourceCategoryModel', id: number, title: string, description?: string | null, sortingOrder: number, updateTime: any, isActive: boolean, createTime: any };

export type ResourceFragmentFragment = { __typename: 'ResourceModel', updateTime: any, title: string, subTitle: string, author: string, isPublished: boolean, sortingOrder: number, quantityInCase: number, isActive: boolean, imageUrl: string, id: number, exclusiveOffer: boolean, description?: string | null, createTime: any, categoryId: number, sku: string, caseWeight: number, isDeleted: boolean, inventory: number, lastYearShipped?: number | null };

export type ExclusionGroupFragmentFragment = { __typename: 'ExclusionGroupModel', name: string, isActive: boolean, id: number, description?: string | null, isDeleted: boolean, loginFromEmail: string; loginBccEmails: string; loginSubjectEmail: string; loginTitleEmail: string; loginEmailContent: string; loginEmailLongTermContent: string; };

export type PageFragmentFragment = { __typename: 'PagesModel', isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null };

export type MinistryFragmentFragment = { __typename: 'MinistryModel', content?: string | null, createTime: any, headLine?: string | null, id: number, isNav: boolean, name: string, order: number, pageTitle?: string | null, parentId?: number | null, sideContent?: string | null, updateTime: any, url?: string | null, sideImage?: string | null, summary?: string | null, btnLabel?: string | null, btnUrl?: string | null };

export type SignUpMutationVariables = Exact<{
  data: UserSignUpInput;
}>;


export type SignUpMutation = { __typename: 'Mutation', SignUp: { __typename: 'UserResponse', message: string, status: boolean, data?: { __typename: 'UserModel', id: number, firstName?: string | null, lastName?: string | null, email: string, phone: string, isActive: boolean, isSuperuser: boolean, createTime: any, updateTime: any, role?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null } | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type RequestLoginSchemaVariables = Exact<{
  email: Scalars['String']['input'];
}>;
export type RequestLoginMutationSchemaVariables = Exact<{
  input: RequestLoginInput;
}>;
export type RequestLoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename: 'Mutation', Login: { __typename: 'TokenResponse', status: boolean, message: string, errorCode?: number | null, data?: { __typename: 'Token', accessToken: string } | null } };
export type RequestLoginMutation = { __typename: 'Mutation', RequestLogin: { __typename: 'StringResponse', status: boolean, message: string, errorCode?: number | null, data?: string | null } };
export type RequestLoginMutationWithToken = { __typename: 'Mutation', RequestLoginWithToken: { __typename: 'TokenResponse', status: boolean, message: string, errorCode?: number | null, data?: { __typename: 'Token', accessToken: string } | null } };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename: 'Mutation', RequestPasswordReset: { __typename: 'StringResponse', status: boolean, message: string } };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', ResetPassword: { __typename: 'StringResponse', status: boolean, message: string } };

export type CreateResourceCategoryMutationVariables = Exact<{
  category: ResourceCategoryInput;
}>;


export type CreateResourceCategoryMutation = { __typename: 'Mutation', CreateResourceCategory: { __typename: 'ResourceCategoryResponse', message: string, status: boolean, data?: { __typename: 'ResourceCategoryModel', id: number, title: string, description?: string | null, sortingOrder: number, updateTime: any, isActive: boolean, createTime: any } | null } };

export type UpdateResourceCategoryMutationVariables = Exact<{
  updateResourceCategory: ResourceCategoryUpdateInput;
}>;


export type UpdateResourceCategoryMutation = { __typename: 'Mutation', UpdateResourceCategory: { __typename: 'ResourceCategoryResponse', message: string, status: boolean, data?: { __typename: 'ResourceCategoryModel', id: number, title: string, description?: string | null, sortingOrder: number, updateTime: any, isActive: boolean, createTime: any } | null } };

export type DeleteResourceCategoryMutationVariables = Exact<{
  categoryId: Scalars['Float']['input'];
}>;


export type DeleteResourceCategoryMutation = { __typename: 'Mutation', DeleteCategory: { __typename: 'StringResponse', status: boolean, message: string } };

export type CreateResourceMutationVariables = Exact<{
  resource: ResourceInput;
}>;


export type CreateResourceMutation = { __typename: 'Mutation', CreateResource: { __typename: 'ResourceResponse', status: boolean, message: string, data?: { __typename: 'ResourceModel', updateTime: any, title: string, subTitle: string, author: string, isPublished: boolean, sortingOrder: number, quantityInCase: number, isActive: boolean, imageUrl: string, id: number, exclusiveOffer: boolean, description?: string | null, createTime: any, categoryId: number, sku: string, caseWeight: number, isDeleted: boolean, inventory: number, lastYearShipped?: number | null } | null } };

export type UpdateResourceMutationVariables = Exact<{
  resources: ResourceUpdateInput;
}>;


export type UpdateResourceMutation = { __typename: 'Mutation', UpdateResource: { __typename: 'ResourceResponse', data?: { __typename: 'ResourceModel', updateTime: any, title: string, subTitle: string, author: string, isPublished: boolean, sortingOrder: number, quantityInCase: number, isActive: boolean, imageUrl: string, id: number, exclusiveOffer: boolean, description?: string | null, createTime: any, categoryId: number, sku: string, caseWeight: number, isDeleted: boolean, inventory: number, lastYearShipped?: number | null } | null } };

export type DeleteResourceMutationVariables = Exact<{
  resourceId: Scalars['Float']['input'];
}>;


export type DeleteResourceMutation = { __typename: 'Mutation', DeleteResource: { __typename: 'StringResponse', message: string, status: boolean } };

export type CheckoutRequestMutationVariables = Exact<{
  selections: CheckoutRequestInput;
}>;


export type CheckoutRequestMutation = { __typename: 'Mutation', CheckoutRequest: { __typename: 'CheckoutRequestResponse', data?: { __typename: 'RequestModel', id: number, updateTime: any, createTime: any, status: string } | null } };

export type CreateRequestByAdminMutationVariables = Exact<{
  request: CreateRequestInput;
}>;


export type CreateRequestByAdminMutation = { __typename: 'Mutation', CreateRequest: { __typename: 'StringResponse', status: boolean, message: string, data?: string | null } };

export type DeleteRequestMutationVariables = Exact<{
  requestId: Scalars['Float']['input'];
}>;


export type DeleteRequestMutation = { __typename: 'Mutation', DeleteRequest: { __typename: 'StringResponse', status: boolean, message: string, data?: string | null } };

export type DeleteRequestsMutationVariables = Exact<{
  requestIds: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
}>;


export type DeleteRequestsMutation = { __typename: 'Mutation', DeletedRequests: { __typename: 'StringResponse', message: string, status: boolean, data?: string | null } };

export type UpdateRequestMutationVariables = Exact<{
  request: UpdateRequestInput;
}>;


export type UpdateRequestMutation = { __typename: 'Mutation', UpdateRequest: { __typename: 'StringResponse', status: boolean, message: string } };

export type ShipRequestsMutationVariables = Exact<{
  requestIds: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
}>;


export type ShipRequestsMutation = { __typename: 'Mutation', ShipRequests: { __typename: 'StringResponse', data?: string | null, message: string, status: boolean } };

export type CreatePageMutationVariables = Exact<{
  pages: PagesInput;
}>;


export type CreatePageMutation = { __typename: 'Mutation', CreatePage: { __typename: 'PagesResponse', status: boolean, message: string, data?: { __typename: 'PagesModel', isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null, children?: Array<{ __typename: 'PagesModel', isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null }> | null } | null } };

export type UpdatePageMutationVariables = Exact<{
  updatePagePage: PagesInput;
}>;


export type UpdatePageMutation = { __typename: 'Mutation', UpdatePage: { __typename: 'PagesResponse', data?: { __typename: 'PagesModel', isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null } | null } };

export type DuplicatePageMutationVariables = Exact<{
  pageId: Scalars['Float']['input'];
}>;


export type DuplicatePageMutation = { __typename: 'Mutation', DuplicatePage: { __typename: 'PagesResponse', message: string, status: boolean, data?: { __typename: 'PagesModel', isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null } | null } };

export type DeletePageMutationVariables = Exact<{
  pageId: Scalars['Float']['input'];
}>;


export type DeletePageMutation = { __typename: 'Mutation', DeletePage: { __typename: 'StringResponse', status: boolean, message: string } };

export type UpdateUserStatusMutationVariables = Exact<{
  input: UpdateUserStatusInput;
}>;


export type UpdateUserStatusMutation = { __typename: 'Mutation', UpdateUserStatus: { __typename: 'UserResponse', message: string, status: boolean, data?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any } | null } };

export type UpdateUsersStatusMutationVariables = Exact<{
  input: UpdateUsersStatusInput;
}>;


export type UpdateUsersStatusMutation = { __typename: 'Mutation', UpdateUsersStatus: { __typename: 'StringResponse', message: string, status: boolean } };

export type UpdateUserMutationVariables = Exact<{
  user: UserUpdateInput;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', UpdateUser: { __typename: 'UserResponse', message: string, status: boolean, data?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any } | null } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteUserMutation = { __typename: 'Mutation', DeleteUser: { __typename: 'StringResponse', status: boolean, message: string } };

export type GetPreSignedUrlMutationVariables = Exact<{
  key: PreSignedUrlInput;
}>;


export type GetPreSignedUrlMutation = { __typename: 'Mutation', GetPreSignedUrl: { __typename: 'StringResponse', data?: string | null, message: string, status: boolean } };

export type ShippingAddressMutationVariables = Exact<{
  shippingAddress: ShippingAddressInput;
}>;


export type ShippingAddressMutation = { __typename: 'Mutation', ShippingAddress: { __typename: 'ShippingAddressResponse', message: string, status: boolean, data?: { __typename: 'ShippingAddressModel', address1: string, address2: string, city: string, firstName: string, id: number, organization: string, lastName: string, state: string, title?: string | null, zipCode: string } | null } };

export type ShippingDetailMutationVariables = Exact<{
  shippingDetail: ShippingDetailInput;
}>;


export type ShippingDetailMutation = { __typename: 'Mutation', ShippingDetail: { __typename: 'ShippingDetailResponse', message: string, status: boolean, data?: { __typename: 'ShippingDetailModel', phone: string, loadingDock: boolean, id: number, email: string, contactInfo: string } | null } };

export type SignatureMutationVariables = Exact<{
  sign: SignatureInput;
}>;


export type SignatureMutation = { __typename: 'Mutation', Signature: { __typename: 'SignatureResponse', message: string, status: boolean, data?: { __typename: 'SignatureModel', requestId: number, sign: string } | null } };

export type CreateFormMutationVariables = Exact<{
  forms: FormsInput;
}>;


export type CreateFormMutation = { __typename: 'Mutation', CreateForm: { __typename: 'FormsResponse', message: string, status: boolean, data?: { __typename: 'FormsModel', id: number, name: string, content: string, adminEmail?: string | null, createTime: any, updateTime: any } | null } };

export type UpdateFormMutationVariables = Exact<{
  form: FormsInput;
}>;


export type UpdateFormMutation = { __typename: 'Mutation', UpdateForm: { __typename: 'FormsResponse', status: boolean, message: string, data?: { __typename: 'FormsModel', id: number, name: string, content: string, createTime: any, updateTime: any } | null } };

export type DuplicateFormMutationVariables = Exact<{
  formId: Scalars['Float']['input'];
}>;


export type DuplicateFormMutation = { __typename: 'Mutation', DuplicateForm: { __typename: 'FormsResponse', message: string, status: boolean, data?: { __typename: 'FormsModel', id: number, name: string, content: string, createTime: any, updateTime: any } | null } };

export type DeleteFormMutationVariables = Exact<{
  formId: Scalars['Float']['input'];
}>;


export type DeleteFormMutation = { __typename: 'Mutation', DeleteForm: { __typename: 'StringResponse', message: string, status: boolean } };

export type SubmitFormMutationVariables = Exact<{
  forms: FormSubmissionInput;
}>;


export type SubmitFormMutation = { __typename: 'Mutation', SubmitForm: { __typename: 'FormSubmissionResponse', status: boolean, message: string, data?: { __typename: 'FormSubmissionModel', id: number, content: string, formId: number } | null } };

export type UpdateShippingLocationMutationVariables = Exact<{
  shippingLocation: UpdateShippingAddressInput;
}>;


export type UpdateShippingLocationMutation = { __typename: 'Mutation', UpdateShippingLocation: { __typename: 'ShippingAddressResponse', status: boolean, message: string, data?: { __typename: 'ShippingAddressModel', firstName: string, city: string, address2: string, address1: string, id: number, lastName: string, organization: string, state: string, title?: string | null, zipCode: string } | null } };

export type UpdateShippingDetailMutationVariables = Exact<{
  shippingDetail: UpdateShippingDetailInput;
}>;


export type UpdateShippingDetailMutation = { __typename: 'Mutation', UpdateShippingDetail: { __typename: 'ShippingDetailResponse', message: string, status: boolean, data?: { __typename: 'ShippingDetailModel', contactInfo: string, email: string, loadingDock: boolean, phone: string, id: number } | null } };

export type UpdateOfficeUseMutationVariables = Exact<{
  officeUse: OfficeUseInput;
}>;


export type UpdateOfficeUseMutation = { __typename: 'Mutation', UpdateOfficeUse: { __typename: 'OfficeUseResponse', message: string, status: boolean, data?: { __typename: 'OfficeUseModel', category: boolean, feedbackFormRequested: boolean, freightDelivery: boolean, id: number, feedbackReceived: boolean, monitorTracking: boolean, moreInfo: boolean, previous: boolean, shippingCarrier?: string | null, status?: string | null, trackingInfo?: string | null, upsLocation?: string | null, usps: boolean, validateShippingAddress?: boolean | null, wsGmGs: boolean } | null } };

export type AddSelectionMutationVariables = Exact<{
  selection: AddSelectionInput;
}>;


export type AddSelectionMutation = { __typename: 'Mutation', AddSelection: { __typename: 'SelectionResponse', message: string, status: boolean, data?: { __typename: 'SelectionModel', id: number } | null } };

export type UpdateSelectionMutationVariables = Exact<{
  selection: SelectionInput;
}>;


export type UpdateSelectionMutation = { __typename: 'Mutation', UpdateSelection: { __typename: 'SelectionResponse', message: string, status: boolean, data?: { __typename: 'SelectionModel', cases: number, createTime: any, id: number, resourceId: number, singles: number, updateTime: any, resource: { __typename: 'ResourceModel', caseWeight: number, categoryId: number, createTime: any, description?: string | null, exclusiveOffer: boolean, id: number, imageUrl: string, isActive: boolean, isPublished: boolean, quantityInCase: number, sku: string, sortingOrder: number, title: string, updateTime: any } } | null } };

export type DeleteSelectionMutationVariables = Exact<{
  selectionId: Scalars['Float']['input'];
}>;


export type DeleteSelectionMutation = { __typename: 'Mutation', DeleteSelection: { __typename: 'StringResponse', data?: string | null, message: string, status: boolean } };

export type CreateUserRoleMutationVariables = Exact<{
  input: UserRoleInput;
}>;


export type CreateUserRoleMutation = { __typename: 'Mutation', CreateUserRole: { __typename: 'UserRoleResponse', message: string, status: boolean, data?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null } };

export type UpdateUserRoleMutationVariables = Exact<{
  input: UserRoleInput;
}>;


export type UpdateUserRoleMutation = { __typename: 'Mutation', UpdateUserRole: { __typename: 'UserRoleResponse', message: string, status: boolean, data?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, id: number, editResource: boolean, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null } };

export type DeleteUserRoleMutationVariables = Exact<{
  roleId: Scalars['Float']['input'];
}>;


export type DeleteUserRoleMutation = { __typename: 'Mutation', DeleteUserRole: { __typename: 'StringResponse', status: boolean, message: string } };

export type ExportRequestsMutationVariables = Exact<{
  requestIds: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
}>;


export type ExportRequestsMutation = { __typename: 'Mutation', ExportRequests: string };

export type PrintRequestsMutationVariables = Exact<{
  requestIds: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  timeZone:  Scalars['String']['input'];
}>;


export type PrintRequestsMutation = { __typename: 'Mutation', PrintRequests: string };

export type PrintRequestFormMutationVariables = Exact<{ [key: string]: never; }>;


export type PrintRequestFormMutation = { __typename: 'Mutation', PrintRequestForm: string };

export type CreateUserShippingLocationMutationVariables = Exact<{
  data: CreateUserShippingLocationInput;
}>;


export type CreateUserShippingLocationMutation = { __typename: 'Mutation', CreateUserShippingLocation: { __typename: 'UserShippingLocationResponse', status: boolean, message: string, data?: { __typename: 'UserShippingLocationModel', address1?: string | null, address2?: string | null, city?: string | null, createTime: any, firstName?: string | null, id: number, lastName?: string | null, organization?: string | null, state?: string | null, title?: string | null, updateTime: any, zipCode?: string | null } | null } };

export type UpdateUserShippingLocationMutationVariables = Exact<{
  shippingLocation: UserShippingAddressInput;
}>;


export type UpdateUserShippingLocationMutation = { __typename: 'Mutation', UpdateUserShippingLocation: { __typename: 'UserShippingLocationResponse', message: string, status: boolean, data?: { __typename: 'UserShippingLocationModel', address1?: string | null, address2?: string | null, city?: string | null, createTime: any, firstName?: string | null, id: number, lastName?: string | null, organization?: string | null, state?: string | null, title?: string | null, updateTime: any, zipCode?: string | null } | null } };

export type CreateUserShippingDetailMutationVariables = Exact<{
  data: CreateUserShippingDetailInput;
}>;


export type CreateUserShippingDetailMutation = { __typename: 'Mutation', CreateUserShippingDetail: { __typename: 'UserShippingDetailResponse', status: boolean, message: string, data?: { __typename: 'UserShippingDetailModel', contactInfo?: string | null, createTime: any, email?: string | null, id: number, loadingDock?: boolean | null, phone?: string | null, updateTime: any } | null } };

export type UpdateUserShippingDetailMutationVariables = Exact<{
  shippingDetail: UserShippingDetailInput;
}>;


export type UpdateUserShippingDetailMutation = { __typename: 'Mutation', UpdateUserShippingDetail: { __typename: 'UserShippingDetailResponse', message: string, status: boolean, data?: { __typename: 'UserShippingDetailModel', contactInfo?: string | null, createTime: any, email?: string | null, id: number, loadingDock?: boolean | null, phone?: string | null, updateTime: any } | null } };

export type CreateUserAdditionalInfoMutationVariables = Exact<{
  data: CreateUserAdditionalInfoInput;
}>;


export type CreateUserAdditionalInfoMutation = { __typename: 'Mutation', CreateUserAdditionalInfo: { __typename: 'AdditionalInfoResponse', status: boolean, message: string, data?: { __typename: 'AdditionalInfoModel', hearUs?: string | null, id: number, isOngoingMinistry?: boolean | null, ministryDescription?: string | null, ministryDetails?: string | null, planToUse?: string | null } | null } };

export type UpdateUserAdditionalInfoMutationVariables = Exact<{
  additionalInfo: AdditionalInfoInput;
}>;


export type UpdateUserAdditionalInfoMutation = { __typename: 'Mutation', UpdateUserAdditionalInfo: { __typename: 'AdditionalInfoResponse', status: boolean, message: string, data?: { __typename: 'AdditionalInfoModel', hearUs?: string | null, id: number, isOngoingMinistry?: boolean | null, ministryDescription?: string | null, ministryDetails?: string | null, planToUse?: string | null } | null } };

export type AddCommentMutationVariables = Exact<{
  comment: CommentInput;
}>;


export type AddCommentMutation = { __typename: 'Mutation', AddComment: { __typename: 'CommentResponse', message: string, status: boolean, data?: { __typename: 'CommentModel', comment: string, id: number, updateTime?: any | null, createTime?: any | null } | null } };

export type UpdateCommentMutationVariables = Exact<{
  comment: CommentInput;
}>;


export type UpdateCommentMutation = { __typename: 'Mutation', UpdateComment: { __typename: 'CommentResponse', message: string, status: boolean, data?: { __typename: 'CommentModel', comment: string, id: number, updateTime?: any | null, createTime?: any | null } | null } };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['Float']['input'];
}>;


export type DeleteCommentMutation = { __typename: 'Mutation', DeleteComment: { __typename: 'StringResponse', message: string, status: boolean, data?: string | null } };

export type DeleteFormSubmissionMutationVariables = Exact<{
  submissionId: Scalars['Float']['input'];
}>;


export type DeleteFormSubmissionMutation = { __typename: 'Mutation', DeleteFormSubmission: { __typename: 'StringResponse', status: boolean, message: string, data?: string | null } };

export type CreateNewsCategoryMutationVariables = Exact<{
  newsCategory: NewsCategoryInput;
}>;


export type CreateNewsCategoryMutation = { __typename: 'Mutation', CreateNewsCategory: { __typename: 'StringResponse', status: boolean, message: string } };

export type UpdateNewsCategoryMutationVariables = Exact<{
  newsCategory: NewsCategoryInput;
}>;


export type UpdateNewsCategoryMutation = { __typename: 'Mutation', UpdateNewsCategory: { __typename: 'StringResponse', status: boolean, message: string } };

export type CreatePostMutationVariables = Exact<{
  post: PostsInput;
}>;


export type CreatePostMutation = { __typename: 'Mutation', CreatePost: { __typename: 'PostResponse', status: boolean, message: string, data?: { __typename: 'PostModel', content?: string | null, id: number, isEnabled: boolean, publishedTime: any, title?: string | null, url: string } | null } };

export type UpdatePostMutationVariables = Exact<{
  post: PostsInput;
}>;


export type UpdatePostMutation = { __typename: 'Mutation', UpdatePost: { __typename: 'PostResponse', message: string, status: boolean, data?: { __typename: 'PostModel', content?: string | null, id: number, isEnabled: boolean, publishedTime: any, title?: string | null, url: string } | null } };

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['Float']['input'];
}>;


export type DeletePostMutation = { __typename: 'Mutation', DeletePost: { __typename: 'StringResponse', data?: string | null, message: string, status: boolean } };

export type UpdateUserAllInfoMutationVariables = Exact<{
  user: UpdateUserAllInfo;
}>;


export type UpdateUserAllInfoMutation = { __typename: 'Mutation', UpdateUserAllInfo: { __typename: 'StringResponse', status: boolean, message: string, data?: string | null } };

export type CreateMinistryMutationVariables = Exact<{
  ministry: MinistryInput;
}>;
export type CreateGalleryResourceMutationVariables = Exact<{
  galleryResource: GalleryResourceInput;
}>;
export type UpdateGalleryResourceMutationVariables = Exact<{
  data: GalleryResourceInput;
}>;

export type DeleteGalleryResourceMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CreateMinistryMutation = { __typename: 'Mutation', CreateMinistry: { __typename: 'MinistryResponse', status: boolean, message: string, data?: { __typename: 'MinistryModel', content?: string | null, createTime: any, headLine?: string | null, id: number, isNav: boolean, name: string, order: number, pageTitle?: string | null, parentId?: number | null, sideContent?: string | null, updateTime: any, url?: string | null, sideImage?: string | null, summary?: string | null, btnLabel?: string | null, btnUrl?: string | null } | null } };
export type CreateGalleryResourceMutation = { __typename: 'Mutation', CreateGalleryResource: { __typename: 'GalleryResourceResponse', status: boolean, message: string, data?: { __typename: 'GalleryResourceModel', title?: string, description?: string, imageUrl?: string,sortingOrder?: number; ministryId: number}}};
export type UpdateGalleryResourceMutation = { __typename: 'Mutation', UpdateGalleryResource: { __typename: 'GalleryResourceResponse', status: boolean, message: string, data?: { __typename: 'GalleryResourceModel', title?: string, description?: string, imageUrl?: string,sortingOrder?: number; ministryId: number}}};
export type DeleteGalleryResourceMutation = { __typename: 'Mutation', DeleteGalleryResource: { __typename: 'StringResponse', data?: string | null, message: string, status: boolean } };

export type DuplicateMinistryMutationVariables = Exact<{
  ministryId: Scalars['Float']['input'];
}>;


export type DuplicateMinistryMutation = { __typename: 'Mutation', DuplicateMinistry: { __typename: 'MinistryResponse', status: boolean, message: string, data?: { __typename: 'MinistryModel', content?: string | null, createTime: any, headLine?: string | null, id: number, isNav: boolean, name: string, order: number, pageTitle?: string | null, parentId?: number | null, sideContent?: string | null, updateTime: any, url?: string | null, sideImage?: string | null, summary?: string | null, btnLabel?: string | null, btnUrl?: string | null } | null } };

export type UpdateMinistryMutationVariables = Exact<{
  ministry: MinistryInput;
}>;


export type UpdateMinistryMutation = { __typename: 'Mutation', UpdateMinistry: { __typename: 'MinistryResponse', status: boolean, message: string, data?: { __typename: 'MinistryModel', content?: string | null, createTime: any, headLine?: string | null, id: number, isNav: boolean, name: string, order: number, pageTitle?: string | null, parentId?: number | null, sideContent?: string | null, updateTime: any, url?: string | null, sideImage?: string | null, summary?: string | null, btnLabel?: string | null, btnUrl?: string | null } | null } };

export type DeleteMinistryMutationVariables = Exact<{
  deleteMinistryId: Scalars['Float']['input'];
}>;


export type DeleteMinistryMutation = { __typename: 'Mutation', DeleteMinistry: { __typename: 'StringResponse', data?: string | null, message: string, status: boolean } };

export type CreateTestimonialMutationVariables = Exact<{
  testimonial: TestimonialInput;
}>;


export type CreateTestimonialMutation = { __typename: 'Mutation', CreateTestimonial: { __typename: 'TestimonialResponse', status: boolean, message: string, data?: { __typename: 'TestimonialModel', content?: string | null, createTime: any, headLine?: string | null, id?: number | null, name: string, order: number, pageTitle: string, ministryId?: number | null, sideContent?: string | null, updateTime: any, url: string, blocks?: Array<{ __typename: 'BlockModel', content?: string | null, id?: number | null, order: number, sideContent?: string | null }> | null } | null } };

export type DeleteTestimonialMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type DeleteTestimonialMutation = { __typename: 'Mutation', DeleteTestimonial: { __typename: 'StringResponse', data?: string | null, message: string, status: boolean } };

export type UpdateTestimonialMutationVariables = Exact<{
  data: TestimonialInput;
}>;


export type UpdateTestimonialMutation = { __typename: 'Mutation', UpdateTestimonial: { __typename: 'TestimonialResponse', status: boolean, message: string, data?: { __typename: 'TestimonialModel', content?: string | null, createTime: any, headLine?: string | null, id?: number | null, name: string, order: number, pageTitle: string, ministryId?: number | null, sideContent?: string | null, summary?: string | null, updateTime: any, url: string, blocks?: Array<{ __typename: 'BlockModel', content?: string | null, id?: number | null, order: number, sideContent?: string | null }> | null } | null } };

export type AddBlockMutationVariables = Exact<{
  data: BlockInput;
}>;


export type AddBlockMutation = { __typename: 'Mutation', AddBlock: { __typename: 'BlockResponse', status: boolean, message: string, data?: { __typename: 'BlockModel', content?: string | null, id?: number | null, order: number, sideContent?: string | null } | null } };

export type UpdateBlockMutationVariables = Exact<{
  data: BlockInput;
}>;


export type UpdateBlockMutation = { __typename: 'Mutation', UpdateBlock: { __typename: 'BlockResponse', message: string, status: boolean, data?: { __typename: 'BlockModel', content?: string | null, id?: number | null, order: number, sideContent?: string | null } | null } };

export type DeleteBlockMutationVariables = Exact<{
  deleteBlockId: Scalars['Float']['input'];
}>;


export type DeleteBlockMutation = { __typename: 'Mutation', DeleteBlock: { __typename: 'StringResponse', status: boolean, message: string, data?: string | null } };

export type UpdateInventoryMutationVariables = Exact<{
  input: UpdateInventoryInput;
}>;


export type UpdateInventoryMutation = { __typename: 'Mutation', UpdateInventory: { __typename: 'ResourceResponse', data?: { __typename: 'ResourceModel', caseWeight: number, categoryId: number, createTime: any, description?: string | null, exclusiveOffer: boolean, id: number, imageUrl: string, inventory: number, isActive: boolean, isDeleted: boolean, isPublished: boolean, quantityInCase: number, sku: string, sortingOrder: number, title: string, updateTime: any } | null } };

export type PrintApplicationsMutationVariables = Exact<{
  applicationIds: Array<Scalars['Float']['input']> | Scalars['Float']['input'];
  timezone: Scalars['Float']['input'];
}>;

export type PrintApprovalsSelectedMutationVariables = Exact<{
  approvalsSelected: any[]
}>;


export type PrintApplicationsMutation = { __typename: 'Mutation', PrintApplications: string };
export type PrintApprovalsSelectedMutation = { __typename: 'Mutation', PrintApprovalsSelected: string };

export type CheckSignUpQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckSignUpQuery = { __typename: 'Query', CheckSignUp: { __typename: 'StringResponse', status: boolean, message: string, errorCode?: number | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename: 'Query', Me: { __typename: 'UserResponse', message: string, status: boolean, data?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any, role?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null, shippingLocations?: Array<{ __typename: 'UserShippingLocationModel', id: number, organization?: string | null, title?: string | null, firstName?: string | null, lastName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, createTime: any, updateTime: any }> | null, shippingDetails?: Array<{ __typename: 'UserShippingDetailModel', id: number, phone?: string | null, email?: string | null, loadingDock?: boolean | null, is501c3?: boolean | null, contactInfo?: string | null, rank?: string | null, createTime: any, updateTime: any }> | null, organizationInfo?: { __typename: 'OrganizationInfoModel', id: number, ministryCategory?: string | null, originalMinistryCategory?: string | null, orgName?: string | null, isManagedByOrg?: boolean | null, affiliation?: string | null, is501c3?: boolean | null, hasWebsite?: string | null, ministryDetails?: string | null, differentOrgName?: string | null, overseeMinistry?: string | null, employerId?: string | null } | null, resourceDistribution?: { __typename: 'ResourceDistributionModel', id: number, requestForEvent?: boolean | null, purpose?: string | null, howDistributed?: string | null, eventDate?: any | null, expectToServe?: string | null, costToAttendee?: string | null, heldToDistribute?: string | null, publicNotice?: string | null, howManyPeople?: string | null } | null, userServe?: { __typename: 'UserServeModel', id: number, appliedBefore?: boolean | null, howHearUs?: string | null, agreeTerm?: boolean | null, approximateTime?: string | null } | null } | null } };

export type CategoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CategoriesQuery = { __typename: 'Query', Categories: { __typename: 'ResourceCategoryPaginatedResponse', total: number, items: Array<{ __typename: 'ResourceCategoryModel', id: number, title: string, description?: string | null, sortingOrder: number, updateTime: any, isActive: boolean, createTime: any }> } };

export type CategoryListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CategoryListQuery = { __typename: 'Query', Categories: { __typename: 'ResourceCategoryPaginatedResponse', total: number, items: Array<{ __typename: 'ResourceCategoryModel', id: number, title: string }> } };

export type ResourcesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ResourceSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
}>;

export type ExclusionGroupQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ExclusionGroupSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
}>;

export type ResourcesQuery = { __typename: 'Query', Resources: { __typename: 'ResourcePaginatedResponse', total: number, items: Array<{ __typename: 'ResourceModel', updateTime: any, title: string, subTitle: string, author: string, isPublished: boolean, sortingOrder: number, quantityInCase: number, isActive: boolean, imageUrl: string, id: number, exclusiveOffer: boolean, description?: string | null, createTime: any, categoryId: number, sku: string, caseWeight: number, isDeleted: boolean, inventory: number, lastYearShipped?: number | null }> } };
export type ExclusionGroupQuery = { __typename: 'Query', ExclusionGroups: { __typename: 'ExclusionGroupPaginatedResponse', total: number, items: Array<{ __typename: 'ExclusionGroupModel', name: string, endDateDays: number | null, description: string | null, isActive: boolean, isDeleted: boolean, loginFromEmail: string; loginBccEmails: string; loginSubjectEmail: string; loginTitleEmail: string; loginEmailContent: string; loginEmailLongTermContent: string; }> } };
export type ExclusionGroupByIdQuery = { __typename: 'Query', ExclusionGroup: { __typename: 'ExclusionGroupResponse', message: string, status: boolean, data?: { __typename: 'ExclusionGroupModel', name: string, description: string | null, isActive: boolean, isDeleted: boolean, resources: Array<ResourceModel>, loginFromEmail: string; loginBccEmails: string; loginSubjectEmail: string; loginTitleEmail: string; loginEmailContent: string; loginEmailLongTermContent: string; } } };

export type PublicResourcesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  resourcesSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicResourcesQuery = { __typename: 'Query', PublicResources: { __typename: 'ResourcePaginatedResponse', total: number, items: Array<{ __typename: 'ResourceModel', updateTime: any, title: string, subTitle: string, author: string, isPublished: boolean, sortingOrder: number, quantityInCase: number, isActive: boolean, imageUrl: string, id: number, exclusiveOffer: boolean, description?: string | null, createTime: any, categoryId: number, sku: string, caseWeight: number, isDeleted: boolean, inventory: number, lastYearShipped?: number | null }> } };

export type ResourcesListQueryVariables = Exact<{ 
  sort?: InputMaybe<ResourceSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
}>;
export type ExclusionGroupsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourcesListQuery = { __typename: 'Query', Resources: { __typename: 'ResourcePaginatedResponse', total: number, items: Array<{ __typename: 'ResourceModel', updateTime: any, title: string, subTitle: string, author: string, isPublished: boolean, sortingOrder: number, quantityInCase: number, isActive: boolean, imageUrl: string, id: number, exclusiveOffer: boolean, description?: string | null, createTime: any, categoryId: number, sku: string, caseWeight: number, isDeleted: boolean, inventory: number, lastYearShipped?: number | null }> } };
export type ExclusionGroupsListQuery = { __typename: 'Query', ExclusionGroups: { __typename: 'ExclusionGroupsPaginatedResponse', total: number, items: Array<{ __typename: 'ExclusionGroupModel', name: string, isActive: boolean, id: number, description?: string | null, isDeleted: boolean, loginFromEmail: string; loginBccEmails: string; loginSubjectEmail: string; loginTitleEmail: string; loginEmailContent: string; loginEmailLongTermContent: string; }> } };

export type ResourcesInventoryQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  sort?: InputMaybe<ReportSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
}>;


export type ResourcesInventoryQuery = { __typename: 'Query', ResourcesInventory: { __typename: 'ResourcePaginatedResponse', total: number, items: Array<{ __typename: 'ResourceModel', updateTime: any, title: string, subTitle: string, author: string, isPublished: boolean, sortingOrder: number, quantityInCase: number, isActive: boolean, imageUrl: string, id: number, exclusiveOffer: boolean, description?: string | null, createTime: any, categoryId: number, sku: string, caseWeight: number, isDeleted: boolean, inventory: number, lastYearShipped?: number | null }> } };

export type ResourceInventoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  resourceId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ResourceInventoriesQuery = { __typename: 'Query', resourceInventories: { __typename: 'ResourceInventoryPaginatedResponse', total: number, items: Array<{ __typename: 'ResourceInventoryModel', id: number, quantity: number, reason: string, createTime: any, updateTime: any, resource: { __typename: 'ResourceModel', id: number, title: string, sku: string, inventory: number }, user: { __typename: 'UserModel', id: number, firstName?: string | null, lastName?: string | null } }> } };

export type ResourceByIdQueryVariables = Exact<{
  resourceId: Scalars['Float']['input'];
}>;


export type ResourceByIdQuery = { __typename: 'Query', Resource: { __typename: 'ResourceResponse', message: string, status: boolean, data?: { __typename: 'ResourceModel', updateTime: any, title: string, subTitle: string, author: string, isPublished: boolean, sortingOrder: number, quantityInCase: number, isActive: boolean, imageUrl: string, id: number, exclusiveOffer: boolean, description?: string | null, createTime: any, categoryId: number, sku: string, caseWeight: number, isDeleted: boolean, inventory: number, lastYearShipped?: number | null } | null } };

export type PagesQueryVariables = Exact<{
  dropMenu?: InputMaybe<Scalars['Boolean']['input']>;
  isNav?: InputMaybe<Scalars['Boolean']['input']>;
  isShow?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PagesQuery = { __typename: 'Query', Pages: { __typename: 'PagesPaginatedResponse', total: number, items: Array<{ __typename: 'PagesModel', isRequestEmail: boolean, requestFromEmail?: string | null, requestBccEmails?: string | null, requestSubjectEmail?: string | null, requestTitleEmail?: string | null, requestEmailContent?: string | null, isCloseAppEmail: boolean, closeAppFromEmail?: string | null, closeAppBccEmails?: string | null, closeAppSubjectEmail?: string | null, closeAppTitleEmail?: string | null, closeAppEmailContent?: string | null, isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null, children?: Array<{ __typename: 'PagesModel', isRequestEmail: boolean, requestFromEmail?: string | null, requestBccEmails?: string | null, requestSubjectEmail?: string | null, requestTitleEmail?: string | null, requestEmailContent?: string | null, isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null }> | null }> } };

export type DropMenuPagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DropMenuPagesQuery = { __typename: 'Query', Pages: { __typename: 'PagesPaginatedResponse', total: number, items: Array<{ __typename: 'PagesModel', id: number, isNav: boolean, name: string }> } };

export type PageHeadersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PageHeadersQuery = { __typename: 'Query', Pages: { __typename: 'PagesPaginatedResponse', total: number, items: Array<{ __typename: 'PagesModel', content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null, children?: Array<{ __typename: 'PagesModel', content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null }> | null }> } };

export type PageByIdQueryVariables = Exact<{
  pageId: Scalars['Float']['input'];
}>;


export type PageByIdQuery = { __typename: 'Query', Page: { __typename: 'PagesResponse', data?: { __typename: 'PagesModel', isRequestEmail: boolean, loginEmailLongTermContent?: string | null, requestFromEmail?: string | null, requestBccEmails?: string | null, requestSubjectEmail?: string | null, requestTitleEmail?: string | null, requestEmailContent?: string | null, isCloseAppEmail: boolean, closeAppFromEmail?: string | null, closeAppBccEmails?: string | null, closeAppSubjectEmail?: string | null, closeAppTitleEmail?: string | null, closeAppEmailContent?: string | null, isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, isApplicationLogin: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null, loginFromEmail?: string | null, loginBccEmails?: string | null, loginSubjectEmail?: string | null, loginTitleEmail?: string | null, loginEmailContent?: string | null, loginLinkEmail?: string | null } | null } };
export type PageRequestLoginQuery = { __typename: 'Query', RequestLoginPage: { __typename: 'PagesResponse', data?: { __typename: 'PagesModel', isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, isApplicationLogin: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null, loginFromEmail?: string | null, loginBccEmails?: string | null, loginSubjectEmail?: string | null, loginTitleEmail?: string | null, loginEmailContent?: string | null, loginLinkEmail?: string | null, loginEmailLongTermContent?: string | null } | null } };
export type PageCloseAppQuery = { __typename: 'Query', CloseAppPage: { __typename: 'PagesResponse', data?: { __typename: 'PagesModel', isFeedbackForm: boolean, content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, isApplicationLogin: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null, loginFromEmail?: string | null, loginBccEmails?: string | null, loginSubjectEmail?: string | null, loginTitleEmail?: string | null, loginEmailContent?: string | null, loginLinkEmail?: string | null, isCloseAppEmail: boolean, closeAppFromEmail?: string | null, closeAppBccEmails?: string | null, closeAppSubjectEmail?: string | null, closeAppTitleEmail?: string | null, closeAppEmailContent?: string | null } | null } };

export type PageByUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type PageByUrlQuery = { __typename: 'Query', PageByUrl: { __typename: 'PagesResponse', message: string, status: boolean, data?: { __typename: 'PagesModel', content?: string | null, sideContent?: string | null, headLine?: string | null, dropMenu: boolean, id: number, isNav: boolean, isHome: boolean, isShow: boolean, name: string, pageTitle: string, parentId?: number | null, createTime: any, updateTime: any, url: string, order: number, formId?: number | null, isApplicationForm: boolean, isApplicationLogin: boolean, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null, loginFromEmail?: string | null, loginBccEmails?: string | null, loginSubjectEmail?: string | null, loginTitleEmail?: string | null, loginEmailContent?: string | null, loginLinkEmail?: string | null } | null } };

export type UsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  isSuperUser?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<UserSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFilterArgType>;
}>;

export type ApprovalsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  isSuperUser?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<ApprovalSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ApprovalsFilterArgType>;
}>;


export type UsersQuery = { __typename: 'Query', Users: { __typename: 'UserPaginatedResponse', total: number, items: Array<{ __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any, role?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null, organizationInfo?: { __typename: 'OrganizationInfoModel', id: number, ministryCategory?: string | null, originalMinistryCategory?: string | null, orgName?: string | null, isManagedByOrg?: boolean | null, affiliation?: string | null, is501c3?: boolean | null, hasWebsite?: string | null, ministryDetails?: string | null, differentOrgName?: string | null, overseeMinistry?: string | null, employerId?: string | null } | null }> } };
//export type ApprovalsQuery = { __typename: 'Query', Approvals: { __typename: 'ApprovalPaginatedResponse', total: number, items: Array<{ __typename: 'ApprovalsModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any, role?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null, organizationInfo?: { __typename: 'OrganizationInfoModel', id: number, ministryCategory?: string | null, originalMinistryCategory?: string | null, orgName?: string | null, isManagedByOrg?: boolean | null, affiliation?: string | null, is501c3?: boolean | null, hasWebsite?: string | null, ministryDetails?: string | null, differentOrgName?: string | null, overseeMinistry?: string | null, employerId?: string | null } | null }> } };
export type ApprovalsQuery = {
  __typename: 'Query';
  ApprovalUsers: {
    __typename: 'ApprovalPaginatedResponse';
    total: number;
    items: Array<IApprovals>;
  };
};
export type SelectUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SelectUsersQuery = { __typename: 'Query', Users: { __typename: 'UserPaginatedResponse', total: number, items: Array<{ __typename: 'UserModel', id: number, firstName?: string | null, lastName?: string | null }> } };

export type UserByIdQueryVariables = Exact<{
  userId: Scalars['Float']['input'];
}>;


export type UserByIdQuery = { __typename: 'Query', User: { __typename: 'UserResponse', status: boolean, message: string, data?: { __typename: 'UserModel', id: number, comments: Array<{ __typename: 'CommentModel', id: number, comment: string, user?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any } | null }>, exclusionGroup?: { __typename: 'ExclusionGroupModel', id: number, name: string } | null, firstName?: string | null, lastName?: string | null, email: string, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, isActive: boolean, status: string, isSuperuser: boolean, acceptedDate?: any | null, endDate?: any | null, createTime: any, updateTime: any, role?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null, shippingLocations?: Array<{ __typename: 'UserShippingLocationModel', id: number, organization?: string | null, title?: string | null, firstName?: string | null, lastName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, createTime: any, updateTime: any }> | null, shippingDetails?: Array<{ __typename: 'UserShippingDetailModel', id: number, phone?: string | null, email?: string | null, loadingDock?: boolean | null, is501c3?: boolean | null, contactInfo?: string | null, rank?: string | null, createTime: any, updateTime: any }> | null, organizationInfo?: { __typename: 'OrganizationInfoModel', id: number, ministryCategory?: string | null, originalMinistryCategory?: string | null, orgName?: string | null, isManagedByOrg?: boolean | null, affiliation?: string | null, is501c3?: boolean | null, hasWebsite?: string | null, ministryDetails?: string | null, differentOrgName?: string | null, overseeMinistry?: string | null, employerId?: string | null } | null, resourceDistribution?: { __typename: 'ResourceDistributionModel', id: number, requestForEvent?: boolean | null, purpose?: string | null, howDistributed?: string | null, eventDate?: any | null, expectToServe?: string | null, costToAttendee?: string | null, heldToDistribute?: string | null, publicNotice?: string | null, howManyPeople?: string | null } | null, userServe?: { __typename: 'UserServeModel', id: number, appliedBefore?: boolean | null, howHearUs?: string | null, agreeTerm?: boolean | null, approximateTime?: string | null } | null, requests?: Array<{ __typename: 'RequestModel', id: number }> | null } | null } };

export type UserShippingLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserShippingLocationQuery = { __typename: 'Query', UserShippingLocation: { __typename: 'UserShippingLocationResponse', message: string, status: boolean, data?: { __typename: 'UserShippingLocationModel', id: number, organization?: string | null, title?: string | null, firstName?: string | null, lastName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, createTime: any, updateTime: any } | null } };

export type UserShippingDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type UserShippingDetailQuery = { __typename: 'Query', UserShippingDetail: { __typename: 'UserShippingDetailResponse', message: string, status: boolean, data?: { __typename: 'UserShippingDetailModel', id: number, phone?: string | null, email?: string | null, loadingDock?: boolean | null, is501c3?: boolean | null, contactInfo?: string | null, rank?: string | null, createTime: any, updateTime: any } | null } };

export type FormsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FormsQuery = { __typename: 'Query', Forms: { __typename: 'FormsPaginatedResponse', total: number, items: Array<{ __typename: 'FormsModel', id: number, name: string, content: string, createTime: any, updateTime: any, adminEmail?: string | null, fromEmail?: string | null, emailHeader?: string | null, emailBottom?: string | null, replyEmail?: string | null, submissions?: Array<{ __typename: 'FormSubmissionModel', id: number }> | null }> } };

export type FormQueryVariables = Exact<{
  formId: Scalars['Float']['input'];
}>;


export type FormQuery = { __typename: 'Query', Form: { __typename: 'FormsResponse', message: string, status: boolean, data?: { __typename: 'FormsModel', id: number, name: string, content: string, createTime: any, updateTime: any, adminEmail?: string | null, fromEmail?: string | null, bccEmails?: string | null, emailHeader?: string | null, emailBottom?: string | null, replyEmail?: string | null } | null } };

export type FormByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type FormByNameQuery = { __typename: 'Query', GetFormByName: { __typename: 'FormsResponse', message: string, status: boolean, data?: { __typename: 'FormsModel', id: number, name: string, content: string, createTime: any, updateTime: any } | null } };

export type FormSubmissionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type FormSubmissionsQuery = { __typename: 'Query', FormSubmissions: { __typename: 'FormSubmissionPaginatedResponse', items: string, keys: Array<string>, total: number } };

export type FormSubmissionQueryVariables = Exact<{
  submissionId: Scalars['Float']['input'];
}>;


export type FormSubmissionQuery = { __typename: 'Query', FormSubmission: { __typename: 'FormSubmissionResponse', message: string, status: boolean, data?: { __typename: 'FormSubmissionModel', id: number, formId: number, content: string } | null } };

export type RequestsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<RequestFilterArgType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<RequestSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
  ids?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestsQuery = { __typename: 'Query', Requests: { __typename: 'RequestPaginatedResponse', total: number, items: Array<{ __typename: 'RequestModel', userId?: number | null, updateTime: any, shippedTime?: any | null, requestTime?: any | null, status: string, id: number, createTime: any, user?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any, organizationInfo?: { __typename: 'OrganizationInfoModel', id: number, ministryCategory?: string | null, originalMinistryCategory?: string | null, orgName?: string | null, isManagedByOrg?: boolean | null, affiliation?: string | null, is501c3?: boolean | null, hasWebsite?: string | null, ministryDetails?: string | null, differentOrgName?: string | null, overseeMinistry?: string | null, employerId?: string | null } | null } | null, signature?: { __typename: 'SignatureModel', id: number, sign: string } | null, shippingLocation?: { __typename: 'ShippingAddressModel', id: number, organization: string, title?: string | null, firstName: string, lastName: string, address1: string, address2: string, city: string, state: string, zipCode: string } | null, shippingDetail?: { __typename: 'ShippingDetailModel', id: number, phone: string, email: string, loadingDock: boolean, is501c3: boolean, contactInfo: string, rank?: string | null } | null, officeUse?: { __typename: 'OfficeUseModel', id: number, freightDelivery: boolean, feedbackReceived: boolean, feedbackFormRequested: boolean, category: boolean, monitorTracking: boolean, previous: boolean, moreInfo: boolean, shippingCarrier?: string | null, status?: string | null, trackingInfo?: string | null, usps: boolean, validateShippingAddress?: boolean | null, upsLocation?: string | null, wsGmGs: boolean } | null }> } };

export type RequestByIdQueryVariables = Exact<{
  requestId: Scalars['Float']['input'];
}>;
export type CommentsByRequestIdQueryVariables = Exact<{
  requestId: Scalars['Float']['input'];
}>;


export type RequestByIdQuery = { __typename: 'Query', Request: { __typename: 'RequestResponse', message: string, status: boolean, data?: { __typename: 'RequestModel', id: number, resourceUse?: string | null, userId?: number | null, updateTime: any, status: string, createTime: any, shippedTime?: any | null, requestTime?: any | null, officeUse?: { __typename: 'OfficeUseModel', id: number, freightDelivery: boolean, feedbackReceived: boolean, feedbackFormRequested: boolean, category: boolean, monitorTracking: boolean, previous: boolean, moreInfo: boolean, shippingCarrier?: string | null, status?: string | null, trackingInfo?: string | null, usps: boolean, validateShippingAddress?: boolean | null, upsLocation?: string | null, wsGmGs: boolean } | null, shippingDetail?: { __typename: 'ShippingDetailModel', id: number, phone: string, email: string, loadingDock: boolean, is501c3: boolean, contactInfo: string, rank?: string | null } | null, shippingLocation?: { __typename: 'ShippingAddressModel', id: number, organization: string, title?: string | null, firstName: string, lastName: string, address1: string, address2: string, city: string, state: string, zipCode: string } | null, signature?: { __typename: 'SignatureModel', id: number, sign: string } | null, user?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any, organizationInfo?: { __typename: 'OrganizationInfoModel', id: number, ministryCategory?: string | null, originalMinistryCategory?: string | null, orgName?: string | null, isManagedByOrg?: boolean | null, affiliation?: string | null, is501c3?: boolean | null, hasWebsite?: string | null, ministryDetails?: string | null, differentOrgName?: string | null, overseeMinistry?: string | null, employerId?: string | null } | null } | null, comments?: Array<{ __typename: 'CommentModel', comment: string, createTime?: any | null, id: number, updateTime?: any | null, user?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any } | null }> | null } | null } };
export type CommentsByRequestIdQuery = { __typename: 'Query', GetCommentsByRequestId: { __typename: 'GetCommentsResponse', total: number, items: Array<{ __typename: 'CommentModel', comment: string, createTime?: any | null, id: number, updateTime?: any | null, user?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any } | null }> | null } | null };

export type RequestQueryVariables = Exact<{
  requestId: Scalars['Float']['input'];
}>;


export type RequestQuery = { __typename: 'Query', Request: { __typename: 'RequestResponse', message: string, status: boolean, data?: { __typename: 'RequestModel', id: number, userId?: number | null, updateTime: any, status: string, createTime: any, shippedTime?: any | null, requestTime?: any | null, officeUse?: { __typename: 'OfficeUseModel', category: boolean, feedbackFormRequested: boolean, feedbackReceived: boolean, freightDelivery: boolean, id: number, monitorTracking: boolean, moreInfo: boolean, previous: boolean, shippingCarrier?: string | null, status?: string | null, trackingInfo?: string | null, upsLocation?: string | null, usps: boolean, validateShippingAddress?: boolean | null, wsGmGs: boolean } | null, shippingLocation?: { __typename: 'ShippingAddressModel', id: number, organization: string, title?: string | null, firstName: string, lastName: string, address1: string, address2: string, city: string, state: string, zipCode: string } | null, shippingDetail?: { __typename: 'ShippingDetailModel', id: number, phone: string, email: string, loadingDock: boolean, is501c3: boolean, contactInfo: string, rank?: string | null } | null, signature?: { __typename: 'SignatureModel', id: number, sign: string } | null, user?: { __typename: 'UserModel', email: string, firstName?: string | null, id: number, isActive: boolean, status: string, isSuperuser: boolean, lastName?: string | null, phone: string, roleId?: number | null, redFlag: boolean, yellowFlag?: boolean | null, autoRedFlag?: boolean | null, autoYellowFlag?: boolean | null, priorApplicationKey?: number | null, ministryName?: string | null, acceptedDate?: any | null, createTime: any, updateTime: any, role?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null } | null } | null } };

export type RequestSelectionsQueryVariables = Exact<{
  requestId: Scalars['Float']['input'];
}>;


export type RequestSelectionsQuery = { __typename: 'Query', RequestSelections: { __typename: 'RequestSelectionsResponse', total: number, items: Array<{ __typename: 'SelectionModel', id: number, createTime: any, cases: number, singles: number, updateTime: any, resourceId: number, resource: { __typename: 'ResourceModel', id: number, imageUrl: string, sku: string, title: string, description?: string | null, caseWeight: number, createTime: any, categoryId: number, exclusiveOffer: boolean, isActive: boolean, isPublished: boolean, quantityInCase: number, sortingOrder: number, updateTime: any } }> } };

export type UserRolesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserRolesQuery = { __typename: 'Query', UserRoles: { __typename: 'UserRolePaginatedResponse', total: number, items: Array<{ __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean }> } };

export type UserRoleQueryVariables = Exact<{
  userroleId: Scalars['Float']['input'];
}>;


export type UserRoleQuery = { __typename: 'Query', UserRole: { __typename: 'UserRoleResponse', message: string, status: boolean, data?: { __typename: 'UserRoleModel', addAdmin: boolean, approveUser: boolean, changePermission: boolean, changeProfile: boolean, changeUsersProfile: boolean, createTime: any, deleteUser: boolean, description: string, editCMS: boolean, editCategory: boolean, editRequest: boolean, editShippedRequest: boolean, editResource: boolean, id: number, isActive: boolean, isDefault: boolean, name: string, updateTime: any, viewCMS: boolean, viewCategory: boolean, viewRequest: boolean, viewResource: boolean } | null } };

export type GetNewsCategoryQueryVariables = Exact<{
  newsCategoryId: Scalars['String']['input'];
}>;


export type GetNewsCategoryQuery = { __typename: 'Query', GetNewsCategory: { __typename: 'NewsCategoryResponse', status: boolean, message: string, data?: { __typename: 'NewsCategoryModel', id: number, headLine?: string | null, sideContent?: string | null, newsCategoryId: string } | null } };

export type PostsInPageQueryVariables = Exact<{
  ministryId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PostsInPageQuery = { __typename: 'Query', Posts: { __typename: 'PostPaginatedResponse', total: number, items: Array<{ __typename: 'PostModel', id: number, isEnabled: boolean, publishedTime: any, title?: string | null, url: string, content?: string | null, ministryId: string }> } };

export type PostsQueryVariables = Exact<{
  ministryId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PostsQuery = { __typename: 'Query', Posts: { __typename: 'PostPaginatedResponse', total: number, items: Array<{ __typename: 'PostModel', id: number, isEnabled: boolean, publishedTime: any, title?: string | null, url: string, content?: string | null, ministryId: string }> } };

export type GetPostsNavigationQueryVariables = Exact<{
  ministryId: Scalars['String']['input'];
}>;


export type GetPostsNavigationQuery = { __typename: 'Query', GetPostNavigation: { __typename: 'StringResponse', data?: string | null, message: string, status: boolean } };

export type PostByIdQueryVariables = Exact<{
  postId: Scalars['Float']['input'];
}>;


export type PostByIdQuery = { __typename: 'Query', Post: { __typename: 'PostResponse', status: boolean, message: string, data?: { __typename: 'PostModel', content?: string | null, id: number, isEnabled: boolean, publishedTime: any, title?: string | null, url: string, ministryId: string } | null } };

export type GetPostByUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type GetPostByUrlQuery = { __typename: 'Query', GetPostByUrl: { __typename: 'PostResponse', message: string, status: boolean, data?: { __typename: 'PostModel', content?: string | null, id: number, isEnabled: boolean, publishedTime: any, title?: string | null, url: string, ministryId: string } | null } };

export type MinistriesQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  isNav?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['Float']['input']>;
  Search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MinistriesQuery = { __typename: 'Query', Ministries: { __typename: 'MinistryPaginatedResponse', total: number, items: Array<{ __typename: 'MinistryModel', id: number, name: string, order: number, pageTitle?: string | null, parent?: { __typename: 'MinistryModel', name: string } | null }> } };
export type MinistryGalleriesQuery = { __typename: 'Query', MinistryGalleries: { __typename: 'MinistryPaginatedResponse', total: number, items: Array<{ __typename: 'MinistryModel', id: number, name: string, order: number, pageTitle?: string | null, parent?: { __typename: 'MinistryModel', name: string } | null }> } };

export type MinistriesDropDownItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type MinistriesDropDownItemsQuery = { __typename: 'Query', Ministries: { __typename: 'MinistryPaginatedResponse', items: Array<{ __typename: 'MinistryModel', id: number, name: string, url?: string | null, summary?: string | null }> } };

export type MinistryByIdQueryVariables = Exact<{
  ministryId: Scalars['Float']['input'];
}>;

export type ExclusionGroupByIdQueryVariables = Exact<{
  exclusionGroupId: Scalars['Float']['input'];
}>;

export type MinistryByIdQuery = { __typename: 'Query', Ministry: { __typename: 'MinistryResponse', message: string, status: boolean, data?: { __typename: 'MinistryModel', content?: string | null, createTime: any, headLine?: string | null, id: number, isNav: boolean, isGallery: true, name: string, order: number, pageTitle?: string | null, parentId?: number | null, sideContent?: string | null, updateTime: any, url?: string | null, sideImage?: string | null, summary?: string | null, btnLabel?: string | null, btnUrl?: string | null, children?: Array<{ __typename: 'MinistryModel', content?: string | null, createTime: any, headLine?: string | null, id: number, isNav: boolean, isGallery: boolean, name: string, order: number, pageTitle?: string | null, parentId?: number | null, sideContent?: string | null, updateTime: any, url?: string | null, sideImage?: string | null, summary?: string | null, btnLabel?: string | null, btnUrl?: string | null }> | null, resources?: Array<{ __typename: 'ResourceModel', id: number }> | null } | null } };

export type MinistryByUrlQueryVariables = Exact<{
  ministryUrl: Scalars['String']['input'];
}>;


export type MinistryByUrlQuery = { __typename: 'Query', MinistryByUrl: { __typename: 'MinistryResponse', message: string, status: boolean, data?: { __typename: 'MinistryModel', content?: string | null, createTime: any, headLine?: string | null, id: number, isNav: boolean, name: string, order: number, pageTitle?: string | null, parentId?: number | null, sideContent?: string | null, updateTime: any, url?: string | null, sideImage?: string | null, summary?: string | null, btnLabel?: string | null, btnUrl?: string | null, children?: Array<{ __typename: 'MinistryModel', url?: string | null, name: string, pageTitle?: string | null }> | null, resources?: Array<{ __typename: 'ResourceModel', id: number, imageUrl: string, title: string, description?: string | null, author: string, subTitle: string }> | null, parent?: { __typename: 'MinistryModel', sideImage?: string | null } | null, testimonials?: Array<{ __typename: 'TestimonialModel', summary?: string | null, name: string, url: string }> | null } | null } };

export type TestimonialByUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type TestimonialByUrlQuery = { __typename: 'Query', TestimonialByUrl: { __typename: 'TestimonialResponse', status: boolean, message: string, data?: { __typename: 'TestimonialModel', content?: string | null, createTime: any, headLine?: string | null, id?: number | null, name: string, order: number, pageTitle: string, ministryId?: number | null, sideContent?: string | null, summary?: string | null, updateTime: any, url: string, blocks?: Array<{ __typename: 'BlockModel', content?: string | null, id?: number | null, order: number, sideContent?: string | null }> | null } | null } };

export type TestimonialsQueryVariables = Exact<{ [key: string]: never; }>;


export type TestimonialsQuery = { __typename: 'Query', Testimonials: { __typename: 'TestimonialPaginatedResponse', total: number, items: Array<{ __typename: 'TestimonialModel', content?: string | null, createTime: any, headLine?: string | null, id?: number | null, name: string, summary?: string | null, order: number, pageTitle: string, ministryId?: number | null, sideContent?: string | null, updateTime: any, url: string, blocks?: Array<{ __typename: 'BlockModel', content?: string | null, id?: number | null, order: number, sideContent?: string | null }> | null }> } };

export type TestimonialQueryVariables = Exact<{
  testimonialId: Scalars['Float']['input'];
}>;


export type TestimonialQuery = { __typename: 'Query', Testimonial: { __typename: 'TestimonialResponse', status: boolean, message: string, data?: { __typename: 'TestimonialModel', content?: string | null, createTime: any, headLine?: string | null, id?: number | null, name: string, order: number, pageTitle: string, ministryId?: number | null, sideContent?: string | null, summary?: string | null, updateTime: any, url: string, blocks?: Array<{ __typename: 'BlockModel', content?: string | null, id?: number | null, order: number, sideContent?: string | null }> | null } | null } };

export type RequestReportQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type RequestReportQuery = { __typename: 'Query', RequestReport: { __typename: 'StringResponse', message: string, status: boolean, data?: string | null } };

export type RequestShipReportQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  sort?: InputMaybe<ReportSortField>;
  sortDirection?: InputMaybe<SortDirectionField>;
}>;


export type RequestShipReportQuery = { __typename: 'Query', RequestShipReport: { __typename: 'StringResponse', message: string, status: boolean, data?: string | null } };

export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on UserModel {
  email
  firstName
  id
  isActive
  status
  isSuperuser
  lastName
  phone
  roleId
  redFlag
  yellowFlag
  autoRedFlag
  autoYellowFlag
  priorApplicationKey
  ministryName
  acceptedDate
  createTime
  updateTime
}
    `;
export const UserRoleFragmentFragmentDoc = gql`
    fragment UserRoleFragment on UserRoleModel {
  addAdmin
  approveUser
  changePermission
  changeProfile
  changeUsersProfile
  createTime
  deleteUser
  description
  editCMS
  editCategory
  editRequest
  editShippedRequest
  editResource
  id
  isActive
  isDefault
  name
  updateTime
  viewCMS
  viewCategory
  viewRequest
  viewResource
}
    `;
export const ShippingLocationFragmentFragmentDoc = gql`
    fragment ShippingLocationFragment on ShippingAddressModel {
  id
  organization
  title
  firstName
  lastName
  address1
  address2
  city
  state
  zipCode
}
    `;


export const SelectionFragmentFragmentDoc = gql`
  fragment SelectionFragment on SelectionModel {
    id
    cases
    singles
    resourceId
    createTime
    updateTime
  }
`;


export const ShippingDetailFragmentFragmentDoc = gql`
    fragment ShippingDetailFragment on ShippingDetailModel {
  id
  phone
  email
  loadingDock
  is501c3
  contactInfo
  rank
  resourceUse
}
    `;
export const OrganizationInfoFragmentFragmentDoc = gql`
    fragment OrganizationInfoFragment on OrganizationInfoModel {
  id
  ministryCategory
  originalMinistryCategory
  orgName
  isManagedByOrg
  affiliation
  is501c3
  hasWebsite
  ministryDetails
  differentOrgName
  overseeMinistry
  employerId
}
    `;
export const ResourceDistributionFragmentFragmentDoc = gql`
    fragment ResourceDistributionFragment on ResourceDistributionModel {
  id
  requestForEvent
  purpose
  howDistributed
  eventDate
  expectToServe
  costToAttendee
  heldToDistribute
  publicNotice
  howManyPeople
}
    `;
export const UserServeFragmentFragmentDoc = gql`
    fragment UserServeFragment on UserServeModel {
  id
  appliedBefore
  howHearUs
  agreeTerm
  approximateTime
}
    `;
export const OfficeUseFragmentFragmentDoc = gql`
    fragment OfficeUseFragment on OfficeUseModel {
  id
  freightDelivery
  feedbackReceived
  feedbackFormRequested
  category
  monitorTracking
  previous
  moreInfo
  shippingCarrier
  status
  trackingInfo
  usps
  validateShippingAddress
  upsLocation
  wsGmGs
}
    `;
export const ResourceCategoryFragmentDoc = gql`
    fragment ResourceCategory on ResourceCategoryModel {
  id
  title
  description
  sortingOrder
  updateTime
  isActive
  createTime
}
    `;
export const ResourceFragmentFragmentDoc = gql`
    fragment ResourceFragment on ResourceModel {
  updateTime
  title
  subTitle
  author
  isPublished
  sortingOrder
  quantityInCase
  isActive
  imageUrl
  id
  exclusiveOffer
  description
  createTime
  categoryId
  sku
  caseWeight
  isDeleted
  inventory
  lastYearShipped
}
    `;
export const ExclusionGroupFragmentFragmentDoc = gql`
    fragment ExclusionGroupFragment on ExclusionGroupModel {
  name
  isActive
  id
  description
  isDeleted
  endDateDays
  loginFromEmail
  loginBccEmails
  loginSubjectEmail
  loginTitleEmail
  loginEmailContent
  loginEmailLongTermContent
}
    `;
export const PageFragmentFragmentDoc = gql`
    fragment PageFragment on PagesModel {
  content
  sideContent
  headLine
  dropMenu
  id
  isNav
  isHome
  isShow
  name
  pageTitle
  parentId
  createTime
  updateTime
  url
  order
  formId
  isApplicationForm
  isApplicationLogin
  isFeedbackForm
  adminEmail
  fromEmail
  bccEmails
  emailHeader
  emailBottom
  loginFromEmail
  loginBccEmails
  loginSubjectEmail
  loginTitleEmail
  loginEmailContent
  loginEmailLongTermContent
  loginLinkEmail
  feedbackFormFromEmail
  feedbackFormBccEmails
  feedbackFormSubjectEmail
  feedbackFormTitleEmail
  feedbackFormEmailContent
  feedbackFormLinkEmail
  isRequestEmail
  requestFromEmail
  requestBccEmails
  requestSubjectEmail
  requestTitleEmail
  requestEmailContent
  isCloseAppEmail
  closeAppFromEmail
  closeAppBccEmails
  closeAppSubjectEmail
  closeAppTitleEmail
  closeAppEmailContent
}
    `;
export const GalleryResourceFragmentDoc = gql`
    fragment GalleryResourceFragment on GalleryResourceModel {
      title
      description
      imageUrl
      sortingOrder
      ministryId
    }
  `;

export const MinistryFragmentFragmentDoc = gql`
    fragment MinistryFragment on MinistryModel {
  content
  createTime
  headLine
  id
  isNav
  isGallery
  name
  order
  pageTitle
  parentId
  sideContent
  updateTime
  url
  sideImage
  summary
  btnLabel
  btnUrl
}
    `;
export const SignUpDocument = gql`
    mutation SignUp($data: UserSignUpInput!) {
  SignUp(data: $data) {
    data {
      id
      firstName
      lastName
      email
      phone
      isActive
      isSuperuser
      createTime
      updateTime
      role {
        ...UserRoleFragment
      }
    }
    message
    status
  }
}
    ${UserRoleFragmentFragmentDoc}`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

export const ValidateAddressDocument = gql`
    query ValidateAddress($addressLine1: String! $addressLine2: String! $city: String! $state: String! $zip: String!) {
      ValidateAddress(addressLine1: $addressLine1 addressLine2: $addressLine2 city: $city state: $state zip: $zip) {
    data {
      isValid
      type
    }
    message
    status
  }
}`;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  Login(email: $email, password: $password) {
    status
    message
    errorCode
    data {
      accessToken
    }
  }
}
    `;
export const RequestLoginDocument = gql`
    mutation RequestLogin($input: RequestLoginInput!) {
  RequestLogin(input: $input) {
    status
    message
    errorCode
    data
  }
}
    `;
export const RequestLoginDocumentWithToken = gql`
    mutation RequestLoginWithToken($email: String!, $token: String!) {
  RequestLoginWithToken(email: $email, token: $token) {
    status
    message
    errorCode
    data {
      accessToken
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  RequestPasswordReset(email: $email) {
    status
    message
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($password: String!, $token: String!) {
  ResetPassword(password: $password, token: $token) {
    status
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CreateResourceCategoryDocument = gql`
    mutation CreateResourceCategory($category: ResourceCategoryInput!) {
  CreateResourceCategory(category: $category) {
    data {
      ...ResourceCategory
    }
    message
    status
  }
}
    ${ResourceCategoryFragmentDoc}`;
export type CreateResourceCategoryMutationFn = Apollo.MutationFunction<CreateResourceCategoryMutation, CreateResourceCategoryMutationVariables>;

/**
 * __useCreateResourceCategoryMutation__
 *
 * To run a mutation, you first call `useCreateResourceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceCategoryMutation, { data, loading, error }] = useCreateResourceCategoryMutation({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateResourceCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceCategoryMutation, CreateResourceCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceCategoryMutation, CreateResourceCategoryMutationVariables>(CreateResourceCategoryDocument, options);
      }
export type CreateResourceCategoryMutationHookResult = ReturnType<typeof useCreateResourceCategoryMutation>;
export type CreateResourceCategoryMutationResult = Apollo.MutationResult<CreateResourceCategoryMutation>;
export type CreateResourceCategoryMutationOptions = Apollo.BaseMutationOptions<CreateResourceCategoryMutation, CreateResourceCategoryMutationVariables>;
export const UpdateResourceCategoryDocument = gql`
    mutation UpdateResourceCategory($updateResourceCategory: ResourceCategoryUpdateInput!) {
  UpdateResourceCategory(category: $updateResourceCategory) {
    data {
      ...ResourceCategory
    }
    message
    status
  }
}
    ${ResourceCategoryFragmentDoc}`;
export type UpdateResourceCategoryMutationFn = Apollo.MutationFunction<UpdateResourceCategoryMutation, UpdateResourceCategoryMutationVariables>;

/**
 * __useUpdateResourceCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateResourceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceCategoryMutation, { data, loading, error }] = useUpdateResourceCategoryMutation({
 *   variables: {
 *      updateResourceCategory: // value for 'updateResourceCategory'
 *   },
 * });
 */
export function useUpdateResourceCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceCategoryMutation, UpdateResourceCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceCategoryMutation, UpdateResourceCategoryMutationVariables>(UpdateResourceCategoryDocument, options);
      }
export type UpdateResourceCategoryMutationHookResult = ReturnType<typeof useUpdateResourceCategoryMutation>;
export type UpdateResourceCategoryMutationResult = Apollo.MutationResult<UpdateResourceCategoryMutation>;
export type UpdateResourceCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateResourceCategoryMutation, UpdateResourceCategoryMutationVariables>;
export const DeleteResourceCategoryDocument = gql`
    mutation DeleteResourceCategory($categoryId: Float!) {
  DeleteCategory(categoryId: $categoryId) {
    status
    message
  }
}
    `;
export type DeleteResourceCategoryMutationFn = Apollo.MutationFunction<DeleteResourceCategoryMutation, DeleteResourceCategoryMutationVariables>;

/**
 * __useDeleteResourceCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteResourceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceCategoryMutation, { data, loading, error }] = useDeleteResourceCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteResourceCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceCategoryMutation, DeleteResourceCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceCategoryMutation, DeleteResourceCategoryMutationVariables>(DeleteResourceCategoryDocument, options);
      }
export type DeleteResourceCategoryMutationHookResult = ReturnType<typeof useDeleteResourceCategoryMutation>;
export type DeleteResourceCategoryMutationResult = Apollo.MutationResult<DeleteResourceCategoryMutation>;
export type DeleteResourceCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteResourceCategoryMutation, DeleteResourceCategoryMutationVariables>;
export const CreateResourceDocument = gql`
    mutation CreateResource($resource: ResourceInput!) {
  CreateResource(resource: $resource) {
    status
    message
    data {
      ...ResourceFragment
    }
  }
}
    ${ResourceFragmentFragmentDoc}`;
export const CreateExclusionGroupDocument = gql`
    mutation CreateExclusionGroup($exclusionGroup: ExclusionGroupInput!) {
  CreateExclusionGroup(exclusionGroup: $exclusionGroup) {
    status
    message
    data {
      ...ExclusionGroupFragment
    }
  }
}
    ${ExclusionGroupFragmentFragmentDoc}`;
export type CreateResourceMutationFn = Apollo.MutationFunction<CreateResourceMutation, CreateResourceMutationVariables>;

/**
 * __useCreateResourceMutation__
 *
 * To run a mutation, you first call `useCreateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceMutation, { data, loading, error }] = useCreateResourceMutation({
 *   variables: {
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useCreateResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceMutation, CreateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceMutation, CreateResourceMutationVariables>(CreateResourceDocument, options);
      }
export type CreateResourceMutationHookResult = ReturnType<typeof useCreateResourceMutation>;
export type CreateResourceMutationResult = Apollo.MutationResult<CreateResourceMutation>;
export type CreateResourceMutationOptions = Apollo.BaseMutationOptions<CreateResourceMutation, CreateResourceMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($resources: ResourceUpdateInput!) {
  UpdateResource(resources: $resources) {
    data {
      ...ResourceFragment
    }
  }
}
    ${ResourceFragmentFragmentDoc}`;
export const UpdateExclusionGroupDocument = gql`
    mutation UpdateExclusionGroup($exclusionGroup: ExclusionGroupUpdateInput!) {
  UpdateExclusionGroup(exclusionGroup: $exclusionGroup) {
    data {
      ...ExclusionGroupFragment
    }
  }
}
    ${ExclusionGroupFragmentFragmentDoc}`;

export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      resources: // value for 'resources'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const DeleteResourceDocument = gql`
    mutation DeleteResource($resourceId: Float!) {
  DeleteResource(resourceId: $resourceId) {
    message
    status
  }
}
    `;
export const DeleteExclusionGroupDocument = gql`
    mutation DeleteExclusionGroup($exclusionGroupId: Float!) {
  DeleteExclusionGroup(exclusionGroupId: $exclusionGroupId) {
    message
    status
  }
}
    `;
export type DeleteResourceMutationFn = Apollo.MutationFunction<DeleteResourceMutation, DeleteResourceMutationVariables>;

/**
 * __useDeleteResourceMutation__
 *
 * To run a mutation, you first call `useDeleteResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceMutation, { data, loading, error }] = useDeleteResourceMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useDeleteResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResourceMutation, DeleteResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, options);
      }
export type DeleteResourceMutationHookResult = ReturnType<typeof useDeleteResourceMutation>;
export type DeleteResourceMutationResult = Apollo.MutationResult<DeleteResourceMutation>;
export type DeleteResourceMutationOptions = Apollo.BaseMutationOptions<DeleteResourceMutation, DeleteResourceMutationVariables>;
export const CheckoutRequestDocument = gql`
    mutation CheckoutRequest($selections: CheckoutRequestInput!) {
  CheckoutRequest(selections: $selections) {
    data {
      id
      updateTime
      createTime
      status
    }
  }
}
    `;
export type CheckoutRequestMutationFn = Apollo.MutationFunction<CheckoutRequestMutation, CheckoutRequestMutationVariables>;

/**
 * __useCheckoutRequestMutation__
 *
 * To run a mutation, you first call `useCheckoutRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutRequestMutation, { data, loading, error }] = useCheckoutRequestMutation({
 *   variables: {
 *      selections: // value for 'selections'
 *   },
 * });
 */
export function useCheckoutRequestMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutRequestMutation, CheckoutRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutRequestMutation, CheckoutRequestMutationVariables>(CheckoutRequestDocument, options);
      }
export type CheckoutRequestMutationHookResult = ReturnType<typeof useCheckoutRequestMutation>;
export type CheckoutRequestMutationResult = Apollo.MutationResult<CheckoutRequestMutation>;
export type CheckoutRequestMutationOptions = Apollo.BaseMutationOptions<CheckoutRequestMutation, CheckoutRequestMutationVariables>;
export const CreateRequestByAdminDocument = gql`
    mutation CreateRequestByAdmin($request: CreateRequestInput!) {
  CreateRequest(request: $request) {
    status
    message
    data
  }
}
    `;
export type CreateRequestByAdminMutationFn = Apollo.MutationFunction<CreateRequestByAdminMutation, CreateRequestByAdminMutationVariables>;

/**
 * __useCreateRequestByAdminMutation__
 *
 * To run a mutation, you first call `useCreateRequestByAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestByAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestByAdminMutation, { data, loading, error }] = useCreateRequestByAdminMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateRequestByAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequestByAdminMutation, CreateRequestByAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequestByAdminMutation, CreateRequestByAdminMutationVariables>(CreateRequestByAdminDocument, options);
      }
export type CreateRequestByAdminMutationHookResult = ReturnType<typeof useCreateRequestByAdminMutation>;
export type CreateRequestByAdminMutationResult = Apollo.MutationResult<CreateRequestByAdminMutation>;
export type CreateRequestByAdminMutationOptions = Apollo.BaseMutationOptions<CreateRequestByAdminMutation, CreateRequestByAdminMutationVariables>;
export const DeleteRequestDocument = gql`
    mutation DeleteRequest($requestId: Float!) {
  DeleteRequest(requestId: $requestId) {
    status
    message
    data
  }
}
    `;
export type DeleteRequestMutationFn = Apollo.MutationFunction<DeleteRequestMutation, DeleteRequestMutationVariables>;

/**
 * __useDeleteRequestMutation__
 *
 * To run a mutation, you first call `useDeleteRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequestMutation, { data, loading, error }] = useDeleteRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useDeleteRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRequestMutation, DeleteRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRequestMutation, DeleteRequestMutationVariables>(DeleteRequestDocument, options);
      }
export type DeleteRequestMutationHookResult = ReturnType<typeof useDeleteRequestMutation>;
export type DeleteRequestMutationResult = Apollo.MutationResult<DeleteRequestMutation>;
export type DeleteRequestMutationOptions = Apollo.BaseMutationOptions<DeleteRequestMutation, DeleteRequestMutationVariables>;
export const DeleteRequestsDocument = gql`
    mutation DeleteRequests($requestIds: [Float!]!) {
  DeletedRequests(requestIds: $requestIds) {
    message
    status
    data
  }
}
    `;
export type DeleteRequestsMutationFn = Apollo.MutationFunction<DeleteRequestsMutation, DeleteRequestsMutationVariables>;

/**
 * __useDeleteRequestsMutation__
 *
 * To run a mutation, you first call `useDeleteRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequestsMutation, { data, loading, error }] = useDeleteRequestsMutation({
 *   variables: {
 *      requestIds: // value for 'requestIds'
 *   },
 * });
 */
export function useDeleteRequestsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRequestsMutation, DeleteRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRequestsMutation, DeleteRequestsMutationVariables>(DeleteRequestsDocument, options);
      }
export type DeleteRequestsMutationHookResult = ReturnType<typeof useDeleteRequestsMutation>;
export type DeleteRequestsMutationResult = Apollo.MutationResult<DeleteRequestsMutation>;
export type DeleteRequestsMutationOptions = Apollo.BaseMutationOptions<DeleteRequestsMutation, DeleteRequestsMutationVariables>;
export const UpdateRequestDocument = gql`
    mutation UpdateRequest($request: UpdateRequestInput!) {
  UpdateRequest(request: $request) {
    status
    message
  }
}
    `;
export type UpdateRequestMutationFn = Apollo.MutationFunction<UpdateRequestMutation, UpdateRequestMutationVariables>;

/**
 * __useUpdateRequestMutation__
 *
 * To run a mutation, you first call `useUpdateRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestMutation, { data, loading, error }] = useUpdateRequestMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useUpdateRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequestMutation, UpdateRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequestMutation, UpdateRequestMutationVariables>(UpdateRequestDocument, options);
      }
export type UpdateRequestMutationHookResult = ReturnType<typeof useUpdateRequestMutation>;
export type UpdateRequestMutationResult = Apollo.MutationResult<UpdateRequestMutation>;
export type UpdateRequestMutationOptions = Apollo.BaseMutationOptions<UpdateRequestMutation, UpdateRequestMutationVariables>;
export const ShipRequestsDocument = gql`
    mutation ShipRequests($requestIds: [Float!]!) {
  ShipRequests(requestIds: $requestIds) {
    data
    message
    status
  }
}
    `;
export type ShipRequestsMutationFn = Apollo.MutationFunction<ShipRequestsMutation, ShipRequestsMutationVariables>;

/**
 * __useShipRequestsMutation__
 *
 * To run a mutation, you first call `useShipRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShipRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shipRequestsMutation, { data, loading, error }] = useShipRequestsMutation({
 *   variables: {
 *      requestIds: // value for 'requestIds'
 *   },
 * });
 */
export function useShipRequestsMutation(baseOptions?: Apollo.MutationHookOptions<ShipRequestsMutation, ShipRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShipRequestsMutation, ShipRequestsMutationVariables>(ShipRequestsDocument, options);
      }
export type ShipRequestsMutationHookResult = ReturnType<typeof useShipRequestsMutation>;
export type ShipRequestsMutationResult = Apollo.MutationResult<ShipRequestsMutation>;
export type ShipRequestsMutationOptions = Apollo.BaseMutationOptions<ShipRequestsMutation, ShipRequestsMutationVariables>;
export const CreatePageDocument = gql`
    mutation CreatePage($pages: PagesInput!) {
  CreatePage(pages: $pages) {
    data {
      ...PageFragment
      children {
        ...PageFragment
      }
    }
    status
    message
  }
}
    ${PageFragmentFragmentDoc}`;
export type CreatePageMutationFn = Apollo.MutationFunction<CreatePageMutation, CreatePageMutationVariables>;

/**
 * __usePageByIdQuery__
 *
 * To run a query within a React component, call `usePageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageByIdQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useLoginPageQuery(baseOptions: Apollo.QueryHookOptions<PageRequestLoginQuery>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PageRequestLoginQuery>(PageLoginPageDocument, options);
}
export function useCloseAppPageQuery(baseOptions: Apollo.QueryHookOptions<PageCloseAppQuery>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PageCloseAppQuery>(PageCloseAppPageDocument, options);
}
export function useLoginPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageRequestLoginQuery>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PageRequestLoginQuery>(PageLoginPageDocument, options);
}
export type LoginPageQueryHookResult = ReturnType<typeof usePageByIdQuery>;
export type LoginPageLazyQueryHookResult = ReturnType<typeof usePageByIdLazyQuery>;
export type LoginPageQueryResult = Apollo.QueryResult<PageByIdQuery>;
export const PageLoginPageDocument = gql`
  query RequestLoginPage($id: String!) {
    RequestLoginPage(id: $id) {
      message
      status
      data {
        ...PageFragment
      }
    }
  }
  ${PageFragmentFragmentDoc}`;
export const PageCloseAppPageDocument = gql`
  query CloseAppPage($id: String!) {
    CloseAppPage(id: $id) {
      message
      status
      data {
        ...PageFragment
      }
    }
  }
  ${PageFragmentFragmentDoc}`;

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      pages: // value for 'pages'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageDocument, options);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>;
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($updatePagePage: PagesInput!) {
  UpdatePage(page: $updatePagePage) {
    data {
      ...PageFragment
    }
  }
}
    ${PageFragmentFragmentDoc}`;
export type UpdatePageMutationFn = Apollo.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      updatePagePage: // value for 'updatePagePage'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, options);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const DuplicatePageDocument = gql`
    mutation DuplicatePage($pageId: Float!) {
  DuplicatePage(pageId: $pageId) {
    data {
      ...PageFragment
    }
    message
    status
  }
}
    ${PageFragmentFragmentDoc}`;
export type DuplicatePageMutationFn = Apollo.MutationFunction<DuplicatePageMutation, DuplicatePageMutationVariables>;

/**
 * __useDuplicatePageMutation__
 *
 * To run a mutation, you first call `useDuplicatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePageMutation, { data, loading, error }] = useDuplicatePageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDuplicatePageMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePageMutation, DuplicatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePageMutation, DuplicatePageMutationVariables>(DuplicatePageDocument, options);
      }
export type DuplicatePageMutationHookResult = ReturnType<typeof useDuplicatePageMutation>;
export type DuplicatePageMutationResult = Apollo.MutationResult<DuplicatePageMutation>;
export type DuplicatePageMutationOptions = Apollo.BaseMutationOptions<DuplicatePageMutation, DuplicatePageMutationVariables>;
export const DeletePageDocument = gql`
    mutation DeletePage($pageId: Float!) {
  DeletePage(pageId: $pageId) {
    status
    message
  }
}
    `;
export type DeletePageMutationFn = Apollo.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, options);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationResult = Apollo.MutationResult<DeletePageMutation>;
export type DeletePageMutationOptions = Apollo.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const UpdateUserStatusDocument = gql`
    mutation UpdateUserStatus($input: UpdateUserStatusInput!) {
  UpdateUserStatus(input: $input) {
    data {
      ...UserFragment
    }
    message
    status
  }
}
    ${UserFragmentFragmentDoc}`;

export const SendCloseAppEmailDocument = gql`
    mutation SendCloseAppEmail($input: SendCloseAppEmailInput!) {
      SendCloseAppEmail(input: $input) {
    data
    message
    status
  }
}`;
export type UpdateUserStatusMutationFn = Apollo.MutationFunction<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;

/**
 * __useUpdateUserStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStatusMutation, { data, loading, error }] = useUpdateUserStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>(UpdateUserStatusDocument, options);
      }
export type UpdateUserStatusMutationHookResult = ReturnType<typeof useUpdateUserStatusMutation>;
export type UpdateUserStatusMutationResult = Apollo.MutationResult<UpdateUserStatusMutation>;
export type UpdateUserStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;
export const UpdateUsersStatusDocument = gql`
    mutation UpdateUsersStatus($input: UpdateUsersStatusInput!) {
  UpdateUsersStatus(input: $input) {
    message
    status
  }
}
    `;
export type UpdateUsersStatusMutationFn = Apollo.MutationFunction<UpdateUsersStatusMutation, UpdateUsersStatusMutationVariables>;

/**
 * __useUpdateUsersStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUsersStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersStatusMutation, { data, loading, error }] = useUpdateUsersStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUsersStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUsersStatusMutation, UpdateUsersStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUsersStatusMutation, UpdateUsersStatusMutationVariables>(UpdateUsersStatusDocument, options);
      }
export type UpdateUsersStatusMutationHookResult = ReturnType<typeof useUpdateUsersStatusMutation>;
export type UpdateUsersStatusMutationResult = Apollo.MutationResult<UpdateUsersStatusMutation>;
export type UpdateUsersStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUsersStatusMutation, UpdateUsersStatusMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($user: UserUpdateInput!) {
  UpdateUser(user: $user) {
    data {
      ...UserFragment
    }
    message
    status
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: Float!) {
  DeleteUser(id: $id) {
    status
    message
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetPreSignedUrlDocument = gql`
    mutation GetPreSignedUrl($key: PreSignedUrlInput!) {
  GetPreSignedUrl(key: $key) {
    data
    message
    status
  }
}
    `;
export type GetPreSignedUrlMutationFn = Apollo.MutationFunction<GetPreSignedUrlMutation, GetPreSignedUrlMutationVariables>;

/**
 * __useGetPreSignedUrlMutation__
 *
 * To run a mutation, you first call `useGetPreSignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPreSignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPreSignedUrlMutation, { data, loading, error }] = useGetPreSignedUrlMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetPreSignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetPreSignedUrlMutation, GetPreSignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPreSignedUrlMutation, GetPreSignedUrlMutationVariables>(GetPreSignedUrlDocument, options);
      }
export type GetPreSignedUrlMutationHookResult = ReturnType<typeof useGetPreSignedUrlMutation>;
export type GetPreSignedUrlMutationResult = Apollo.MutationResult<GetPreSignedUrlMutation>;
export type GetPreSignedUrlMutationOptions = Apollo.BaseMutationOptions<GetPreSignedUrlMutation, GetPreSignedUrlMutationVariables>;
export const ShippingAddressDocument = gql`
    mutation ShippingAddress($shippingAddress: ShippingAddressInput!) {
  ShippingAddress(shippingAddress: $shippingAddress) {
    data {
      address1
      address2
      city
      firstName
      id
      organization
      lastName
      state
      title
      zipCode
    }
    message
    status
  }
}
    `;
export type ShippingAddressMutationFn = Apollo.MutationFunction<ShippingAddressMutation, ShippingAddressMutationVariables>;

/**
 * __useShippingAddressMutation__
 *
 * To run a mutation, you first call `useShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shippingAddressMutation, { data, loading, error }] = useShippingAddressMutation({
 *   variables: {
 *      shippingAddress: // value for 'shippingAddress'
 *   },
 * });
 */
export function useShippingAddressMutation(baseOptions?: Apollo.MutationHookOptions<ShippingAddressMutation, ShippingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShippingAddressMutation, ShippingAddressMutationVariables>(ShippingAddressDocument, options);
      }
export type ShippingAddressMutationHookResult = ReturnType<typeof useShippingAddressMutation>;
export type ShippingAddressMutationResult = Apollo.MutationResult<ShippingAddressMutation>;
export type ShippingAddressMutationOptions = Apollo.BaseMutationOptions<ShippingAddressMutation, ShippingAddressMutationVariables>;
export const ShippingDetailDocument = gql`
    mutation ShippingDetail($shippingDetail: ShippingDetailInput!) {
  ShippingDetail(shippingDetail: $shippingDetail) {
    data {
      phone
      loadingDock
      id
      email
      contactInfo
      rank
    }
    message
    status
  }
}
    `;
export type ShippingDetailMutationFn = Apollo.MutationFunction<ShippingDetailMutation, ShippingDetailMutationVariables>;

/**
 * __useShippingDetailMutation__
 *
 * To run a mutation, you first call `useShippingDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShippingDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shippingDetailMutation, { data, loading, error }] = useShippingDetailMutation({
 *   variables: {
 *      shippingDetail: // value for 'shippingDetail'
 *   },
 * });
 */
export function useShippingDetailMutation(baseOptions?: Apollo.MutationHookOptions<ShippingDetailMutation, ShippingDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShippingDetailMutation, ShippingDetailMutationVariables>(ShippingDetailDocument, options);
      }
export type ShippingDetailMutationHookResult = ReturnType<typeof useShippingDetailMutation>;
export type ShippingDetailMutationResult = Apollo.MutationResult<ShippingDetailMutation>;
export type ShippingDetailMutationOptions = Apollo.BaseMutationOptions<ShippingDetailMutation, ShippingDetailMutationVariables>;
export const SignatureDocument = gql`
    mutation Signature($sign: SignatureInput!) {
  Signature(sign: $sign) {
    data {
      requestId
      sign
    }
    message
    status
  }
}
    `;
export type SignatureMutationFn = Apollo.MutationFunction<SignatureMutation, SignatureMutationVariables>;

/**
 * __useSignatureMutation__
 *
 * To run a mutation, you first call `useSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signatureMutation, { data, loading, error }] = useSignatureMutation({
 *   variables: {
 *      sign: // value for 'sign'
 *   },
 * });
 */
export function useSignatureMutation(baseOptions?: Apollo.MutationHookOptions<SignatureMutation, SignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignatureMutation, SignatureMutationVariables>(SignatureDocument, options);
      }
export type SignatureMutationHookResult = ReturnType<typeof useSignatureMutation>;
export type SignatureMutationResult = Apollo.MutationResult<SignatureMutation>;
export type SignatureMutationOptions = Apollo.BaseMutationOptions<SignatureMutation, SignatureMutationVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($forms: FormsInput!) {
  CreateForm(Forms: $forms) {
    data {
      id
      name
      content
      adminEmail
      createTime
      updateTime
    }
    message
    status
  }
}
    `;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      forms: // value for 'forms'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const UpdateFormDocument = gql`
    mutation UpdateForm($form: FormsInput!) {
  UpdateForm(Form: $form) {
    data {
      id
      name
      content
      createTime
      updateTime
    }
    status
    message
  }
}
    `;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, options);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const DuplicateFormDocument = gql`
    mutation DuplicateForm($formId: Float!) {
  DuplicateForm(formId: $formId) {
    data {
      id
      name
      content
      createTime
      updateTime
    }
    message
    status
  }
}
    `;
export type DuplicateFormMutationFn = Apollo.MutationFunction<DuplicateFormMutation, DuplicateFormMutationVariables>;

/**
 * __useDuplicateFormMutation__
 *
 * To run a mutation, you first call `useDuplicateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateFormMutation, { data, loading, error }] = useDuplicateFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDuplicateFormMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateFormMutation, DuplicateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateFormMutation, DuplicateFormMutationVariables>(DuplicateFormDocument, options);
      }
export type DuplicateFormMutationHookResult = ReturnType<typeof useDuplicateFormMutation>;
export type DuplicateFormMutationResult = Apollo.MutationResult<DuplicateFormMutation>;
export type DuplicateFormMutationOptions = Apollo.BaseMutationOptions<DuplicateFormMutation, DuplicateFormMutationVariables>;
export const DeleteFormDocument = gql`
    mutation DeleteForm($formId: Float!) {
  DeleteForm(formId: $formId) {
    message
    status
  }
}
    `;
export type DeleteFormMutationFn = Apollo.MutationFunction<DeleteFormMutation, DeleteFormMutationVariables>;

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormMutation, { data, loading, error }] = useDeleteFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDeleteFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormMutation, DeleteFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormMutation, DeleteFormMutationVariables>(DeleteFormDocument, options);
      }
export type DeleteFormMutationHookResult = ReturnType<typeof useDeleteFormMutation>;
export type DeleteFormMutationResult = Apollo.MutationResult<DeleteFormMutation>;
export type DeleteFormMutationOptions = Apollo.BaseMutationOptions<DeleteFormMutation, DeleteFormMutationVariables>;
export const SubmitFormDocument = gql`
    mutation SubmitForm($forms: FormSubmissionInput!, $requestId: String!) {
  SubmitForm(Forms: $forms, requestId: $requestId) {
    status
    message
    data {
      id
      content
      formId
    }
  }
}
    `;
export type SubmitFormMutationFn = Apollo.MutationFunction<SubmitFormMutation, SubmitFormMutationVariables>;

/**
 * __useSubmitFormMutation__
 *
 * To run a mutation, you first call `useSubmitFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormMutation, { data, loading, error }] = useSubmitFormMutation({
 *   variables: {
 *      forms: // value for 'forms'
 *   },
 * });
 */
export function useSubmitFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFormMutation, SubmitFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFormMutation, SubmitFormMutationVariables>(SubmitFormDocument, options);
      }
export type SubmitFormMutationHookResult = ReturnType<typeof useSubmitFormMutation>;
export type SubmitFormMutationResult = Apollo.MutationResult<SubmitFormMutation>;
export type SubmitFormMutationOptions = Apollo.BaseMutationOptions<SubmitFormMutation, SubmitFormMutationVariables>;
export const UpdateShippingLocationDocument = gql`
    mutation UpdateShippingLocation($shippingLocation: UpdateShippingAddressInput!) {
  UpdateShippingLocation(shippingLocation: $shippingLocation) {
    status
    message
    data {
      firstName
      city
      address2
      address1
      id
      lastName
      organization
      state
      title
      zipCode
    }
  }
}
    `;
export type UpdateShippingLocationMutationFn = Apollo.MutationFunction<UpdateShippingLocationMutation, UpdateShippingLocationMutationVariables>;

/**
 * __useUpdateShippingLocationMutation__
 *
 * To run a mutation, you first call `useUpdateShippingLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingLocationMutation, { data, loading, error }] = useUpdateShippingLocationMutation({
 *   variables: {
 *      shippingLocation: // value for 'shippingLocation'
 *   },
 * });
 */
export function useUpdateShippingLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingLocationMutation, UpdateShippingLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingLocationMutation, UpdateShippingLocationMutationVariables>(UpdateShippingLocationDocument, options);
      }
export type UpdateShippingLocationMutationHookResult = ReturnType<typeof useUpdateShippingLocationMutation>;
export type UpdateShippingLocationMutationResult = Apollo.MutationResult<UpdateShippingLocationMutation>;
export type UpdateShippingLocationMutationOptions = Apollo.BaseMutationOptions<UpdateShippingLocationMutation, UpdateShippingLocationMutationVariables>;
export const UpdateShippingDetailDocument = gql`
    mutation UpdateShippingDetail($shippingDetail: UpdateShippingDetailInput!) {
  UpdateShippingDetail(shippingDetail: $shippingDetail) {
    message
    status
    data {
      contactInfo
      email
      loadingDock
      phone
      id
    }
  }
}
    `;
export type UpdateShippingDetailMutationFn = Apollo.MutationFunction<UpdateShippingDetailMutation, UpdateShippingDetailMutationVariables>;

/**
 * __useUpdateShippingDetailMutation__
 *
 * To run a mutation, you first call `useUpdateShippingDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShippingDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShippingDetailMutation, { data, loading, error }] = useUpdateShippingDetailMutation({
 *   variables: {
 *      shippingDetail: // value for 'shippingDetail'
 *   },
 * });
 */
export function useUpdateShippingDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShippingDetailMutation, UpdateShippingDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShippingDetailMutation, UpdateShippingDetailMutationVariables>(UpdateShippingDetailDocument, options);
      }
export type UpdateShippingDetailMutationHookResult = ReturnType<typeof useUpdateShippingDetailMutation>;
export type UpdateShippingDetailMutationResult = Apollo.MutationResult<UpdateShippingDetailMutation>;
export type UpdateShippingDetailMutationOptions = Apollo.BaseMutationOptions<UpdateShippingDetailMutation, UpdateShippingDetailMutationVariables>;
export const UpdateOfficeUseDocument = gql`
    mutation UpdateOfficeUse($officeUse: OfficeUseInput!) {
  UpdateOfficeUse(officeUse: $officeUse) {
    message
    status
    data {
      category
      feedbackFormRequested
      freightDelivery
      id
      feedbackReceived
      monitorTracking
      moreInfo
      previous
      shippingCarrier
      status
      trackingInfo
      upsLocation
      usps
      validateShippingAddress
      wsGmGs
    }
  }
}
    `;
export type UpdateOfficeUseMutationFn = Apollo.MutationFunction<UpdateOfficeUseMutation, UpdateOfficeUseMutationVariables>;

/**
 * __useUpdateOfficeUseMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeUseMutation, { data, loading, error }] = useUpdateOfficeUseMutation({
 *   variables: {
 *      officeUse: // value for 'officeUse'
 *   },
 * });
 */
export function useUpdateOfficeUseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfficeUseMutation, UpdateOfficeUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfficeUseMutation, UpdateOfficeUseMutationVariables>(UpdateOfficeUseDocument, options);
      }
export type UpdateOfficeUseMutationHookResult = ReturnType<typeof useUpdateOfficeUseMutation>;
export type UpdateOfficeUseMutationResult = Apollo.MutationResult<UpdateOfficeUseMutation>;
export type UpdateOfficeUseMutationOptions = Apollo.BaseMutationOptions<UpdateOfficeUseMutation, UpdateOfficeUseMutationVariables>;
export const AddSelectionDocument = gql`
    mutation AddSelection($selection: AddSelectionInput!) {
  AddSelection(selection: $selection) {
    message
    status
    data {
      id
    }
  }
}
    `;
export type AddSelectionMutationFn = Apollo.MutationFunction<AddSelectionMutation, AddSelectionMutationVariables>;


export const AddSelectionsDocument = gql`
    mutation AddSelections($selections: [AddSelectionInput!]!) {
    AddSelections(selections: $selections) {
      message
      status
      data {
        id
      }
    }
}
    `;

/**
 * __useAddSelectionMutation__
 *
 * To run a mutation, you first call `useAddSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSelectionMutation, { data, loading, error }] = useAddSelectionMutation({
 *   variables: {
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useAddSelectionMutation(baseOptions?: Apollo.MutationHookOptions<AddSelectionMutation, AddSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSelectionMutation, AddSelectionMutationVariables>(AddSelectionDocument, options);
      }
export type AddSelectionMutationHookResult = ReturnType<typeof useAddSelectionMutation>;
export type AddSelectionMutationResult = Apollo.MutationResult<AddSelectionMutation>;
export type AddSelectionMutationOptions = Apollo.BaseMutationOptions<AddSelectionMutation, AddSelectionMutationVariables>;
export const UpdateSelectionDocument = gql`
    mutation UpdateSelection($selection: SelectionInput!) {
  UpdateSelection(selection: $selection) {
    data {
      cases
      createTime
      id
      resourceId
      singles
      updateTime
      resource {
        caseWeight
        categoryId
        createTime
        description
        exclusiveOffer
        id
        imageUrl
        isActive
        isPublished
        quantityInCase
        sku
        sortingOrder
        title
        updateTime
      }
    }
    message
    status
  }
}
    `;
export type UpdateSelectionMutationFn = Apollo.MutationFunction<UpdateSelectionMutation, UpdateSelectionMutationVariables>;


export const UpdateSelectionsDocument = gql`
    mutation UpdateSelections($selections: [SelectionInput!]!) {
    UpdateSelections(selections: $selections) {
      data {
        cases
        createTime
        id
        resourceId
        singles
        updateTime
        resource {
          caseWeight
          categoryId
          createTime
          description
          exclusiveOffer
          id
          imageUrl
          isActive
          isPublished
          quantityInCase
          sku
          sortingOrder
          title
          updateTime
        }
      }
      message
      status
    }
}
    `;
/**
 * __useUpdateSelectionMutation__
 *
 * To run a mutation, you first call `useUpdateSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelectionMutation, { data, loading, error }] = useUpdateSelectionMutation({
 *   variables: {
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useUpdateSelectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSelectionMutation, UpdateSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSelectionMutation, UpdateSelectionMutationVariables>(UpdateSelectionDocument, options);
      }
export type UpdateSelectionMutationHookResult = ReturnType<typeof useUpdateSelectionMutation>;
export type UpdateSelectionMutationResult = Apollo.MutationResult<UpdateSelectionMutation>;
export type UpdateSelectionMutationOptions = Apollo.BaseMutationOptions<UpdateSelectionMutation, UpdateSelectionMutationVariables>;
export const DeleteSelectionDocument = gql`
    mutation DeleteSelection($selectionId: Float!) {
  DeleteSelection(selectionId: $selectionId) {
    data
    message
    status
  }
}
    `;
export type DeleteSelectionMutationFn = Apollo.MutationFunction<DeleteSelectionMutation, DeleteSelectionMutationVariables>;

/**
 * __useDeleteSelectionMutation__
 *
 * To run a mutation, you first call `useDeleteSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSelectionMutation, { data, loading, error }] = useDeleteSelectionMutation({
 *   variables: {
 *      selectionId: // value for 'selectionId'
 *   },
 * });
 */
export function useDeleteSelectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSelectionMutation, DeleteSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSelectionMutation, DeleteSelectionMutationVariables>(DeleteSelectionDocument, options);
      }
export type DeleteSelectionMutationHookResult = ReturnType<typeof useDeleteSelectionMutation>;
export type DeleteSelectionMutationResult = Apollo.MutationResult<DeleteSelectionMutation>;
export type DeleteSelectionMutationOptions = Apollo.BaseMutationOptions<DeleteSelectionMutation, DeleteSelectionMutationVariables>;
export const CreateUserRoleDocument = gql`
    mutation CreateUserRole($input: UserRoleInput!) {
  CreateUserRole(input: $input) {
    data {
      addAdmin
      approveUser
      changePermission
      changeProfile
      changeUsersProfile
      createTime
      deleteUser
      description
      editCMS
      editCategory
      editRequest
      editResource
      id
      isActive
      isDefault
      name
      updateTime
      viewCMS
      viewCategory
      viewRequest
      viewResource
    }
    message
    status
  }
}
    `;
export type CreateUserRoleMutationFn = Apollo.MutationFunction<CreateUserRoleMutation, CreateUserRoleMutationVariables>;

/**
 * __useCreateUserRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserRoleMutation, { data, loading, error }] = useCreateUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserRoleMutation, CreateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserRoleMutation, CreateUserRoleMutationVariables>(CreateUserRoleDocument, options);
      }
export type CreateUserRoleMutationHookResult = ReturnType<typeof useCreateUserRoleMutation>;
export type CreateUserRoleMutationResult = Apollo.MutationResult<CreateUserRoleMutation>;
export type CreateUserRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserRoleMutation, CreateUserRoleMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($input: UserRoleInput!) {
  UpdateUserRole(input: $input) {
    message
    status
    data {
      addAdmin
      approveUser
      changePermission
      changeProfile
      changeUsersProfile
      createTime
      deleteUser
      description
      editCMS
      editCategory
      editRequest
      id
      editResource
      isActive
      isDefault
      name
      updateTime
      viewCMS
      viewCategory
      viewRequest
      viewResource
    }
  }
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const DeleteUserRoleDocument = gql`
    mutation DeleteUserRole($roleId: Float!) {
  DeleteUserRole(roleId: $roleId) {
    status
    message
  }
}
    `;
export type DeleteUserRoleMutationFn = Apollo.MutationFunction<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>;

/**
 * __useDeleteUserRoleMutation__
 *
 * To run a mutation, you first call `useDeleteUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRoleMutation, { data, loading, error }] = useDeleteUserRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>(DeleteUserRoleDocument, options);
      }
export type DeleteUserRoleMutationHookResult = ReturnType<typeof useDeleteUserRoleMutation>;
export type DeleteUserRoleMutationResult = Apollo.MutationResult<DeleteUserRoleMutation>;
export type DeleteUserRoleMutationOptions = Apollo.BaseMutationOptions<DeleteUserRoleMutation, DeleteUserRoleMutationVariables>;
export const ExportRequestsDocument = gql`
    mutation ExportRequests($requestIds: [Float!]!) {
  ExportRequests(requestIds: $requestIds)
}
    `;
export type ExportRequestsMutationFn = Apollo.MutationFunction<ExportRequestsMutation, ExportRequestsMutationVariables>;

/**
 * __useExportRequestsMutation__
 *
 * To run a mutation, you first call `useExportRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportRequestsMutation, { data, loading, error }] = useExportRequestsMutation({
 *   variables: {
 *      requestIds: // value for 'requestIds'
 *   },
 * });
 */
export function useExportRequestsMutation(baseOptions?: Apollo.MutationHookOptions<ExportRequestsMutation, ExportRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportRequestsMutation, ExportRequestsMutationVariables>(ExportRequestsDocument, options);
      }
export type ExportRequestsMutationHookResult = ReturnType<typeof useExportRequestsMutation>;
export type ExportRequestsMutationResult = Apollo.MutationResult<ExportRequestsMutation>;
export type ExportRequestsMutationOptions = Apollo.BaseMutationOptions<ExportRequestsMutation, ExportRequestsMutationVariables>;
export const PrintRequestsDocument = gql`
    mutation PrintRequests($requestIds: [Float!]!, $timeZone: String!) {
  PrintRequests(requestIds: $requestIds, timeZone: $timeZone)
}
    `;
export type PrintRequestsMutationFn = Apollo.MutationFunction<PrintRequestsMutation, PrintRequestsMutationVariables>;

/**
 * __usePrintRequestsMutation__
 *
 * To run a mutation, you first call `usePrintRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printRequestsMutation, { data, loading, error }] = usePrintRequestsMutation({
 *   variables: {
 *      requestIds: // value for 'requestIds'
 *   },
 * });
 */
export function usePrintRequestsMutation(baseOptions?: Apollo.MutationHookOptions<PrintRequestsMutation, PrintRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintRequestsMutation, PrintRequestsMutationVariables>(PrintRequestsDocument, options);
      }
export type PrintRequestsMutationHookResult = ReturnType<typeof usePrintRequestsMutation>;
export type PrintRequestsMutationResult = Apollo.MutationResult<PrintRequestsMutation>;
export type PrintRequestsMutationOptions = Apollo.BaseMutationOptions<PrintRequestsMutation, PrintRequestsMutationVariables>;
export const PrintRequestFormDocument = gql`
    mutation PrintRequestForm {
  PrintRequestForm
}
    `;
export type PrintRequestFormMutationFn = Apollo.MutationFunction<PrintRequestFormMutation, PrintRequestFormMutationVariables>;

/**
 * __usePrintRequestFormMutation__
 *
 * To run a mutation, you first call `usePrintRequestFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintRequestFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printRequestFormMutation, { data, loading, error }] = usePrintRequestFormMutation({
 *   variables: {
 *   },
 * });
 */
export function usePrintRequestFormMutation(baseOptions?: Apollo.MutationHookOptions<PrintRequestFormMutation, PrintRequestFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintRequestFormMutation, PrintRequestFormMutationVariables>(PrintRequestFormDocument, options);
      }
export type PrintRequestFormMutationHookResult = ReturnType<typeof usePrintRequestFormMutation>;
export type PrintRequestFormMutationResult = Apollo.MutationResult<PrintRequestFormMutation>;
export type PrintRequestFormMutationOptions = Apollo.BaseMutationOptions<PrintRequestFormMutation, PrintRequestFormMutationVariables>;
export const CreateUserShippingLocationDocument = gql`
    mutation CreateUserShippingLocation($data: CreateUserShippingLocationInput!) {
  CreateUserShippingLocation(data: $data) {
    status
    message
    data {
      address1
      address2
      city
      createTime
      firstName
      id
      lastName
      organization
      state
      title
      updateTime
      zipCode
    }
  }
}
    `;
export type CreateUserShippingLocationMutationFn = Apollo.MutationFunction<CreateUserShippingLocationMutation, CreateUserShippingLocationMutationVariables>;

/**
 * __useCreateUserShippingLocationMutation__
 *
 * To run a mutation, you first call `useCreateUserShippingLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserShippingLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserShippingLocationMutation, { data, loading, error }] = useCreateUserShippingLocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserShippingLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserShippingLocationMutation, CreateUserShippingLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserShippingLocationMutation, CreateUserShippingLocationMutationVariables>(CreateUserShippingLocationDocument, options);
      }
export type CreateUserShippingLocationMutationHookResult = ReturnType<typeof useCreateUserShippingLocationMutation>;
export type CreateUserShippingLocationMutationResult = Apollo.MutationResult<CreateUserShippingLocationMutation>;
export type CreateUserShippingLocationMutationOptions = Apollo.BaseMutationOptions<CreateUserShippingLocationMutation, CreateUserShippingLocationMutationVariables>;
export const UpdateUserShippingLocationDocument = gql`
    mutation UpdateUserShippingLocation($shippingLocation: UserShippingAddressInput!) {
  UpdateUserShippingLocation(shippingLocation: $shippingLocation) {
    message
    status
    data {
      address1
      address2
      city
      createTime
      firstName
      id
      lastName
      organization
      state
      title
      updateTime
      zipCode
    }
  }
}
    `;
export type UpdateUserShippingLocationMutationFn = Apollo.MutationFunction<UpdateUserShippingLocationMutation, UpdateUserShippingLocationMutationVariables>;

/**
 * __useUpdateUserShippingLocationMutation__
 *
 * To run a mutation, you first call `useUpdateUserShippingLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserShippingLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserShippingLocationMutation, { data, loading, error }] = useUpdateUserShippingLocationMutation({
 *   variables: {
 *      shippingLocation: // value for 'shippingLocation'
 *   },
 * });
 */
export function useUpdateUserShippingLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserShippingLocationMutation, UpdateUserShippingLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserShippingLocationMutation, UpdateUserShippingLocationMutationVariables>(UpdateUserShippingLocationDocument, options);
      }
export type UpdateUserShippingLocationMutationHookResult = ReturnType<typeof useUpdateUserShippingLocationMutation>;
export type UpdateUserShippingLocationMutationResult = Apollo.MutationResult<UpdateUserShippingLocationMutation>;
export type UpdateUserShippingLocationMutationOptions = Apollo.BaseMutationOptions<UpdateUserShippingLocationMutation, UpdateUserShippingLocationMutationVariables>;
export const CreateUserShippingDetailDocument = gql`
    mutation CreateUserShippingDetail($data: CreateUserShippingDetailInput!) {
  CreateUserShippingDetail(data: $data) {
    status
    message
    data {
      contactInfo
      createTime
      email
      id
      loadingDock
      phone
      updateTime
    }
  }
}
    `;
export type CreateUserShippingDetailMutationFn = Apollo.MutationFunction<CreateUserShippingDetailMutation, CreateUserShippingDetailMutationVariables>;

/**
 * __useCreateUserShippingDetailMutation__
 *
 * To run a mutation, you first call `useCreateUserShippingDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserShippingDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserShippingDetailMutation, { data, loading, error }] = useCreateUserShippingDetailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserShippingDetailMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserShippingDetailMutation, CreateUserShippingDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserShippingDetailMutation, CreateUserShippingDetailMutationVariables>(CreateUserShippingDetailDocument, options);
      }
export type CreateUserShippingDetailMutationHookResult = ReturnType<typeof useCreateUserShippingDetailMutation>;
export type CreateUserShippingDetailMutationResult = Apollo.MutationResult<CreateUserShippingDetailMutation>;
export type CreateUserShippingDetailMutationOptions = Apollo.BaseMutationOptions<CreateUserShippingDetailMutation, CreateUserShippingDetailMutationVariables>;
export const UpdateUserShippingDetailDocument = gql`
    mutation UpdateUserShippingDetail($shippingDetail: UserShippingDetailInput!) {
  UpdateUserShippingDetail(shippingDetail: $shippingDetail) {
    message
    status
    data {
      contactInfo
      createTime
      email
      id
      loadingDock
      phone
      updateTime
    }
  }
}
    `;
export type UpdateUserShippingDetailMutationFn = Apollo.MutationFunction<UpdateUserShippingDetailMutation, UpdateUserShippingDetailMutationVariables>;

/**
 * __useUpdateUserShippingDetailMutation__
 *
 * To run a mutation, you first call `useUpdateUserShippingDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserShippingDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserShippingDetailMutation, { data, loading, error }] = useUpdateUserShippingDetailMutation({
 *   variables: {
 *      shippingDetail: // value for 'shippingDetail'
 *   },
 * });
 */
export function useUpdateUserShippingDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserShippingDetailMutation, UpdateUserShippingDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserShippingDetailMutation, UpdateUserShippingDetailMutationVariables>(UpdateUserShippingDetailDocument, options);
      }
export type UpdateUserShippingDetailMutationHookResult = ReturnType<typeof useUpdateUserShippingDetailMutation>;
export type UpdateUserShippingDetailMutationResult = Apollo.MutationResult<UpdateUserShippingDetailMutation>;
export type UpdateUserShippingDetailMutationOptions = Apollo.BaseMutationOptions<UpdateUserShippingDetailMutation, UpdateUserShippingDetailMutationVariables>;
export const CreateUserAdditionalInfoDocument = gql`
    mutation CreateUserAdditionalInfo($data: CreateUserAdditionalInfoInput!) {
  CreateUserAdditionalInfo(data: $data) {
    status
    message
    data {
      hearUs
      id
      isOngoingMinistry
      ministryDescription
      ministryDetails
      planToUse
    }
  }
}
    `;
export type CreateUserAdditionalInfoMutationFn = Apollo.MutationFunction<CreateUserAdditionalInfoMutation, CreateUserAdditionalInfoMutationVariables>;

/**
 * __useCreateUserAdditionalInfoMutation__
 *
 * To run a mutation, you first call `useCreateUserAdditionalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAdditionalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAdditionalInfoMutation, { data, loading, error }] = useCreateUserAdditionalInfoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserAdditionalInfoMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserAdditionalInfoMutation, CreateUserAdditionalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserAdditionalInfoMutation, CreateUserAdditionalInfoMutationVariables>(CreateUserAdditionalInfoDocument, options);
      }
export type CreateUserAdditionalInfoMutationHookResult = ReturnType<typeof useCreateUserAdditionalInfoMutation>;
export type CreateUserAdditionalInfoMutationResult = Apollo.MutationResult<CreateUserAdditionalInfoMutation>;
export type CreateUserAdditionalInfoMutationOptions = Apollo.BaseMutationOptions<CreateUserAdditionalInfoMutation, CreateUserAdditionalInfoMutationVariables>;
export const UpdateUserAdditionalInfoDocument = gql`
    mutation UpdateUserAdditionalInfo($additionalInfo: AdditionalInfoInput!) {
  UpdateUserAdditionalInfo(additionalInfo: $additionalInfo) {
    status
    message
    data {
      hearUs
      id
      isOngoingMinistry
      ministryDescription
      ministryDetails
      planToUse
    }
  }
}
    `;
export type UpdateUserAdditionalInfoMutationFn = Apollo.MutationFunction<UpdateUserAdditionalInfoMutation, UpdateUserAdditionalInfoMutationVariables>;

/**
 * __useUpdateUserAdditionalInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserAdditionalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAdditionalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAdditionalInfoMutation, { data, loading, error }] = useUpdateUserAdditionalInfoMutation({
 *   variables: {
 *      additionalInfo: // value for 'additionalInfo'
 *   },
 * });
 */
export function useUpdateUserAdditionalInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAdditionalInfoMutation, UpdateUserAdditionalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAdditionalInfoMutation, UpdateUserAdditionalInfoMutationVariables>(UpdateUserAdditionalInfoDocument, options);
      }
export type UpdateUserAdditionalInfoMutationHookResult = ReturnType<typeof useUpdateUserAdditionalInfoMutation>;
export type UpdateUserAdditionalInfoMutationResult = Apollo.MutationResult<UpdateUserAdditionalInfoMutation>;
export type UpdateUserAdditionalInfoMutationOptions = Apollo.BaseMutationOptions<UpdateUserAdditionalInfoMutation, UpdateUserAdditionalInfoMutationVariables>;
export const AddCommentDocument = gql`
    mutation AddComment($comment: CommentInput!) {
  AddComment(comment: $comment) {
    message
    status
    data {
      comment
      id
      updateTime
      createTime
    }
  }
}
    `;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($comment: CommentInput!) {
  UpdateComment(comment: $comment) {
    data {
      comment
      id
      updateTime
      createTime
    }
    message
    status
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentId: Float!) {
  DeleteComment(commentId: $commentId) {
    message
    status
    data
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteFormSubmissionDocument = gql`
    mutation DeleteFormSubmission($submissionId: Float!) {
  DeleteFormSubmission(submissionId: $submissionId) {
    status
    message
    data
  }
}
    `;
export type DeleteFormSubmissionMutationFn = Apollo.MutationFunction<DeleteFormSubmissionMutation, DeleteFormSubmissionMutationVariables>;

/**
 * __useDeleteFormSubmissionMutation__
 *
 * To run a mutation, you first call `useDeleteFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormSubmissionMutation, { data, loading, error }] = useDeleteFormSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useDeleteFormSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormSubmissionMutation, DeleteFormSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormSubmissionMutation, DeleteFormSubmissionMutationVariables>(DeleteFormSubmissionDocument, options);
      }
export type DeleteFormSubmissionMutationHookResult = ReturnType<typeof useDeleteFormSubmissionMutation>;
export type DeleteFormSubmissionMutationResult = Apollo.MutationResult<DeleteFormSubmissionMutation>;
export type DeleteFormSubmissionMutationOptions = Apollo.BaseMutationOptions<DeleteFormSubmissionMutation, DeleteFormSubmissionMutationVariables>;
export const CreateNewsCategoryDocument = gql`
    mutation CreateNewsCategory($newsCategory: NewsCategoryInput!) {
  CreateNewsCategory(newsCategory: $newsCategory) {
    status
    message
  }
}
    `;
export type CreateNewsCategoryMutationFn = Apollo.MutationFunction<CreateNewsCategoryMutation, CreateNewsCategoryMutationVariables>;

/**
 * __useCreateNewsCategoryMutation__
 *
 * To run a mutation, you first call `useCreateNewsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsCategoryMutation, { data, loading, error }] = useCreateNewsCategoryMutation({
 *   variables: {
 *      newsCategory: // value for 'newsCategory'
 *   },
 * });
 */
export function useCreateNewsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewsCategoryMutation, CreateNewsCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewsCategoryMutation, CreateNewsCategoryMutationVariables>(CreateNewsCategoryDocument, options);
      }
export type CreateNewsCategoryMutationHookResult = ReturnType<typeof useCreateNewsCategoryMutation>;
export type CreateNewsCategoryMutationResult = Apollo.MutationResult<CreateNewsCategoryMutation>;
export type CreateNewsCategoryMutationOptions = Apollo.BaseMutationOptions<CreateNewsCategoryMutation, CreateNewsCategoryMutationVariables>;
export const UpdateNewsCategoryDocument = gql`
    mutation UpdateNewsCategory($newsCategory: NewsCategoryInput!) {
  UpdateNewsCategory(newsCategory: $newsCategory) {
    status
    message
  }
}
    `;
export type UpdateNewsCategoryMutationFn = Apollo.MutationFunction<UpdateNewsCategoryMutation, UpdateNewsCategoryMutationVariables>;

/**
 * __useUpdateNewsCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateNewsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNewsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNewsCategoryMutation, { data, loading, error }] = useUpdateNewsCategoryMutation({
 *   variables: {
 *      newsCategory: // value for 'newsCategory'
 *   },
 * });
 */
export function useUpdateNewsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNewsCategoryMutation, UpdateNewsCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNewsCategoryMutation, UpdateNewsCategoryMutationVariables>(UpdateNewsCategoryDocument, options);
      }
export type UpdateNewsCategoryMutationHookResult = ReturnType<typeof useUpdateNewsCategoryMutation>;
export type UpdateNewsCategoryMutationResult = Apollo.MutationResult<UpdateNewsCategoryMutation>;
export type UpdateNewsCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateNewsCategoryMutation, UpdateNewsCategoryMutationVariables>;
export const CreatePostDocument = gql`
    mutation CreatePost($post: PostsInput!) {
  CreatePost(post: $post) {
    status
    message
    data {
      content
      id
      isEnabled
      publishedTime
      title
      url
    }
  }
}
    `;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      post: // value for 'post'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const UpdatePostDocument = gql`
    mutation UpdatePost($post: PostsInput!) {
  UpdatePost(Post: $post) {
    data {
      content
      id
      isEnabled
      publishedTime
      title
      url
    }
    message
    status
  }
}
    `;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      post: // value for 'post'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($postId: Float!) {
  DeletePost(postId: $postId) {
    data
    message
    status
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const UpdateUserAllInfoDocument = gql`
    mutation UpdateUserAllInfo($user: UpdateUserAllInfo!, $exclusionGroup: Float!) {
  UpdateUserAllInfo(user: $user, exclusionGroup: $exclusionGroup) {
    status
    message
    data
  }
}
    `;
export type UpdateUserAllInfoMutationFn = Apollo.MutationFunction<UpdateUserAllInfoMutation, UpdateUserAllInfoMutationVariables>;

/**
 * __useUpdateUserAllInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserAllInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAllInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAllInfoMutation, { data, loading, error }] = useUpdateUserAllInfoMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserAllInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAllInfoMutation, UpdateUserAllInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAllInfoMutation, UpdateUserAllInfoMutationVariables>(UpdateUserAllInfoDocument, options);
      }
export type UpdateUserAllInfoMutationHookResult = ReturnType<typeof useUpdateUserAllInfoMutation>;
export type UpdateUserAllInfoMutationResult = Apollo.MutationResult<UpdateUserAllInfoMutation>;
export type UpdateUserAllInfoMutationOptions = Apollo.BaseMutationOptions<UpdateUserAllInfoMutation, UpdateUserAllInfoMutationVariables>;
export const CreateMinistryDocument = gql`
    mutation CreateMinistry($ministry: MinistryInput!) {
  CreateMinistry(ministry: $ministry) {
    status
    message
    data {
      ...MinistryFragment
    }
  }
}
    ${MinistryFragmentFragmentDoc}`;

export type CreateGalleryResourceMutationFn = Apollo.MutationFunction<CreateGalleryResourceMutation, CreateGalleryResourceMutationVariables>;
export const CreateGalleryResourceDocument = gql`
    mutation CreateGalleryResource($galleryResource: GalleryResourceInput!) {
      CreateGalleryResource(galleryResource: $galleryResource) {
        status
        message
        data {
          ...GalleryResourceFragment
        }
      }
}
    ${GalleryResourceFragmentDoc}`;

export function useCreateGalleryResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateGalleryResourceMutation, CreateGalleryResourceMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateGalleryResourceMutation, CreateGalleryResourceMutationVariables>(CreateGalleryResourceDocument, options);
}


export type UpdateGalleryResourceMutationFn = Apollo.MutationFunction<UpdateGalleryResourceMutation, UpdateGalleryResourceMutationVariables>;
export const UpdateGalleryResourceDocument = gql`
    mutation UpdateGalleryResource($data: GalleryResourceInput!) {
      UpdateGalleryResource(data: $data) {
        status
        message
        data {
          ...GalleryResourceFragment
        }
      }
}
    ${GalleryResourceFragmentDoc}`;

export function useUpdateGalleryResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGalleryResourceMutation, UpdateGalleryResourceMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateGalleryResourceMutation, UpdateGalleryResourceMutationVariables>(UpdateGalleryResourceDocument, options);
}

export const DeleteGalleryResourceDocument = gql`
    mutation DeleteGalleryResource($id: Float!) {
      DeleteGalleryResource(id: $id) {
        data
        message
        status
      }
}
    `;

export function useDeleteGalleryResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGalleryResourceMutation, DeleteGalleryResourceMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteGalleryResourceMutation, DeleteGalleryResourceMutationVariables>(DeleteGalleryResourceDocument, options);
}
export type DeleteGalleryResourceMutationHookResult = ReturnType<typeof useDeleteGalleryResourceMutation>;
export type DeleteGalleryResourceMutationResult = Apollo.MutationResult<DeleteGalleryResourceMutation>;
export type DeleteGalleryResourceMutationOptions = Apollo.BaseMutationOptions<DeleteGalleryResourceMutation, DeleteGalleryResourceMutationVariables>;

/**
 * __useCreateMinistryMutation__
 *
 * To run a mutation, you first call `useCreateMinistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMinistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMinistryMutation, { data, loading, error }] = useCreateMinistryMutation({
 *   variables: {
 *      ministry: // value for 'ministry'
 *   },
 * });
 */
export function useCreateMinistryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMinistryMutation, CreateMinistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMinistryMutation, CreateMinistryMutationVariables>(CreateMinistryDocument, options);
      }
export type CreateMinistryMutationHookResult = ReturnType<typeof useCreateMinistryMutation>;
export type CreateMinistryMutationResult = Apollo.MutationResult<CreateMinistryMutation>;
export type CreateMinistryMutationOptions = Apollo.BaseMutationOptions<CreateMinistryMutation, CreateMinistryMutationVariables>;
export const DuplicateMinistryDocument = gql`
    mutation DuplicateMinistry($ministryId: Float!) {
  DuplicateMinistry(id: $ministryId) {
    status
    message
    data {
      ...MinistryFragment
    }
  }
}
    ${MinistryFragmentFragmentDoc}`;
export type DuplicateMinistryMutationFn = Apollo.MutationFunction<DuplicateMinistryMutation, DuplicateMinistryMutationVariables>;

/**
 * __useDuplicateMinistryMutation__
 *
 * To run a mutation, you first call `useDuplicateMinistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateMinistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateMinistryMutation, { data, loading, error }] = useDuplicateMinistryMutation({
 *   variables: {
 *      ministryId: // value for 'ministryId'
 *   },
 * });
 */
export function useDuplicateMinistryMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateMinistryMutation, DuplicateMinistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateMinistryMutation, DuplicateMinistryMutationVariables>(DuplicateMinistryDocument, options);
      }
export type DuplicateMinistryMutationHookResult = ReturnType<typeof useDuplicateMinistryMutation>;
export type DuplicateMinistryMutationResult = Apollo.MutationResult<DuplicateMinistryMutation>;
export type DuplicateMinistryMutationOptions = Apollo.BaseMutationOptions<DuplicateMinistryMutation, DuplicateMinistryMutationVariables>;
export const UpdateMinistryDocument = gql`
    mutation UpdateMinistry($ministry: MinistryInput!) {
  UpdateMinistry(data: $ministry) {
    status
    message
    data {
      ...MinistryFragment
    }
  }
}
    ${MinistryFragmentFragmentDoc}`;
export type UpdateMinistryMutationFn = Apollo.MutationFunction<UpdateMinistryMutation, UpdateMinistryMutationVariables>;

/**
 * __useUpdateMinistryMutation__
 *
 * To run a mutation, you first call `useUpdateMinistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMinistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMinistryMutation, { data, loading, error }] = useUpdateMinistryMutation({
 *   variables: {
 *      ministry: // value for 'ministry'
 *   },
 * });
 */
export function useUpdateMinistryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMinistryMutation, UpdateMinistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMinistryMutation, UpdateMinistryMutationVariables>(UpdateMinistryDocument, options);
      }
export type UpdateMinistryMutationHookResult = ReturnType<typeof useUpdateMinistryMutation>;
export type UpdateMinistryMutationResult = Apollo.MutationResult<UpdateMinistryMutation>;
export type UpdateMinistryMutationOptions = Apollo.BaseMutationOptions<UpdateMinistryMutation, UpdateMinistryMutationVariables>;
export const DeleteMinistryDocument = gql`
    mutation DeleteMinistry($deleteMinistryId: Float!) {
  DeleteMinistry(id: $deleteMinistryId) {
    data
    message
    status
  }
}
    `;
export type DeleteMinistryMutationFn = Apollo.MutationFunction<DeleteMinistryMutation, DeleteMinistryMutationVariables>;

/**
 * __useDeleteMinistryMutation__
 *
 * To run a mutation, you first call `useDeleteMinistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMinistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMinistryMutation, { data, loading, error }] = useDeleteMinistryMutation({
 *   variables: {
 *      deleteMinistryId: // value for 'deleteMinistryId'
 *   },
 * });
 */
export function useDeleteMinistryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMinistryMutation, DeleteMinistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMinistryMutation, DeleteMinistryMutationVariables>(DeleteMinistryDocument, options);
      }
export type DeleteMinistryMutationHookResult = ReturnType<typeof useDeleteMinistryMutation>;
export type DeleteMinistryMutationResult = Apollo.MutationResult<DeleteMinistryMutation>;
export type DeleteMinistryMutationOptions = Apollo.BaseMutationOptions<DeleteMinistryMutation, DeleteMinistryMutationVariables>;
export const CreateTestimonialDocument = gql`
    mutation CreateTestimonial($testimonial: TestimonialInput!) {
  CreateTestimonial(testimonial: $testimonial) {
    status
    message
    data {
      blocks {
        content
        id
        order
        sideContent
      }
      content
      createTime
      headLine
      id
      name
      order
      pageTitle
      ministryId
      sideContent
      updateTime
      url
    }
  }
}
    `;
export type CreateTestimonialMutationFn = Apollo.MutationFunction<CreateTestimonialMutation, CreateTestimonialMutationVariables>;

/**
 * __useCreateTestimonialMutation__
 *
 * To run a mutation, you first call `useCreateTestimonialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestimonialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestimonialMutation, { data, loading, error }] = useCreateTestimonialMutation({
 *   variables: {
 *      testimonial: // value for 'testimonial'
 *   },
 * });
 */
export function useCreateTestimonialMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestimonialMutation, CreateTestimonialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestimonialMutation, CreateTestimonialMutationVariables>(CreateTestimonialDocument, options);
      }
export type CreateTestimonialMutationHookResult = ReturnType<typeof useCreateTestimonialMutation>;
export type CreateTestimonialMutationResult = Apollo.MutationResult<CreateTestimonialMutation>;
export type CreateTestimonialMutationOptions = Apollo.BaseMutationOptions<CreateTestimonialMutation, CreateTestimonialMutationVariables>;
export const DeleteTestimonialDocument = gql`
    mutation DeleteTestimonial($id: Float!) {
  DeleteTestimonial(id: $id) {
    data
    message
    status
  }
}
    `;
export type DeleteTestimonialMutationFn = Apollo.MutationFunction<DeleteTestimonialMutation, DeleteTestimonialMutationVariables>;

/**
 * __useDeleteTestimonialMutation__
 *
 * To run a mutation, you first call `useDeleteTestimonialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestimonialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestimonialMutation, { data, loading, error }] = useDeleteTestimonialMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTestimonialMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTestimonialMutation, DeleteTestimonialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTestimonialMutation, DeleteTestimonialMutationVariables>(DeleteTestimonialDocument, options);
      }
export type DeleteTestimonialMutationHookResult = ReturnType<typeof useDeleteTestimonialMutation>;
export type DeleteTestimonialMutationResult = Apollo.MutationResult<DeleteTestimonialMutation>;
export type DeleteTestimonialMutationOptions = Apollo.BaseMutationOptions<DeleteTestimonialMutation, DeleteTestimonialMutationVariables>;
export const UpdateTestimonialDocument = gql`
    mutation UpdateTestimonial($data: TestimonialInput!) {
  UpdateTestimonial(data: $data) {
    status
    message
    data {
      blocks {
        content
        id
        order
        sideContent
      }
      content
      createTime
      headLine
      id
      name
      order
      pageTitle
      ministryId
      sideContent
      summary
      updateTime
      url
    }
  }
}
    `;
export type UpdateTestimonialMutationFn = Apollo.MutationFunction<UpdateTestimonialMutation, UpdateTestimonialMutationVariables>;

/**
 * __useUpdateTestimonialMutation__
 *
 * To run a mutation, you first call `useUpdateTestimonialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestimonialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestimonialMutation, { data, loading, error }] = useUpdateTestimonialMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTestimonialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestimonialMutation, UpdateTestimonialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestimonialMutation, UpdateTestimonialMutationVariables>(UpdateTestimonialDocument, options);
      }
export type UpdateTestimonialMutationHookResult = ReturnType<typeof useUpdateTestimonialMutation>;
export type UpdateTestimonialMutationResult = Apollo.MutationResult<UpdateTestimonialMutation>;
export type UpdateTestimonialMutationOptions = Apollo.BaseMutationOptions<UpdateTestimonialMutation, UpdateTestimonialMutationVariables>;
export const AddBlockDocument = gql`
    mutation AddBlock($data: BlockInput!) {
  AddBlock(data: $data) {
    status
    message
    data {
      content
      id
      order
      sideContent
    }
  }
}
    `;
export type AddBlockMutationFn = Apollo.MutationFunction<AddBlockMutation, AddBlockMutationVariables>;

/**
 * __useAddBlockMutation__
 *
 * To run a mutation, you first call `useAddBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBlockMutation, { data, loading, error }] = useAddBlockMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddBlockMutation(baseOptions?: Apollo.MutationHookOptions<AddBlockMutation, AddBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBlockMutation, AddBlockMutationVariables>(AddBlockDocument, options);
      }
export type AddBlockMutationHookResult = ReturnType<typeof useAddBlockMutation>;
export type AddBlockMutationResult = Apollo.MutationResult<AddBlockMutation>;
export type AddBlockMutationOptions = Apollo.BaseMutationOptions<AddBlockMutation, AddBlockMutationVariables>;
export const UpdateBlockDocument = gql`
    mutation UpdateBlock($data: BlockInput!) {
  UpdateBlock(data: $data) {
    data {
      content
      id
      order
      sideContent
    }
    message
    status
  }
}
    `;
export type UpdateBlockMutationFn = Apollo.MutationFunction<UpdateBlockMutation, UpdateBlockMutationVariables>;

/**
 * __useUpdateBlockMutation__
 *
 * To run a mutation, you first call `useUpdateBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockMutation, { data, loading, error }] = useUpdateBlockMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockMutation, UpdateBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockMutation, UpdateBlockMutationVariables>(UpdateBlockDocument, options);
      }
export type UpdateBlockMutationHookResult = ReturnType<typeof useUpdateBlockMutation>;
export type UpdateBlockMutationResult = Apollo.MutationResult<UpdateBlockMutation>;
export type UpdateBlockMutationOptions = Apollo.BaseMutationOptions<UpdateBlockMutation, UpdateBlockMutationVariables>;
export const DeleteBlockDocument = gql`
    mutation DeleteBlock($deleteBlockId: Float!) {
  DeleteBlock(id: $deleteBlockId) {
    status
    message
    data
  }
}
    `;
export type DeleteBlockMutationFn = Apollo.MutationFunction<DeleteBlockMutation, DeleteBlockMutationVariables>;

/**
 * __useDeleteBlockMutation__
 *
 * To run a mutation, you first call `useDeleteBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockMutation, { data, loading, error }] = useDeleteBlockMutation({
 *   variables: {
 *      deleteBlockId: // value for 'deleteBlockId'
 *   },
 * });
 */
export function useDeleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlockMutation, DeleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlockMutation, DeleteBlockMutationVariables>(DeleteBlockDocument, options);
      }
export type DeleteBlockMutationHookResult = ReturnType<typeof useDeleteBlockMutation>;
export type DeleteBlockMutationResult = Apollo.MutationResult<DeleteBlockMutation>;
export type DeleteBlockMutationOptions = Apollo.BaseMutationOptions<DeleteBlockMutation, DeleteBlockMutationVariables>;
export const UpdateInventoryDocument = gql`
    mutation UpdateInventory($input: UpdateInventoryInput!) {
  UpdateInventory(input: $input) {
    data {
      caseWeight
      categoryId
      createTime
      description
      exclusiveOffer
      id
      imageUrl
      inventory
      isActive
      isDeleted
      isPublished
      quantityInCase
      sku
      sortingOrder
      title
      updateTime
    }
  }
}
    `;
export type UpdateInventoryMutationFn = Apollo.MutationFunction<UpdateInventoryMutation, UpdateInventoryMutationVariables>;

/**
 * __useUpdateInventoryMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryMutation, { data, loading, error }] = useUpdateInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInventoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInventoryMutation, UpdateInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInventoryMutation, UpdateInventoryMutationVariables>(UpdateInventoryDocument, options);
      }
export type UpdateInventoryMutationHookResult = ReturnType<typeof useUpdateInventoryMutation>;
export type UpdateInventoryMutationResult = Apollo.MutationResult<UpdateInventoryMutation>;
export type UpdateInventoryMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryMutation, UpdateInventoryMutationVariables>;
export const PrintApplicationsDocument = gql`
    mutation PrintApplications($applicationIds: [Float!]!, $timezone: Float!) {
  PrintApplications(applicationIds: $applicationIds, timezone: $timezone)
}
    `;
export type PrintApplicationsMutationFn = Apollo.MutationFunction<PrintApplicationsMutation, PrintApplicationsMutationVariables>;


export type PrintApprovalsSelectedMutationFn = Apollo.MutationFunction<PrintApprovalsSelectedMutation, ApprovalsSelectedForPDF>;
export const PrintApprovalsSelectedDocument = gql`
    mutation PrintApprovalsSelected($approvalsSelected: [ApprovalsSelectedForPDF!]!) {
      PrintApprovalsSelected(approvalsSelected: $approvalsSelected)
}
    `;

/**
 * __usePrintApplicationsMutation__
 *
 * To run a mutation, you first call `usePrintApplicationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintApplicationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printApplicationsMutation, { data, loading, error }] = usePrintApplicationsMutation({
 *   variables: {
 *      applicationIds: // value for 'applicationIds'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function usePrintApplicationsMutation(baseOptions?: Apollo.MutationHookOptions<PrintApplicationsMutation, PrintApplicationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintApplicationsMutation, PrintApplicationsMutationVariables>(PrintApplicationsDocument, options);
      }
export type PrintApplicationsMutationHookResult = ReturnType<typeof usePrintApplicationsMutation>;
export type PrintApplicationsMutationResult = Apollo.MutationResult<PrintApplicationsMutation>;
export type PrintApplicationsMutationOptions = Apollo.BaseMutationOptions<PrintApplicationsMutation, PrintApplicationsMutationVariables>;
export const CheckSignUpDocument = gql`
    query CheckSignUp($email: String!) {
  CheckSignUp(email: $email) {
    status
    message
    errorCode
  }
}
    `;

/**
 * __useCheckSignUpQuery__
 *
 * To run a query within a React component, call `useCheckSignUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSignUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSignUpQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckSignUpQuery(baseOptions: Apollo.QueryHookOptions<CheckSignUpQuery, CheckSignUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSignUpQuery, CheckSignUpQueryVariables>(CheckSignUpDocument, options);
      }
export function useCheckSignUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSignUpQuery, CheckSignUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSignUpQuery, CheckSignUpQueryVariables>(CheckSignUpDocument, options);
        }
export type CheckSignUpQueryHookResult = ReturnType<typeof useCheckSignUpQuery>;
export type CheckSignUpLazyQueryHookResult = ReturnType<typeof useCheckSignUpLazyQuery>;
export type CheckSignUpQueryResult = Apollo.QueryResult<CheckSignUpQuery, CheckSignUpQueryVariables>;
export const MeDocument = gql`
    query Me {
  Me {
    data {
      ...UserFragment
      role {
        ...UserRoleFragment
      }
      shippingLocations {
        id
        organization
        title
        firstName
        lastName
        address1
        address2
        city
        state
        zipCode
        createTime
        updateTime
      }
      shippingDetails {
        id
        phone
        email
        loadingDock
        is501c3
        contactInfo
        rank
        createTime
        updateTime
      }
      organizationInfo {
        ...OrganizationInfoFragment
      }
      resourceDistribution {
        ...ResourceDistributionFragment
      }
      userServe {
        ...UserServeFragment
      }
      exclusionGroup {
        ...ExclusionGroupFragment
      }
    }
    message
    status
  }
}
    ${UserFragmentFragmentDoc}
${UserRoleFragmentFragmentDoc}
${OrganizationInfoFragmentFragmentDoc}
${ResourceDistributionFragmentFragmentDoc}
${UserServeFragmentFragmentDoc}${ExclusionGroupFragmentFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CategoriesDocument = gql`
    query Categories($page: Int, $pageSize: Int, $search: String, $skip: Int) {
  Categories(page: $page, pageSize: $pageSize, search: $search, skip: $skip) {
    items {
      ...ResourceCategory
    }
    total
  }
}
    ${ResourceCategoryFragmentDoc}`;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const CategoryListDocument = gql`
    query CategoryList($page: Int, $pageSize: Int, $search: String, $skip: Int) {
  Categories(page: $page, pageSize: $pageSize, search: $search, skip: $skip) {
    items {
      id
      title
    }
    total
  }
}
    `;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<CategoryListQuery, CategoryListQueryVariables>;
export const ResourcesDocument = gql`
    query Resources($page: Int, $pageSize: Int, $search: String, $sort: ResourceSortField, $sortDirection: SortDirectionField) {
  Resources(
    page: $page
    pageSize: $pageSize
    search: $search
    sort: $sort
    sortDirection: $sortDirection
  ) {
    items {
      ...ResourceFragment
    }
    total
  }
}
    ${ResourceFragmentFragmentDoc}`;

export const ExclusionGroupsDocument = gql`
    query ExclusionGroups($page: Int, $pageSize: Int, $search: String, $sort: ExclusionGroupSortField, $sortDirection: SortDirectionField) {
  ExclusionGroups(
    page: $page
    pageSize: $pageSize
    search: $search
    sort: $sort
    sortDirection: $sortDirection
  ) {
    items {
      ...ExclusionGroupFragment
    }
    total
  }
}
    ${ExclusionGroupFragmentFragmentDoc}`;

/**
 * __useResourcesQuery__
 *
 * To run a query within a React component, call `useResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useResourcesQuery(baseOptions?: Apollo.QueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
      }
export function useResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
        }
export type ResourcesQueryHookResult = ReturnType<typeof useResourcesQuery>;
export type ResourcesLazyQueryHookResult = ReturnType<typeof useResourcesLazyQuery>;
export type ResourcesQueryResult = Apollo.QueryResult<ResourcesQuery, ResourcesQueryVariables>;
export const PublicResourcesDocument = gql`
    query PublicResources($page: Int, $pageSize: Int, $resourcesSearch: String) {
  PublicResources(page: $page, pageSize: $pageSize, search: $resourcesSearch) {
    items {
      ...ResourceFragment
    }
    total
  }
}
    ${ResourceFragmentFragmentDoc}`;

export function useExclusionGroupQuery(baseOptions?: Apollo.QueryHookOptions<ExclusionGroupQuery, ExclusionGroupQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ExclusionGroupQuery, ExclusionGroupQueryVariables>(ExclusionGroupsDocument, options);
}

/**
 * __usePublicResourcesQuery__
 *
 * To run a query within a React component, call `usePublicResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicResourcesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      resourcesSearch: // value for 'resourcesSearch'
 *   },
 * });
 */
export function usePublicResourcesQuery(baseOptions?: Apollo.QueryHookOptions<PublicResourcesQuery, PublicResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicResourcesQuery, PublicResourcesQueryVariables>(PublicResourcesDocument, options);
      }
export function usePublicResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicResourcesQuery, PublicResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicResourcesQuery, PublicResourcesQueryVariables>(PublicResourcesDocument, options);
        }
export type PublicResourcesQueryHookResult = ReturnType<typeof usePublicResourcesQuery>;
export type PublicResourcesLazyQueryHookResult = ReturnType<typeof usePublicResourcesLazyQuery>;
export type PublicResourcesQueryResult = Apollo.QueryResult<PublicResourcesQuery, PublicResourcesQueryVariables>;
export const ResourcesListDocument = gql`
    query ResourcesList($sort: ResourceSortField, $sortDirection: SortDirectionField) {
  Resources(page: 1, pageSize: 10000, sort: $sort, sortDirection: $sortDirection) {
    items {
      ...ResourceFragment
    }
    total
  }
}
    ${ResourceFragmentFragmentDoc}`;

export const ExclusionGroupsListDocument = gql`
    query ExclusionGroupsList {
  ExclusionGroups(page: 1, pageSize: 10000) {
    items {
      ...ExclusionGroupFragment
    }
    total
  }
}
    ${ExclusionGroupFragmentFragmentDoc}`;

/**
 * __useResourcesListQuery__
 *
 * To run a query within a React component, call `useResourcesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useExclusionGroupListQuery(baseOptions?: Apollo.QueryHookOptions<ExclusionGroupsListQuery, ExclusionGroupsListQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ExclusionGroupsListQuery, ExclusionGroupsListQueryVariables>(ExclusionGroupsListDocument, options);
}

export function useResourcesListQuery(baseOptions?: Apollo.QueryHookOptions<ResourcesListQuery, ResourcesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesListQuery, ResourcesListQueryVariables>(ResourcesListDocument, options);
      }
export function useResourcesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesListQuery, ResourcesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesListQuery, ResourcesListQueryVariables>(ResourcesListDocument, options);
        }
export type ResourcesListQueryHookResult = ReturnType<typeof useResourcesListQuery>;
export type ResourcesListLazyQueryHookResult = ReturnType<typeof useResourcesListLazyQuery>;
export type ResourcesListQueryResult = Apollo.QueryResult<ResourcesListQuery, ResourcesListQueryVariables>;
export const ResourcesInventoryDocument = gql`
    query ResourcesInventory($start: DateTime!, $end: DateTime!, $sort: ReportSortField, $sortDirection: SortDirectionField) {
  ResourcesInventory(page: 1, pageSize: 10000, start: $start, end: $end, sort: $sort, sortDirection: $sortDirection) {
    items {
      ...ResourceFragment
    }
    total
  }
}
    ${ResourceFragmentFragmentDoc}`;

/**
 * __useResourcesInventoryQuery__
 *
 * To run a query within a React component, call `useResourcesInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesInventoryQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useResourcesInventoryQuery(baseOptions: Apollo.QueryHookOptions<ResourcesInventoryQuery, ResourcesInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesInventoryQuery, ResourcesInventoryQueryVariables>(ResourcesInventoryDocument, options);
      }
export function useResourcesInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesInventoryQuery, ResourcesInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesInventoryQuery, ResourcesInventoryQueryVariables>(ResourcesInventoryDocument, options);
        }
export type ResourcesInventoryQueryHookResult = ReturnType<typeof useResourcesInventoryQuery>;
export type ResourcesInventoryLazyQueryHookResult = ReturnType<typeof useResourcesInventoryLazyQuery>;
export type ResourcesInventoryQueryResult = Apollo.QueryResult<ResourcesInventoryQuery, ResourcesInventoryQueryVariables>;
export const ResourceInventoriesDocument = gql`
    query resourceInventories($page: Int, $pageSize: Int, $resourceId: Float) {
  resourceInventories(page: $page, pageSize: $pageSize, resourceId: $resourceId) {
    items {
      id
      quantity
      reason
      createTime
      updateTime
      resource {
        id
        title
        sku
        inventory
      }
      user {
        id
        firstName
        lastName
      }
    }
    total
  }
}
    `;

/**
 * __useResourceInventoriesQuery__
 *
 * To run a query within a React component, call `useResourceInventoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceInventoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceInventoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useResourceInventoriesQuery(baseOptions?: Apollo.QueryHookOptions<ResourceInventoriesQuery, ResourceInventoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceInventoriesQuery, ResourceInventoriesQueryVariables>(ResourceInventoriesDocument, options);
      }
export function useResourceInventoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceInventoriesQuery, ResourceInventoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceInventoriesQuery, ResourceInventoriesQueryVariables>(ResourceInventoriesDocument, options);
        }
export type ResourceInventoriesQueryHookResult = ReturnType<typeof useResourceInventoriesQuery>;
export type ResourceInventoriesLazyQueryHookResult = ReturnType<typeof useResourceInventoriesLazyQuery>;
export type ResourceInventoriesQueryResult = Apollo.QueryResult<ResourceInventoriesQuery, ResourceInventoriesQueryVariables>;
export const ResourceByIdDocument = gql`
    query ResourceById($resourceId: Float!) {
  Resource(resourceId: $resourceId) {
    data {
      ...ResourceFragment
    }
    message
    status
  }
}
    ${ResourceFragmentFragmentDoc}`;

/**
 * __useResourceByIdQuery__
 *
 * To run a query within a React component, call `useResourceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceByIdQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useResourceByIdQuery(baseOptions: Apollo.QueryHookOptions<ResourceByIdQuery, ResourceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceByIdQuery, ResourceByIdQueryVariables>(ResourceByIdDocument, options);
      }
export function useResourceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceByIdQuery, ResourceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceByIdQuery, ResourceByIdQueryVariables>(ResourceByIdDocument, options);
        }
export type ResourceByIdQueryHookResult = ReturnType<typeof useResourceByIdQuery>;
export type ResourceByIdLazyQueryHookResult = ReturnType<typeof useResourceByIdLazyQuery>;
export type ResourceByIdQueryResult = Apollo.QueryResult<ResourceByIdQuery, ResourceByIdQueryVariables>;
export const PagesDocument = gql`
    query Pages($dropMenu: Boolean, $isNav: Boolean, $isShow: Boolean, $page: Int, $pageSize: Int) {
  Pages(
    dropMenu: $dropMenu
    isNav: $isNav
    isShow: $isShow
    page: $page
    pageSize: $pageSize
  ) {
    items {
      ...PageFragment
      children {
        ...PageFragment
      }
    }
    total
  }
}
    ${PageFragmentFragmentDoc}`;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *      dropMenu: // value for 'dropMenu'
 *      isNav: // value for 'isNav'
 *      isShow: // value for 'isShow'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function usePagesQuery(baseOptions?: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
      }
export function usePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>;
export type PagesQueryResult = Apollo.QueryResult<PagesQuery, PagesQueryVariables>;
export const DropMenuPagesDocument = gql`
    query DropMenuPages($page: Int, $pageSize: Int) {
  Pages(isNav: true, page: $page, pageSize: $pageSize) {
    items {
      id
      isNav
      name
    }
    total
  }
}
    `;

/**
 * __useDropMenuPagesQuery__
 *
 * To run a query within a React component, call `useDropMenuPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDropMenuPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropMenuPagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useDropMenuPagesQuery(baseOptions?: Apollo.QueryHookOptions<DropMenuPagesQuery, DropMenuPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DropMenuPagesQuery, DropMenuPagesQueryVariables>(DropMenuPagesDocument, options);
      }
export function useDropMenuPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DropMenuPagesQuery, DropMenuPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DropMenuPagesQuery, DropMenuPagesQueryVariables>(DropMenuPagesDocument, options);
        }
export type DropMenuPagesQueryHookResult = ReturnType<typeof useDropMenuPagesQuery>;
export type DropMenuPagesLazyQueryHookResult = ReturnType<typeof useDropMenuPagesLazyQuery>;
export type DropMenuPagesQueryResult = Apollo.QueryResult<DropMenuPagesQuery, DropMenuPagesQueryVariables>;
export const PageHeadersDocument = gql`
    query PageHeaders($page: Int, $pageSize: Int) {
  Pages(page: $page, pageSize: $pageSize) {
    items {
      ...PageFragment
      children {
        ...PageFragment
      }
    }
    total
  }
}
    ${PageFragmentFragmentDoc}`;

/**
 * __usePageHeadersQuery__
 *
 * To run a query within a React component, call `usePageHeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageHeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageHeadersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function usePageHeadersQuery(baseOptions?: Apollo.QueryHookOptions<PageHeadersQuery, PageHeadersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageHeadersQuery, PageHeadersQueryVariables>(PageHeadersDocument, options);
      }
export function usePageHeadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageHeadersQuery, PageHeadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageHeadersQuery, PageHeadersQueryVariables>(PageHeadersDocument, options);
        }
export type PageHeadersQueryHookResult = ReturnType<typeof usePageHeadersQuery>;
export type PageHeadersLazyQueryHookResult = ReturnType<typeof usePageHeadersLazyQuery>;
export type PageHeadersQueryResult = Apollo.QueryResult<PageHeadersQuery, PageHeadersQueryVariables>;
export const PageByIdDocument = gql`
    query PageById($pageId: Float!) {
  Page(pageId: $pageId) {
    data {
      ...PageFragment
    }
  }
}
    ${PageFragmentFragmentDoc}`;

/**
 * __usePageByIdQuery__
 *
 * To run a query within a React component, call `usePageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageByIdQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function usePageByIdQuery(baseOptions: Apollo.QueryHookOptions<PageByIdQuery, PageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageByIdQuery, PageByIdQueryVariables>(PageByIdDocument, options);
      }
export function usePageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageByIdQuery, PageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageByIdQuery, PageByIdQueryVariables>(PageByIdDocument, options);
        }
export type PageByIdQueryHookResult = ReturnType<typeof usePageByIdQuery>;
export type PageByIdLazyQueryHookResult = ReturnType<typeof usePageByIdLazyQuery>;
export type PageByIdQueryResult = Apollo.QueryResult<PageByIdQuery, PageByIdQueryVariables>;
export const PageByUrlDocument = gql`
    query PageByUrl($url: String!) {
  PageByUrl(url: $url) {
    message
    status
    data {
      ...PageFragment
    }
  }
}
    ${PageFragmentFragmentDoc}`;

/**
 * __usePageByUrlQuery__
 *
 * To run a query within a React component, call `usePageByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function usePageByUrlQuery(baseOptions: Apollo.QueryHookOptions<PageByUrlQuery, PageByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageByUrlQuery, PageByUrlQueryVariables>(PageByUrlDocument, options);
      }
export function usePageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageByUrlQuery, PageByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageByUrlQuery, PageByUrlQueryVariables>(PageByUrlDocument, options);
        }
export type PageByUrlQueryHookResult = ReturnType<typeof usePageByUrlQuery>;
export type PageByUrlLazyQueryHookResult = ReturnType<typeof usePageByUrlLazyQuery>;
export type PageByUrlQueryResult = Apollo.QueryResult<PageByUrlQuery, PageByUrlQueryVariables>;
export const UsersDocument = gql`
    query Users($page: Int, $pageSize: Int, $isSuperUser: Boolean, $sort: UserSortField, $sortDirection: SortDirectionField, $search: String, $filter: UserFilterArgType) {
  Users(
    page: $page
    pageSize: $pageSize
    isSuperUser: $isSuperUser
    sort: $sort
    sortDirection: $sortDirection
    search: $search
    filter: $filter
  ) {
    items {
      ...UserFragment
      role {
        ...UserRoleFragment
      }
      organizationInfo {
        ...OrganizationInfoFragment
      }
    }
    total
  }
}
    ${UserFragmentFragmentDoc}
${UserRoleFragmentFragmentDoc}
${OrganizationInfoFragmentFragmentDoc}`;




export function useApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<ApprovalsQuery, ApprovalsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ApprovalsQuery, ApprovalsQueryVariables>(ApprovalsDocument, options);
}
export function useApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalsQuery, ApprovalsQueryVariables>) {
    const options = {...defaultOptions, ...baseOptions}
    return Apollo.useLazyQuery<ApprovalsQuery, ApprovalsQueryVariables>(ApprovalsDocument, options);
  }
export type ApprovalsQueryHookResult = ReturnType<typeof useApprovalsQuery>;
export type ApprovalsLazyQueryHookResult = ReturnType<typeof useApprovalsLazyQuery>;
export type ApprovalsQueryResult = Apollo.QueryResult<ApprovalsQuery, ApprovalsQueryVariables>;
export const ApprovalsDocument = gql`
query Approvals($page: Int, $pageSize: Int, $isSuperUser: Boolean, $sort: ApprovalSortField, $sortDirection: SortDirectionField, $search: String, $filter: ApprovalsFilterArgType) {
  ApprovalUsers(
    page: $page
    pageSize: $pageSize
    isSuperUser: $isSuperUser
    sort: $sort
    sortDirection: $sortDirection
    search: $search
    filter: $filter
  ) {
    items {
      id
      acceptedDate
      createTime
      endDate
      ministryCategory
      requestId
      requestStatus
      requestTime
      shippedTime
      updateTime
      organization
      firstName
      lastName
    }
    total
  }
}
`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      isSuperUser: // value for 'isSuperUser'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const SelectUsersDocument = gql`
    query SelectUsers($page: Int, $pageSize: Int) {
  Users(page: $page, pageSize: $pageSize) {
    items {
      id
      firstName
      lastName
    }
    total
  }
}
    `;

/**
 * __useSelectUsersQuery__
 *
 * To run a query within a React component, call `useSelectUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useSelectUsersQuery(baseOptions?: Apollo.QueryHookOptions<SelectUsersQuery, SelectUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectUsersQuery, SelectUsersQueryVariables>(SelectUsersDocument, options);
      }
export function useSelectUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectUsersQuery, SelectUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectUsersQuery, SelectUsersQueryVariables>(SelectUsersDocument, options);
        }
export type SelectUsersQueryHookResult = ReturnType<typeof useSelectUsersQuery>;
export type SelectUsersLazyQueryHookResult = ReturnType<typeof useSelectUsersLazyQuery>;
export type SelectUsersQueryResult = Apollo.QueryResult<SelectUsersQuery, SelectUsersQueryVariables>;
export const UserByIdDocument = gql`
    query UserById($userId: Float!) {
  User(userId: $userId) {
    status
    message
    data {
      id
      firstName
      lastName
      email
      phone
      roleId
      redFlag
      yellowFlag
      autoRedFlag
      autoYellowFlag
      priorApplicationKey
      isActive
      status
      isSuperuser
      acceptedDate
      endDate
      createTime
      updateTime
      role {
        ...UserRoleFragment
      }
      exclusionGroup {
        ...ExclusionGroupFragment
      }
      shippingLocations {
        id
        organization
        title
        firstName
        lastName
        address1
        address2
        city
        state
        zipCode
        createTime
        updateTime
      }
      shippingDetails {
        id
        phone
        email
        loadingDock
        is501c3
        contactInfo
        rank
        createTime
        updateTime
      }
      organizationInfo {
        ...OrganizationInfoFragment
      }
      resourceDistribution {
        ...ResourceDistributionFragment
      }
      userServe {
        ...UserServeFragment
      }
      requests {
        id
      }
      comments {
        id
        comment
        user {
          id
          firstName
          lastName
        }
        createTime
        updateTime
      }
    }
  }
}
    ${UserRoleFragmentFragmentDoc}
${OrganizationInfoFragmentFragmentDoc}
${ResourceDistributionFragmentFragmentDoc}
${UserServeFragmentFragmentDoc}
${ExclusionGroupFragmentFragmentDoc}`;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const UserShippingLocationDocument = gql`
    query UserShippingLocation {
  UserShippingLocation {
    data {
      id
      organization
      title
      firstName
      lastName
      address1
      address2
      city
      state
      zipCode
      createTime
      updateTime
    }
    message
    status
  }
}
    `;

/**
 * __useUserShippingLocationQuery__
 *
 * To run a query within a React component, call `useUserShippingLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserShippingLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserShippingLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserShippingLocationQuery(baseOptions?: Apollo.QueryHookOptions<UserShippingLocationQuery, UserShippingLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserShippingLocationQuery, UserShippingLocationQueryVariables>(UserShippingLocationDocument, options);
      }
export function useUserShippingLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserShippingLocationQuery, UserShippingLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserShippingLocationQuery, UserShippingLocationQueryVariables>(UserShippingLocationDocument, options);
        }
export type UserShippingLocationQueryHookResult = ReturnType<typeof useUserShippingLocationQuery>;
export type UserShippingLocationLazyQueryHookResult = ReturnType<typeof useUserShippingLocationLazyQuery>;
export type UserShippingLocationQueryResult = Apollo.QueryResult<UserShippingLocationQuery, UserShippingLocationQueryVariables>;
export const UserShippingDetailDocument = gql`
    query UserShippingDetail {
  UserShippingDetail {
    data {
      id
      phone
      email
      loadingDock
      is501c3
      contactInfo
      rank
      createTime
      updateTime
    }
    message
    status
  }
}
    `;

/**
 * __useUserShippingDetailQuery__
 *
 * To run a query within a React component, call `useUserShippingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserShippingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserShippingDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserShippingDetailQuery(baseOptions?: Apollo.QueryHookOptions<UserShippingDetailQuery, UserShippingDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserShippingDetailQuery, UserShippingDetailQueryVariables>(UserShippingDetailDocument, options);
      }
export function useUserShippingDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserShippingDetailQuery, UserShippingDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserShippingDetailQuery, UserShippingDetailQueryVariables>(UserShippingDetailDocument, options);
        }
export type UserShippingDetailQueryHookResult = ReturnType<typeof useUserShippingDetailQuery>;
export type UserShippingDetailLazyQueryHookResult = ReturnType<typeof useUserShippingDetailLazyQuery>;
export type UserShippingDetailQueryResult = Apollo.QueryResult<UserShippingDetailQuery, UserShippingDetailQueryVariables>;
export const FormsDocument = gql`
    query Forms($page: Int, $pageSize: Int) {
  Forms(page: $page, pageSize: $pageSize) {
    items {
      id
      name
      content
      createTime
      updateTime
      adminEmail
      fromEmail
      emailHeader
      emailBottom
      replyEmail
      submissions {
        id
      }
    }
    total
  }
}
    `;

/**
 * __useFormsQuery__
 *
 * To run a query within a React component, call `useFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useFormsQuery(baseOptions?: Apollo.QueryHookOptions<FormsQuery, FormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
      }
export function useFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormsQuery, FormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
        }
export type FormsQueryHookResult = ReturnType<typeof useFormsQuery>;
export type FormsLazyQueryHookResult = ReturnType<typeof useFormsLazyQuery>;
export type FormsQueryResult = Apollo.QueryResult<FormsQuery, FormsQueryVariables>;
export const FormDocument = gql`
    query Form($formId: Float!) {
  Form(FormId: $formId) {
    message
    status
    data {
      id
      name
      content
      createTime
      updateTime
      adminEmail
      fromEmail
      bccEmails
      emailHeader
      emailBottom
      replyEmail
    }
  }
}
    `;

/**
 * __useFormQuery__
 *
 * To run a query within a React component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormQuery(baseOptions: Apollo.QueryHookOptions<FormQuery, FormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQuery, FormQueryVariables>(FormDocument, options);
      }
export function useFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuery, FormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQuery, FormQueryVariables>(FormDocument, options);
        }
export type FormQueryHookResult = ReturnType<typeof useFormQuery>;
export type FormLazyQueryHookResult = ReturnType<typeof useFormLazyQuery>;
export type FormQueryResult = Apollo.QueryResult<FormQuery, FormQueryVariables>;
export const FormByNameDocument = gql`
    query FormByName($name: String!) {
  GetFormByName(name: $name) {
    data {
      id
      name
      content
      createTime
      updateTime
    }
    message
    status
  }
}
    `;

/**
 * __useFormByNameQuery__
 *
 * To run a query within a React component, call `useFormByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFormByNameQuery(baseOptions: Apollo.QueryHookOptions<FormByNameQuery, FormByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormByNameQuery, FormByNameQueryVariables>(FormByNameDocument, options);
      }
export function useFormByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormByNameQuery, FormByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormByNameQuery, FormByNameQueryVariables>(FormByNameDocument, options);
        }
export type FormByNameQueryHookResult = ReturnType<typeof useFormByNameQuery>;
export type FormByNameLazyQueryHookResult = ReturnType<typeof useFormByNameLazyQuery>;
export type FormByNameQueryResult = Apollo.QueryResult<FormByNameQuery, FormByNameQueryVariables>;
export const FormSubmissionsDocument = gql`
    query FormSubmissions($page: Int, $pageSize: Int, $formId: Float) {
  FormSubmissions(page: $page, pageSize: $pageSize, formId: $formId) {
    items
    keys
    total
  }
}
    `;

/**
 * __useFormSubmissionsQuery__
 *
 * To run a query within a React component, call `useFormSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormSubmissionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<FormSubmissionsQuery, FormSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormSubmissionsQuery, FormSubmissionsQueryVariables>(FormSubmissionsDocument, options);
      }
export function useFormSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormSubmissionsQuery, FormSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormSubmissionsQuery, FormSubmissionsQueryVariables>(FormSubmissionsDocument, options);
        }
export type FormSubmissionsQueryHookResult = ReturnType<typeof useFormSubmissionsQuery>;
export type FormSubmissionsLazyQueryHookResult = ReturnType<typeof useFormSubmissionsLazyQuery>;
export type FormSubmissionsQueryResult = Apollo.QueryResult<FormSubmissionsQuery, FormSubmissionsQueryVariables>;
export const FormSubmissionDocument = gql`
    query FormSubmission($submissionId: Float!) {
  FormSubmission(submissionId: $submissionId) {
    message
    status
    data {
      id
      formId
      content
    }
  }
}
    `;

/**
 * __useFormSubmissionQuery__
 *
 * To run a query within a React component, call `useFormSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormSubmissionQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useFormSubmissionQuery(baseOptions: Apollo.QueryHookOptions<FormSubmissionQuery, FormSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormSubmissionQuery, FormSubmissionQueryVariables>(FormSubmissionDocument, options);
      }
export function useFormSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormSubmissionQuery, FormSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormSubmissionQuery, FormSubmissionQueryVariables>(FormSubmissionDocument, options);
        }
export type FormSubmissionQueryHookResult = ReturnType<typeof useFormSubmissionQuery>;
export type FormSubmissionLazyQueryHookResult = ReturnType<typeof useFormSubmissionLazyQuery>;
export type FormSubmissionQueryResult = Apollo.QueryResult<FormSubmissionQuery, FormSubmissionQueryVariables>;
export const RequestsDocument = gql`
    query Requests($categoryId: Float, $filter: RequestFilterArgType, $page: Int, $pageSize: Int, $search: String, $skip: Int, $sort: RequestSortField, $sortDirection: SortDirectionField, $ids: String) {
  Requests(
    categoryId: $categoryId
    filter: $filter
    page: $page
    pageSize: $pageSize
    search: $search
    skip: $skip
    sort: $sort
    sortDirection: $sortDirection
    ids: $ids
  ) {
    total
    items {
      userId
      updateTime
      shippedTime
      requestTime
      status
      id
      createTime
      user {
        ...UserFragment
        organizationInfo {
          ...OrganizationInfoFragment
        }
      }
      signature {
        id
        sign
      }
      selections {
        ...SelectionFragment
      }
      shippingLocation {
        ...ShippingLocationFragment
      }
      shippingDetail {
        ...ShippingDetailFragment
      }
      officeUse {
        ...OfficeUseFragment
      }
    }
  }
}
    ${UserFragmentFragmentDoc}
${OrganizationInfoFragmentFragmentDoc}
${SelectionFragmentFragmentDoc}   
${ShippingLocationFragmentFragmentDoc}
${ShippingDetailFragmentFragmentDoc}
${OfficeUseFragmentFragmentDoc}`;

/**
 * __useRequestsQuery__
 *
 * To run a query within a React component, call `useRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      sort: // value for 'sort'
 *      sortDirection: // value for 'sortDirection'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRequestsQuery(baseOptions?: Apollo.QueryHookOptions<RequestsQuery, RequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestsQuery, RequestsQueryVariables>(RequestsDocument, options);
      }
export function useRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestsQuery, RequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestsQuery, RequestsQueryVariables>(RequestsDocument, options);
        }
export type RequestsQueryHookResult = ReturnType<typeof useRequestsQuery>;
export type RequestsLazyQueryHookResult = ReturnType<typeof useRequestsLazyQuery>;
export type RequestsQueryResult = Apollo.QueryResult<RequestsQuery, RequestsQueryVariables>;
export const RequestByIdDocument = gql`
    query RequestById($requestId: Float!) {
  Request(requestId: $requestId) {
    message
    status
    data {
      id
      userId
      updateTime
      status
      createTime
      shippedTime
      requestTime
      officeUse {
        ...OfficeUseFragment
      }
      shippingDetail {
        ...ShippingDetailFragment
      }
      shippingLocation {
        ...ShippingLocationFragment
      }
      signature {
        id
        sign
      }
      user {
        ...UserFragment
        organizationInfo {
          ...OrganizationInfoFragment
        }
      }
      comments {
        comment
        createTime
        id
        updateTime
        user {
          ...UserFragment
        }
      }
    }
  }
}
    ${OfficeUseFragmentFragmentDoc}
${ShippingDetailFragmentFragmentDoc}
${ShippingLocationFragmentFragmentDoc}
${UserFragmentFragmentDoc}
${OrganizationInfoFragmentFragmentDoc}`;

export const CommentsByRequestIdDocument = gql`
    query GetCommentsByRequestId($requestId: Float!) {
      GetCommentsByRequestId(requestId: $requestId) {
    total
    items {
      comment
      createTime
      id
      updateTime
      user {
        ...UserFragment
      }
    }
  }
}
${UserFragmentFragmentDoc}`;

/**
 * __useRequestByIdQuery__
 *
 * To run a query within a React component, call `useRequestByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestByIdQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRequestByIdQuery(baseOptions: Apollo.QueryHookOptions<RequestByIdQuery, RequestByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestByIdQuery, RequestByIdQueryVariables>(RequestByIdDocument, options);
      }
export function useRequestByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestByIdQuery, RequestByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestByIdQuery, RequestByIdQueryVariables>(RequestByIdDocument, options);
        }
export function useGetCommentsByRequestIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsByRequestIdQuery, CommentsByRequestIdQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CommentsByRequestIdQuery, CommentsByRequestIdQueryVariables>(CommentsByRequestIdDocument, options);
}
export type RequestByIdQueryHookResult = ReturnType<typeof useRequestByIdQuery>;
export type RequestByIdLazyQueryHookResult = ReturnType<typeof useRequestByIdLazyQuery>;
export type RequestByIdQueryResult = Apollo.QueryResult<RequestByIdQuery, RequestByIdQueryVariables>;
export const RequestDocument = gql`
    query Request($requestId: Float!) {
  Request(requestId: $requestId) {
    message
    status
    data {
      id
      userId
      updateTime
      status
      createTime
      shippedTime
      requestTime
      officeUse {
        category
        feedbackFormRequested
        feedbackReceived
        freightDelivery
        id
        monitorTracking
        moreInfo
        previous
        shippingCarrier
        status
        trackingInfo
        upsLocation
        usps
        validateShippingAddress
        wsGmGs
      }
      shippingLocation {
        id
        organization
        title
        firstName
        lastName
        address1
        address2
        city
        state
        zipCode
      }
      shippingDetail {
        id
        phone
        email
        loadingDock
        is501c3
        contactInfo
        rank
      }
      signature {
        id
        sign
      }
      user {
        ...UserFragment
        role {
          ...UserRoleFragment
        }
      }
    }
  }
}
    ${UserFragmentFragmentDoc}
${UserRoleFragmentFragmentDoc}`;

/**
 * __useRequestQuery__
 *
 * To run a query within a React component, call `useRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRequestQuery(baseOptions: Apollo.QueryHookOptions<RequestQuery, RequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestQuery, RequestQueryVariables>(RequestDocument, options);
      }
export function useRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestQuery, RequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestQuery, RequestQueryVariables>(RequestDocument, options);
        }
export type RequestQueryHookResult = ReturnType<typeof useRequestQuery>;
export type RequestLazyQueryHookResult = ReturnType<typeof useRequestLazyQuery>;
export type RequestQueryResult = Apollo.QueryResult<RequestQuery, RequestQueryVariables>;
export const RequestSelectionsDocument = gql`
    query RequestSelections($requestId: Float!) {
  RequestSelections(requestId: $requestId) {
    items {
      id
      createTime
      cases
      singles
      updateTime
      resourceId
      resource {
        id
        imageUrl
        sku
        title
        description
        caseWeight
        createTime
        inventory
        categoryId
        exclusiveOffer
        isActive
        isPublished
        quantityInCase
        sortingOrder
        updateTime
      }
    }
    total
  }
}
    `;

/**
 * __useRequestSelectionsQuery__
 *
 * To run a query within a React component, call `useRequestSelectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestSelectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestSelectionsQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRequestSelectionsQuery(baseOptions: Apollo.QueryHookOptions<RequestSelectionsQuery, RequestSelectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestSelectionsQuery, RequestSelectionsQueryVariables>(RequestSelectionsDocument, options);
      }
export function useRequestSelectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestSelectionsQuery, RequestSelectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestSelectionsQuery, RequestSelectionsQueryVariables>(RequestSelectionsDocument, options);
        }
export type RequestSelectionsQueryHookResult = ReturnType<typeof useRequestSelectionsQuery>;
export type RequestSelectionsLazyQueryHookResult = ReturnType<typeof useRequestSelectionsLazyQuery>;
export type RequestSelectionsQueryResult = Apollo.QueryResult<RequestSelectionsQuery, RequestSelectionsQueryVariables>;
export const UserRolesDocument = gql`
    query UserRoles($page: Int, $pageSize: Int) {
  UserRoles(page: $page, pageSize: $pageSize) {
    items {
      ...UserRoleFragment
    }
    total
  }
}
    ${UserRoleFragmentFragmentDoc}`;

/**
 * __useUserRolesQuery__
 *
 * To run a query within a React component, call `useUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRolesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
      }
export function useUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export type UserRolesQueryHookResult = ReturnType<typeof useUserRolesQuery>;
export type UserRolesLazyQueryHookResult = ReturnType<typeof useUserRolesLazyQuery>;
export type UserRolesQueryResult = Apollo.QueryResult<UserRolesQuery, UserRolesQueryVariables>;
export const UserRoleDocument = gql`
    query UserRole($userroleId: Float!) {
  UserRole(userroleId: $userroleId) {
    message
    status
    data {
      ...UserRoleFragment
    }
  }
}
    ${UserRoleFragmentFragmentDoc}`;

/**
 * __useUserRoleQuery__
 *
 * To run a query within a React component, call `useUserRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleQuery({
 *   variables: {
 *      userroleId: // value for 'userroleId'
 *   },
 * });
 */
export function useUserRoleQuery(baseOptions: Apollo.QueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
      }
export function useUserRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoleQuery, UserRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoleQuery, UserRoleQueryVariables>(UserRoleDocument, options);
        }
export type UserRoleQueryHookResult = ReturnType<typeof useUserRoleQuery>;
export type UserRoleLazyQueryHookResult = ReturnType<typeof useUserRoleLazyQuery>;
export type UserRoleQueryResult = Apollo.QueryResult<UserRoleQuery, UserRoleQueryVariables>;
export const GetNewsCategoryDocument = gql`
    query GetNewsCategory($newsCategoryId: String!) {
  GetNewsCategory(newsCategoryId: $newsCategoryId) {
    status
    message
    data {
      id
      headLine
      sideContent
      newsCategoryId
    }
  }
}
    `;

/**
 * __useGetNewsCategoryQuery__
 *
 * To run a query within a React component, call `useGetNewsCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsCategoryQuery({
 *   variables: {
 *      newsCategoryId: // value for 'newsCategoryId'
 *   },
 * });
 */
export function useGetNewsCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetNewsCategoryQuery, GetNewsCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsCategoryQuery, GetNewsCategoryQueryVariables>(GetNewsCategoryDocument, options);
      }
export function useGetNewsCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsCategoryQuery, GetNewsCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsCategoryQuery, GetNewsCategoryQueryVariables>(GetNewsCategoryDocument, options);
        }
export type GetNewsCategoryQueryHookResult = ReturnType<typeof useGetNewsCategoryQuery>;
export type GetNewsCategoryLazyQueryHookResult = ReturnType<typeof useGetNewsCategoryLazyQuery>;
export type GetNewsCategoryQueryResult = Apollo.QueryResult<GetNewsCategoryQuery, GetNewsCategoryQueryVariables>;
export const PostsInPageDocument = gql`
    query PostsInPage($ministryId: String!, $page: Int, $pageSize: Int) {
  Posts(ministryId: $ministryId, page: $page, pageSize: $pageSize, isEnable: true) {
    items {
      id
      isEnabled
      publishedTime
      title
      url
      content
      ministryId
    }
    total
  }
}
    `;

/**
 * __usePostsInPageQuery__
 *
 * To run a query within a React component, call `usePostsInPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsInPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsInPageQuery({
 *   variables: {
 *      ministryId: // value for 'ministryId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function usePostsInPageQuery(baseOptions: Apollo.QueryHookOptions<PostsInPageQuery, PostsInPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsInPageQuery, PostsInPageQueryVariables>(PostsInPageDocument, options);
      }
export function usePostsInPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsInPageQuery, PostsInPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsInPageQuery, PostsInPageQueryVariables>(PostsInPageDocument, options);
        }
export type PostsInPageQueryHookResult = ReturnType<typeof usePostsInPageQuery>;
export type PostsInPageLazyQueryHookResult = ReturnType<typeof usePostsInPageLazyQuery>;
export type PostsInPageQueryResult = Apollo.QueryResult<PostsInPageQuery, PostsInPageQueryVariables>;
export const PostsDocument = gql`
    query Posts($ministryId: String!, $page: Int, $pageSize: Int) {
  Posts(ministryId: $ministryId, page: $page, pageSize: $pageSize) {
    items {
      id
      isEnabled
      publishedTime
      title
      url
      content
      ministryId
    }
    total
  }
}
    `;

/**
 * __usePostsQuery__
 *
 * To run a query within a React component, call `usePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsQuery({
 *   variables: {
 *      ministryId: // value for 'ministryId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function usePostsQuery(baseOptions: Apollo.QueryHookOptions<PostsQuery, PostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
      }
export function usePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsQuery, PostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
        }
export type PostsQueryHookResult = ReturnType<typeof usePostsQuery>;
export type PostsLazyQueryHookResult = ReturnType<typeof usePostsLazyQuery>;
export type PostsQueryResult = Apollo.QueryResult<PostsQuery, PostsQueryVariables>;
export const GetPostsNavigationDocument = gql`
    query GetPostsNavigation($ministryId: String!) {
  GetPostNavigation(ministryId: $ministryId) {
    data
    message
    status
  }
}
    `;

/**
 * __useGetPostsNavigationQuery__
 *
 * To run a query within a React component, call `useGetPostsNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsNavigationQuery({
 *   variables: {
 *      ministryId: // value for 'ministryId'
 *   },
 * });
 */
export function useGetPostsNavigationQuery(baseOptions: Apollo.QueryHookOptions<GetPostsNavigationQuery, GetPostsNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsNavigationQuery, GetPostsNavigationQueryVariables>(GetPostsNavigationDocument, options);
      }
export function useGetPostsNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsNavigationQuery, GetPostsNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsNavigationQuery, GetPostsNavigationQueryVariables>(GetPostsNavigationDocument, options);
        }
export type GetPostsNavigationQueryHookResult = ReturnType<typeof useGetPostsNavigationQuery>;
export type GetPostsNavigationLazyQueryHookResult = ReturnType<typeof useGetPostsNavigationLazyQuery>;
export type GetPostsNavigationQueryResult = Apollo.QueryResult<GetPostsNavigationQuery, GetPostsNavigationQueryVariables>;
export const PostByIdDocument = gql`
    query PostById($postId: Float!) {
  Post(PostId: $postId) {
    data {
      content
      id
      isEnabled
      publishedTime
      title
      url
      ministryId
    }
    status
    message
  }
}
    `;

/**
 * __usePostByIdQuery__
 *
 * To run a query within a React component, call `usePostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostByIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostByIdQuery(baseOptions: Apollo.QueryHookOptions<PostByIdQuery, PostByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostByIdQuery, PostByIdQueryVariables>(PostByIdDocument, options);
      }
export function usePostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostByIdQuery, PostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostByIdQuery, PostByIdQueryVariables>(PostByIdDocument, options);
        }
export type PostByIdQueryHookResult = ReturnType<typeof usePostByIdQuery>;
export type PostByIdLazyQueryHookResult = ReturnType<typeof usePostByIdLazyQuery>;
export type PostByIdQueryResult = Apollo.QueryResult<PostByIdQuery, PostByIdQueryVariables>;
export const GetPostByUrlDocument = gql`
    query GetPostByUrl($url: String!) {
  GetPostByUrl(url: $url) {
    message
    status
    data {
      content
      id
      isEnabled
      publishedTime
      title
      url
      ministryId
    }
  }
}
    `;

/**
 * __useGetPostByUrlQuery__
 *
 * To run a query within a React component, call `useGetPostByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetPostByUrlQuery(baseOptions: Apollo.QueryHookOptions<GetPostByUrlQuery, GetPostByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostByUrlQuery, GetPostByUrlQueryVariables>(GetPostByUrlDocument, options);
      }
export function useGetPostByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostByUrlQuery, GetPostByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostByUrlQuery, GetPostByUrlQueryVariables>(GetPostByUrlDocument, options);
        }
export type GetPostByUrlQueryHookResult = ReturnType<typeof useGetPostByUrlQuery>;
export type GetPostByUrlLazyQueryHookResult = ReturnType<typeof useGetPostByUrlLazyQuery>;
export type GetPostByUrlQueryResult = Apollo.QueryResult<GetPostByUrlQuery, GetPostByUrlQueryVariables>;
export const MinistriesDocument = gql`
    query Ministries($categoryId: Float, $isGallery: Boolean, $isNav: Boolean, $page: Int, $pageSize: Int, $parentId: Float, $Search: String, $skip: Int) {
  Ministries(
    categoryId: $categoryId
    isNav: $isNav
    isGallery: $isGallery
    page: $page
    pageSize: $pageSize
    parentId: $parentId
    search: $Search
    skip: $skip
  ) {
    total
    items {
      id
      name
      order
      pageTitle
      parent {
        name
      }
    }
  }
}
    `;

export const MinistryGalleriesDocument = gql`
    query MinistryGalleries($categoryId: Float, $isNav: Boolean, $page: Int, $pageSize: Int, $parentId: Float, $Search: String, $skip: Int) {
    MinistryGalleries(
      categoryId: $categoryId
      isNav: $isNav
      page: $page
      pageSize: $pageSize
      parentId: $parentId
      search: $Search
      skip: $skip
    ) {
      total
      items {
        id
        name
        order
        pageTitle
        parent {
          name
        }
      }
    }
}
    `;

/**
 * __useMinistriesQuery__
 *
 * To run a query within a React component, call `useMinistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinistriesQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      isNav: // value for 'isNav'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      parentId: // value for 'parentId'
 *      Search: // value for 'Search'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useMinistriesQuery(baseOptions?: Apollo.QueryHookOptions<MinistriesQuery, MinistriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MinistriesQuery, MinistriesQueryVariables>(MinistriesDocument, options);
      }

export function useMinistryGalleriesQuery(baseOptions?: Apollo.QueryHookOptions<MinistryGalleriesQuery>) {
        
        return Apollo.useQuery<MinistryGalleriesQuery, MinistriesQueryVariables>(MinistryGalleriesDocument);
      }
export function useMinistriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MinistriesQuery, MinistriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MinistriesQuery, MinistriesQueryVariables>(MinistriesDocument, options);
        }
export type MinistriesQueryHookResult = ReturnType<typeof useMinistriesQuery>;
export type MinistriesLazyQueryHookResult = ReturnType<typeof useMinistriesLazyQuery>;
export type MinistriesQueryResult = Apollo.QueryResult<MinistriesQuery, MinistriesQueryVariables>;
export const MinistriesDropDownItemsDocument = gql`
    query MinistriesDropDownItems {
  Ministries(isNav: true, page: 1, pageSize: 10000) {
    items {
      id
      name
      url
      summary
    }
  }
}
    `;



/**
 * __useMinistriesDropDownItemsQuery__
 *
 * To run a query within a React component, call `useMinistriesDropDownItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinistriesDropDownItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinistriesDropDownItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMinistriesDropDownItemsQuery(baseOptions?: Apollo.QueryHookOptions<MinistriesDropDownItemsQuery, MinistriesDropDownItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MinistriesDropDownItemsQuery, MinistriesDropDownItemsQueryVariables>(MinistriesDropDownItemsDocument, options);
      }
export function useMinistriesDropDownItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MinistriesDropDownItemsQuery, MinistriesDropDownItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MinistriesDropDownItemsQuery, MinistriesDropDownItemsQueryVariables>(MinistriesDropDownItemsDocument, options);
        }
export type MinistriesDropDownItemsQueryHookResult = ReturnType<typeof useMinistriesDropDownItemsQuery>;
export type MinistriesDropDownItemsLazyQueryHookResult = ReturnType<typeof useMinistriesDropDownItemsLazyQuery>;
export type MinistriesDropDownItemsQueryResult = Apollo.QueryResult<MinistriesDropDownItemsQuery, MinistriesDropDownItemsQueryVariables>;
export const MinistryByIdDocument = gql`
    query MinistryById($ministryId: Float!) {
  Ministry(id: $ministryId) {
    message
    status
    data {
      children {
        ...MinistryFragment
      }
      ...MinistryFragment
      resources {
        id
      }
      galleries {
        id
        title
        description
        sortingOrder
        imageUrl
      }
    }
  }
}
    ${MinistryFragmentFragmentDoc}`;

/**
 * __useMinistryByIdQuery__
 *
 * To run a query within a React component, call `useMinistryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinistryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinistryByIdQuery({
 *   variables: {
 *      ministryId: // value for 'ministryId'
 *   },
 * });
 */
export function useExclusionGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<ExclusionGroupByIdQuery, ExclusionGroupByIdQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<ExclusionGroupByIdQuery, ExclusionGroupByIdQueryVariables>(ExclusionGroupByIdDocument, options);
}
export const ExclusionGroupByIdDocument = gql`
    query ExclusionGroupById($exclusionGroupId: Float!) {
  ExclusionGroup(exclusionGroupId: $exclusionGroupId) {
    message
    status
    data {
      ...ExclusionGroupFragment
      resources {
        id,
        title
      }
    }
  }
}
    ${ExclusionGroupFragmentFragmentDoc}`;

export function useMinistryByIdQuery(baseOptions: Apollo.QueryHookOptions<MinistryByIdQuery, MinistryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MinistryByIdQuery, MinistryByIdQueryVariables>(MinistryByIdDocument, options);
      }
export function useMinistryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MinistryByIdQuery, MinistryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MinistryByIdQuery, MinistryByIdQueryVariables>(MinistryByIdDocument, options);
        }
export type MinistryByIdQueryHookResult = ReturnType<typeof useMinistryByIdQuery>;
export type MinistryByIdLazyQueryHookResult = ReturnType<typeof useMinistryByIdLazyQuery>;
export type MinistryByIdQueryResult = Apollo.QueryResult<MinistryByIdQuery, MinistryByIdQueryVariables>;
export const MinistryByUrlDocument = gql`
    query MinistryByUrl($ministryUrl: String!) {
  MinistryByUrl(url: $ministryUrl) {
    message
    status
    data {
      children {
        url
        name
        pageTitle
      }
      ...MinistryFragment
      resources {
        id
        imageUrl
        title
        description
        author
        subTitle
      }
      parent {
        sideImage
      }
      testimonials {
        summary
        name
        url
      }
      galleries {
        id
        title
        description
        imageUrl
      }
    }
  }
}
    ${MinistryFragmentFragmentDoc}`;

/**
 * __useMinistryByUrlQuery__
 *
 * To run a query within a React component, call `useMinistryByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinistryByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinistryByUrlQuery({
 *   variables: {
 *      ministryUrl: // value for 'ministryUrl'
 *   },
 * });
 */
export function useMinistryByUrlQuery(baseOptions: Apollo.QueryHookOptions<MinistryByUrlQuery, MinistryByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MinistryByUrlQuery, MinistryByUrlQueryVariables>(MinistryByUrlDocument, options);
      }
export function useMinistryByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MinistryByUrlQuery, MinistryByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MinistryByUrlQuery, MinistryByUrlQueryVariables>(MinistryByUrlDocument, options);
        }
export type MinistryByUrlQueryHookResult = ReturnType<typeof useMinistryByUrlQuery>;
export type MinistryByUrlLazyQueryHookResult = ReturnType<typeof useMinistryByUrlLazyQuery>;
export type MinistryByUrlQueryResult = Apollo.QueryResult<MinistryByUrlQuery, MinistryByUrlQueryVariables>;
export const TestimonialByUrlDocument = gql`
    query TestimonialByUrl($url: String!) {
  TestimonialByUrl(url: $url) {
    status
    message
    data {
      content
      createTime
      headLine
      id
      name
      order
      pageTitle
      ministryId
      sideContent
      summary
      updateTime
      url
      blocks {
        content
        id
        order
        sideContent
      }
    }
  }
}
    `;

/**
 * __useTestimonialByUrlQuery__
 *
 * To run a query within a React component, call `useTestimonialByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestimonialByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestimonialByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useTestimonialByUrlQuery(baseOptions: Apollo.QueryHookOptions<TestimonialByUrlQuery, TestimonialByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestimonialByUrlQuery, TestimonialByUrlQueryVariables>(TestimonialByUrlDocument, options);
      }
export function useTestimonialByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestimonialByUrlQuery, TestimonialByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestimonialByUrlQuery, TestimonialByUrlQueryVariables>(TestimonialByUrlDocument, options);
        }
export type TestimonialByUrlQueryHookResult = ReturnType<typeof useTestimonialByUrlQuery>;
export type TestimonialByUrlLazyQueryHookResult = ReturnType<typeof useTestimonialByUrlLazyQuery>;
export type TestimonialByUrlQueryResult = Apollo.QueryResult<TestimonialByUrlQuery, TestimonialByUrlQueryVariables>;
export const TestimonialsDocument = gql`
    query Testimonials {
  Testimonials {
    total
    items {
      blocks {
        content
        id
        order
        sideContent
      }
      content
      createTime
      headLine
      id
      name
      summary
      order
      pageTitle
      ministryId
      sideContent
      updateTime
      url
    }
  }
}
    `;

/**
 * __useTestimonialsQuery__
 *
 * To run a query within a React component, call `useTestimonialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestimonialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestimonialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestimonialsQuery(baseOptions?: Apollo.QueryHookOptions<TestimonialsQuery, TestimonialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestimonialsQuery, TestimonialsQueryVariables>(TestimonialsDocument, options);
      }
export function useTestimonialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestimonialsQuery, TestimonialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestimonialsQuery, TestimonialsQueryVariables>(TestimonialsDocument, options);
        }
export type TestimonialsQueryHookResult = ReturnType<typeof useTestimonialsQuery>;
export type TestimonialsLazyQueryHookResult = ReturnType<typeof useTestimonialsLazyQuery>;
export type TestimonialsQueryResult = Apollo.QueryResult<TestimonialsQuery, TestimonialsQueryVariables>;
export const TestimonialDocument = gql`
    query Testimonial($testimonialId: Float!) {
  Testimonial(id: $testimonialId) {
    status
    message
    data {
      content
      createTime
      headLine
      id
      name
      order
      pageTitle
      ministryId
      sideContent
      summary
      updateTime
      url
      blocks {
        content
        id
        order
        sideContent
      }
    }
  }
}
    `;

/**
 * __useTestimonialQuery__
 *
 * To run a query within a React component, call `useTestimonialQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestimonialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestimonialQuery({
 *   variables: {
 *      testimonialId: // value for 'testimonialId'
 *   },
 * });
 */
export function useTestimonialQuery(baseOptions: Apollo.QueryHookOptions<TestimonialQuery, TestimonialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestimonialQuery, TestimonialQueryVariables>(TestimonialDocument, options);
      }
export function useTestimonialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestimonialQuery, TestimonialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestimonialQuery, TestimonialQueryVariables>(TestimonialDocument, options);
        }
export type TestimonialQueryHookResult = ReturnType<typeof useTestimonialQuery>;
export type TestimonialLazyQueryHookResult = ReturnType<typeof useTestimonialLazyQuery>;
export type TestimonialQueryResult = Apollo.QueryResult<TestimonialQuery, TestimonialQueryVariables>;
export const RequestReportDocument = gql`
    query RequestReport($start: DateTime!, $end: DateTime!) {
  RequestReport(start: $start, end: $end) {
    message
    status
    data
  }
}
    `;

/**
 * __useRequestReportQuery__
 *
 * To run a query within a React component, call `useRequestReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestReportQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useRequestReportQuery(baseOptions: Apollo.QueryHookOptions<RequestReportQuery, RequestReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestReportQuery, RequestReportQueryVariables>(RequestReportDocument, options);
      }
export function useRequestReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestReportQuery, RequestReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestReportQuery, RequestReportQueryVariables>(RequestReportDocument, options);
        }
export type RequestReportQueryHookResult = ReturnType<typeof useRequestReportQuery>;
export type RequestReportLazyQueryHookResult = ReturnType<typeof useRequestReportLazyQuery>;
export type RequestReportQueryResult = Apollo.QueryResult<RequestReportQuery, RequestReportQueryVariables>;
export const RequestShipReportDocument = gql`
    query RequestShipReport($start: DateTime!, $end: DateTime!, $sort: ReportSortField, $sortDirection: SortDirectionField) {
  RequestShipReport(start: $start, end: $end, sort: $sort, sortDirection: $sortDirection) {
    message
    status
    data
  }
}
    `;

/**
 * __useRequestShipReportQuery__
 *
 * To run a query within a React component, call `useRequestShipReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestShipReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestShipReportQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useRequestShipReportQuery(baseOptions: Apollo.QueryHookOptions<RequestShipReportQuery, RequestShipReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestShipReportQuery, RequestShipReportQueryVariables>(RequestShipReportDocument, options);
      }
export function useRequestShipReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestShipReportQuery, RequestShipReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestShipReportQuery, RequestShipReportQueryVariables>(RequestShipReportDocument, options);
        }
export type RequestShipReportQueryHookResult = ReturnType<typeof useRequestShipReportQuery>;
export type RequestShipReportLazyQueryHookResult = ReturnType<typeof useRequestShipReportLazyQuery>;
export type RequestShipReportQueryResult = Apollo.QueryResult<RequestShipReportQuery, RequestShipReportQueryVariables>;

// New testimonial section page:

// ============ TYPES ============

export type TestimonialPageInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  enabledGallery?: InputMaybe<Scalars['Boolean']['input']>;
  galleryButtonName?: InputMaybe<Scalars['String']['input']>;
  galleryButtonPathUrl?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  ministryId?: InputMaybe<Scalars['Float']['input']>;
};

export type TestimonialSectionInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<Scalars['String']['input']>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  enabledButton?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  parentId?: InputMaybe<Scalars['Float']['input']>;
  galleries?: InputMaybe<Array<TestimonialSectionGalleryInput>>;
};

export type TestimonialSectionGalleryInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Float']['input']>;
};

export type ITestimonialPage = {
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  enabledGallery?: Maybe<Scalars['Boolean']['output']>;
  galleryButtonName?: Maybe<Scalars['String']['output']>;
  galleryButtonPathUrl?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  headLine?: Maybe<Scalars['String']['output']>;
  ministryId?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['DateTime']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type ITestimonialSection = {
  id?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  button?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  enabledButton?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Float']['output'];
  parentId?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['DateTime']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type ITestimonialSectionGallery = {
  id?: Maybe<Scalars['Float']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['DateTime']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type TestimonialPageModel = ITestimonialPage & {
  id?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  enabledGallery?: Maybe<Scalars['Boolean']['output']>;
  galleryButtonName?: Maybe<Scalars['String']['output']>;
  galleryButtonPathUrl?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  headLine?: Maybe<Scalars['String']['output']>;
  ministryId?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['DateTime']['output'];
  updateTime: Scalars['DateTime']['output'];
  sections?: Maybe<Array<TestimonialSectionModel>>;
};

export type TestimonialSectionModel = ITestimonialSection & {
  id?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  button?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  enabledButton?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Float']['output'];
  parentId?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['DateTime']['output'];
  updateTime: Scalars['DateTime']['output'];
  galleries?: Maybe<Array<TestimonialSectionGalleryModel>>;
};

export type TestimonialSectionGalleryModel = ITestimonialSectionGallery & {
  id?: Maybe<Scalars['Float']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  createTime: Scalars['DateTime']['output'];
  updateTime: Scalars['DateTime']['output'];
};

export type TestimonialPageResponse = {
  data?: Maybe<TestimonialPageModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type TestimonialPagePaginatedResponse = {
  items: Array<TestimonialPageModel>;
  total: Scalars['Float']['output'];
};

export type TestimonialSectionResponse = {
  data?: Maybe<TestimonialSectionModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type TestimonialSectionGalleryResponse = {
  data?: Maybe<TestimonialSectionGalleryModel>;
  errorCode?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

// ============ FRAGMENTS ============

export const TestimonialPageFragmentDoc = gql`
  fragment TestimonialPageFragment on TestimonialPageModel {
    id
    name
    pageTitle
    url
    summary
    logoUrl
    enabledGallery
    galleryButtonName
    galleryButtonPathUrl
    order
    headLine
    ministryId
    createTime
    updateTime
  }
`;

export const TestimonialSectionFragmentDoc = gql`
  fragment TestimonialSectionFragment on TestimonialSectionModel {
    id
    title
    content
    button
    buttonUrl
    enabledButton
    order
    parentId
    createTime
    updateTime
  }
`;

export const TestimonialSectionGalleryFragmentDoc = gql`
  fragment TestimonialSectionGalleryFragment on TestimonialSectionGalleryModel {
    id
    footer
    order
    imageUrl
    parentId
    createTime
    updateTime
  }
`;

// ============ MUTATIONS ============

export type CreateTestimonialPageMutationVariables = Exact<{
  data: TestimonialPageInput;
  sections?: InputMaybe<Array<TestimonialSectionInput> | TestimonialSectionInput>;
}>;

export type CreateTestimonialPageMutation = { 
  __typename: 'Mutation', 
  CreateTestimonialPage: { 
    __typename: 'TestimonialPageResponse', 
    status: boolean, 
    message: string, 
    data?: { 
      __typename: 'TestimonialPageModel', 
      id?: number | null, 
      name?: string | null, 
      pageTitle?: string | null, 
      url?: string | null, 
      summary?: string | null, 
      logoUrl?: string | null, 
      enabledGallery: boolean | null;
      galleryButtonName: string | null;
      galleryButtonPathUrl: string | null;
      order: number, 
      headLine?: string | null, 
      ministryId?: number | null, 
      createTime: any, 
      updateTime: any,
      sections?: Array<{ 
        __typename: 'TestimonialSectionModel', 
        id?: number | null, 
        title?: string | null, 
        content?: string | null,
        button?: string | null,
        buttonUrl?: string | null,
        enabledButton: boolean | null;
        order: number,
        parentId?: number | null,
        galleries?: Array<{
          __typename: 'TestimonialSectionGalleryModel',
          id?: number | null,
          footer?: string | null,
          order: number,
          imageUrl?: string | null,
          parentId?: number | null
        }> | null
      }> | null 
    } | null 
  } 
};

export type UpdateTestimonialPageMutationVariables = Exact<{
  data: TestimonialPageInput;
  sections?: InputMaybe<Array<TestimonialSectionInput> | TestimonialSectionInput>;
}>;

export type UpdateTestimonialPageMutation = { 
  __typename: 'Mutation', 
  UpdateTestimonialPage: { 
    __typename: 'TestimonialPageResponse', 
    status: boolean, 
    message: string, 
    data?: { 
      __typename: 'TestimonialPageModel', 
      id?: number | null, 
      name?: string | null, 
      pageTitle?: string | null, 
      url?: string | null, 
      summary?: string | null, 
      logoUrl?: string | null, 
      enabledGallery: boolean | null;
      galleryButtonName: string | null;
      galleryButtonPathUrl: string | null;
      order: number, 
      headLine?: string | null, 
      ministryId?: number | null, 
      createTime: any, 
      updateTime: any 
    } | null 
  } 
};

export type DeleteTestimonialPageMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;

export type DeleteTestimonialPageMutation = { 
  __typename: 'Mutation', 
  DeleteTestimonialPage: { 
    __typename: 'StringResponse', 
    status: boolean, 
    message: string, 
    data?: string | null 
  } 
};

// ============ DOCUMENTS ============

export const CreateTestimonialPageDocument = gql`
  mutation CreateTestimonialPage($data: TestimonialPageInput!, $sections: [TestimonialSectionInput!]) {
    CreateTestimonialPage(data: $data, sections: $sections) {
      status
      message
      data {
        ...TestimonialPageFragment
        sections {
          ...TestimonialSectionFragment
          galleries {
            ...TestimonialSectionGalleryFragment
          }
        }
      }
    }
  }
  ${TestimonialPageFragmentDoc}
  ${TestimonialSectionFragmentDoc}
  ${TestimonialSectionGalleryFragmentDoc}
`;

export const UpdateTestimonialPageDocument = gql`
  mutation UpdateTestimonialPage($data: TestimonialPageInput!, $sections: [TestimonialSectionInput!]) {
    UpdateTestimonialPage(data: $data, sections: $sections) {
      status
      message
      data {
        ...TestimonialPageFragment
      }
    }
  }
  ${TestimonialPageFragmentDoc}
`;

export const DeleteTestimonialPageDocument = gql`
  mutation DeleteTestimonialPage($id: Float!) {
    DeleteTestimonialPage(id: $id) {
      status
      message
      data
    }
  }
`;

export const TestimonialPageDocument = gql`
  query TestimonialPage($id: Float!) {
    TestimonialPage(id: $id) {
      status
      message
      data {
        ...TestimonialPageFragment
        sections {
          ...TestimonialSectionFragment
          galleries {
            ...TestimonialSectionGalleryFragment
          }
        }
      }
    }
  }
  ${TestimonialPageFragmentDoc}
  ${TestimonialSectionFragmentDoc}
  ${TestimonialSectionGalleryFragmentDoc}
`;

export const TestimonialPageByUrlDocument = gql`
  query TestimonialPageByUrl($url: String!) {
    TestimonialPageByUrl(url: $url) {
      status
      message
      data {
        ...TestimonialPageFragment
        sections {
          ...TestimonialSectionFragment
          galleries {
            ...TestimonialSectionGalleryFragment
          }
        }
      }
    }
  }
  ${TestimonialPageFragmentDoc}
  ${TestimonialSectionFragmentDoc}
  ${TestimonialSectionGalleryFragmentDoc}
`;

export const TestimonialPagesDocument = gql`
  query TestimonialPages($page: Int, $pageSize: Int) {
    TestimonialPages(page: $page, pageSize: $pageSize) {
      total
      items {
        ...TestimonialPageFragment
      }
    }
  }
  ${TestimonialPageFragmentDoc}
`;

// ============ HOOKS ============

export type CreateTestimonialPageMutationFn = Apollo.MutationFunction<CreateTestimonialPageMutation, CreateTestimonialPageMutationVariables>;

export function useCreateTestimonialPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestimonialPageMutation, CreateTestimonialPageMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateTestimonialPageMutation, CreateTestimonialPageMutationVariables>(CreateTestimonialPageDocument, options);
}

export type CreateTestimonialPageMutationHookResult = ReturnType<typeof useCreateTestimonialPageMutation>;
export type CreateTestimonialPageMutationResult = Apollo.MutationResult<CreateTestimonialPageMutation>;
export type CreateTestimonialPageMutationOptions = Apollo.BaseMutationOptions<CreateTestimonialPageMutation, CreateTestimonialPageMutationVariables>;

export type UpdateTestimonialPageMutationFn = Apollo.MutationFunction<UpdateTestimonialPageMutation, UpdateTestimonialPageMutationVariables>;

export function useUpdateTestimonialPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestimonialPageMutation, UpdateTestimonialPageMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateTestimonialPageMutation, UpdateTestimonialPageMutationVariables>(UpdateTestimonialPageDocument, options);
}

export type UpdateTestimonialPageMutationHookResult = ReturnType<typeof useUpdateTestimonialPageMutation>;
export type UpdateTestimonialPageMutationResult = Apollo.MutationResult<UpdateTestimonialPageMutation>;
export type UpdateTestimonialPageMutationOptions = Apollo.BaseMutationOptions<UpdateTestimonialPageMutation, UpdateTestimonialPageMutationVariables>;

export type DeleteTestimonialPageMutationFn = Apollo.MutationFunction<DeleteTestimonialPageMutation, DeleteTestimonialPageMutationVariables>;

export function useDeleteTestimonialPageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTestimonialPageMutation, DeleteTestimonialPageMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteTestimonialPageMutation, DeleteTestimonialPageMutationVariables>(DeleteTestimonialPageDocument, options);
}

export type DeleteTestimonialPageMutationHookResult = ReturnType<typeof useDeleteTestimonialPageMutation>;
export type DeleteTestimonialPageMutationResult = Apollo.MutationResult<DeleteTestimonialPageMutation>;
export type DeleteTestimonialPageMutationOptions = Apollo.BaseMutationOptions<DeleteTestimonialPageMutation, DeleteTestimonialPageMutationVariables>;

export function useTestimonialPageQuery(baseOptions: Apollo.QueryHookOptions<TestimonialPageQuery, TestimonialPageQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<TestimonialPageQuery, TestimonialPageQueryVariables>(TestimonialPageDocument, options);
}

export function useTestimonialPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestimonialPageQuery, TestimonialPageQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<TestimonialPageQuery, TestimonialPageQueryVariables>(TestimonialPageDocument, options);
}

export type TestimonialPageQueryHookResult = ReturnType<typeof useTestimonialPageQuery>;
export type TestimonialPageLazyQueryHookResult = ReturnType<typeof useTestimonialPageLazyQuery>;
export type TestimonialPageQueryResult = Apollo.QueryResult<TestimonialPageQuery, TestimonialPageQueryVariables>;

export function useTestimonialPageByUrlQuery(baseOptions: Apollo.QueryHookOptions<TestimonialPageByUrlQuery, TestimonialPageByUrlQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<TestimonialPageByUrlQuery, TestimonialPageByUrlQueryVariables>(TestimonialPageByUrlDocument, options);
}

export function useTestimonialPageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestimonialPageByUrlQuery, TestimonialPageByUrlQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<TestimonialPageByUrlQuery, TestimonialPageByUrlQueryVariables>(TestimonialPageByUrlDocument, options);
}

export type TestimonialPageByUrlQueryHookResult = ReturnType<typeof useTestimonialPageByUrlQuery>;
export type TestimonialPageByUrlLazyQueryHookResult = ReturnType<typeof useTestimonialPageByUrlLazyQuery>;
export type TestimonialPageByUrlQueryResult = Apollo.QueryResult<TestimonialPageByUrlQuery, TestimonialPageByUrlQueryVariables>;

export function useTestimonialPagesQuery(baseOptions?: Apollo.QueryHookOptions<TestimonialPagesQuery, TestimonialPagesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<TestimonialPagesQuery, TestimonialPagesQueryVariables>(TestimonialPagesDocument, options);
}

export function useTestimonialPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestimonialPagesQuery, TestimonialPagesQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<TestimonialPagesQuery, TestimonialPagesQueryVariables>(TestimonialPagesDocument, options);
}

export type TestimonialPagesQueryHookResult = ReturnType<typeof useTestimonialPagesQuery>;
export type TestimonialPagesLazyQueryHookResult = ReturnType<typeof useTestimonialPagesLazyQuery>;
export type TestimonialPagesQueryResult = Apollo.QueryResult<TestimonialPagesQuery, TestimonialPagesQueryVariables>;

// Query types
export type TestimonialPageQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;

export type TestimonialPageQuery = { 
  __typename: 'Query', 
  TestimonialPage: { 
    __typename: 'TestimonialPageResponse', 
    status: boolean, 
    message: string, 
    data?: { 
      __typename: 'TestimonialPageModel', 
      id?: number | null, 
      name?: string | null, 
      pageTitle?: string | null, 
      url?: string | null, 
      order: number, 
      headLine?: string | null, 
      ministryId?: number | null, 
      createTime: any, 
      updateTime: any 
    } | null 
  } 
};

export type TestimonialPageByUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;

export type TestimonialPageByUrlQuery = { 
  __typename: 'Query', 
  TestimonialPageByUrl: { 
    __typename: 'TestimonialPageResponse', 
    status: boolean, 
    message: string, 
    data?: { 
      __typename: 'TestimonialPageModel', 
      id?: number | null, 
      name?: string | null, 
      pageTitle?: string | null, 
      url?: string | null, 
      summary?: string | null,
      logoUrl?: string | null,
      enabledGallery: boolean | null;
      galleryButtonName: string | null;
      galleryButtonPathUrl: string | null;
      order: number, 
      headLine?: string | null, 
      ministryId?: number | null, 
      createTime: any, 
      updateTime: any,
      sections?: Array<{
        __typename: 'TestimonialSectionModel',
        id?: number | null,
        title?: string | null,
        content?: string | null,
        button?: string | null,
        buttonUrl?: string | null,
        enabledButton: boolean | null;
        order: number,
        parentId?: number | null,
        createTime: any,
        updateTime: any,
        galleries?: Array<{
          __typename: 'TestimonialSectionGalleryModel',
          id?: number | null,
          footer?: string | null,
          order: number,
          imageUrl?: string | null,
          parentId?: number | null,
          createTime: any,
          updateTime: any
        }> | null
      }> | null
    } | null 
  } 
};

export type TestimonialPagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type TestimonialPagesQuery = { 
  __typename: 'Query', 
  TestimonialPages: { 
    __typename: 'TestimonialPagePaginatedResponse', 
    total: number, 
    items: Array<{ 
      __typename: 'TestimonialPageModel', 
      id?: number | null, 
      name?: string | null, 
      pageTitle?: string | null, 
      url?: string | null, 
      order: number, 
      headLine?: string | null, 
      ministryId?: number | null, 
      createTime: any, 
      updateTime: any 
    }> 
  } 
};


export const AddTestimonialSectionDocument = gql`
  mutation AddTestimonialSection($data: TestimonialSectionInput!) {
    AddTestimonialSection(data: $data) {
      status
      message
      data {
        ...TestimonialSectionFragment
        galleries {
          ...TestimonialSectionGalleryFragment
        }
      }
    }
  }
  ${TestimonialSectionFragmentDoc}
  ${TestimonialSectionGalleryFragmentDoc}
`;

export const UpdateTestimonialSectionDocument = gql`
  mutation UpdateTestimonialSection($data: TestimonialSectionInput!, $galleries: [TestimonialSectionGalleryInput!]) {
    UpdateTestimonialSection(data: $data, galleries: $galleries) {
      status
      message
      data {
        ...TestimonialSectionFragment
        galleries {
          ...TestimonialSectionGalleryFragment
        }
      }
    }
  }
  ${TestimonialSectionFragmentDoc}
  ${TestimonialSectionGalleryFragmentDoc}
`;

export const DeleteTestimonialSectionDocument = gql`
  mutation DeleteTestimonialSection($id: Float!) {
    DeleteTestimonialSection(id: $id) {
      status
      message
      data
    }
  }
`;

// ============ GALLERY MUTATIONS ============

export const AddTestimonialSectionGalleryDocument = gql`
  mutation AddTestimonialSectionGallery($data: TestimonialSectionGalleryInput!) {
    AddTestimonialSectionGallery(data: $data) {
      status
      message
      data {
        ...TestimonialSectionGalleryFragment
      }
    }
  }
  ${TestimonialSectionGalleryFragmentDoc}
`;

export const UpdateTestimonialSectionGalleryDocument = gql`
  mutation UpdateTestimonialSectionGallery($data: TestimonialSectionGalleryInput!) {
    UpdateTestimonialSectionGallery(data: $data) {
      status
      message
      data {
        ...TestimonialSectionGalleryFragment
      }
    }
  }
  ${TestimonialSectionGalleryFragmentDoc}
`;

export const DeleteTestimonialSectionGalleryDocument = gql`
  mutation DeleteTestimonialSectionGallery($id: Float!) {
    DeleteTestimonialSectionGallery(id: $id) {
      status
      message
      data
    }
  }
`;

// ============ MUTATION TYPES ============

export type AddTestimonialSectionMutationVariables = Exact<{
  data: TestimonialSectionInput;
}>;

export type AddTestimonialSectionMutation = { 
  __typename: 'Mutation', 
  AddTestimonialSection: { 
    __typename: 'TestimonialSectionResponse', 
    status: boolean, 
    message: string, 
    data?: { 
      __typename: 'TestimonialSectionModel', 
      id?: number | null, 
      title?: string | null, 
      content?: string | null,
      button?: string | null,
      buttonUrl?: string | null,
      enabledButton: boolean | null;
      order: number,
      parentId?: number | null,
      createTime: any,
      updateTime: any,
      galleries?: Array<{
        __typename: 'TestimonialSectionGalleryModel',
        id?: number | null,
        footer?: string | null,
        order: number,
        imageUrl?: string | null,
        parentId?: number | null,
        createTime: any,
        updateTime: any
      }> | null
    } | null 
  } 
};

export type UpdateTestimonialSectionMutationVariables = Exact<{
  data: TestimonialSectionInput;
  galleries?: InputMaybe<Array<TestimonialSectionGalleryInput> | TestimonialSectionGalleryInput>;
}>;

export type UpdateTestimonialSectionMutation = { 
  __typename: 'Mutation', 
  UpdateTestimonialSection: { 
    __typename: 'TestimonialSectionResponse', 
    status: boolean, 
    message: string, 
    data?: { 
      __typename: 'TestimonialSectionModel', 
      id?: number | null, 
      title?: string | null, 
      content?: string | null,
      button?: string | null,
      buttonUrl?: string | null,
      enabledButton: boolean | null;
      order: number,
      parentId?: number | null,
      createTime: any,
      updateTime: any,
      galleries?: Array<{
        __typename: 'TestimonialSectionGalleryModel',
        id?: number | null,
        footer?: string | null,
        order: number,
        imageUrl?: string | null,
        parentId?: number | null,
        createTime: any,
        updateTime: any
      }> | null
    } | null 
  } 
};

export type DeleteTestimonialSectionMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;

export type DeleteTestimonialSectionMutation = { 
  __typename: 'Mutation', 
  DeleteTestimonialSection: { 
    __typename: 'StringResponse', 
    status: boolean, 
    message: string, 
    data?: string | null 
  } 
};

export type AddTestimonialSectionGalleryMutationVariables = Exact<{
  data: TestimonialSectionGalleryInput;
}>;

export type AddTestimonialSectionGalleryMutation = { 
  __typename: 'Mutation', 
  AddTestimonialSectionGallery: { 
    __typename: 'TestimonialSectionGalleryResponse', 
    status: boolean, 
    message: string, 
    data?: { 
      __typename: 'TestimonialSectionGalleryModel', 
      id?: number | null, 
      footer?: string | null, 
      order: number, 
      imageUrl?: string | null, 
      parentId?: number | null,
      createTime: any,
      updateTime: any
    } | null 
  } 
};

export type UpdateTestimonialSectionGalleryMutationVariables = Exact<{
  data: TestimonialSectionGalleryInput;
}>;

export type UpdateTestimonialSectionGalleryMutation = { 
  __typename: 'Mutation', 
  UpdateTestimonialSectionGallery: { 
    __typename: 'TestimonialSectionGalleryResponse', 
    status: boolean, 
    message: string, 
    data?: { 
      __typename: 'TestimonialSectionGalleryModel', 
      id?: number | null, 
      footer?: string | null, 
      order: number, 
      imageUrl?: string | null, 
      parentId?: number | null,
      createTime: any,
      updateTime: any
    } | null 
  } 
};

export type DeleteTestimonialSectionGalleryMutationVariables = Exact<{
  id: Scalars['Float']['input'];
}>;

export type DeleteTestimonialSectionGalleryMutation = { 
  __typename: 'Mutation', 
  DeleteTestimonialSectionGallery: { 
    __typename: 'StringResponse', 
    status: boolean, 
    message: string, 
    data?: string | null 
  } 
};

// ============ HOOKS ============

export function useAddTestimonialSectionMutation(baseOptions?: Apollo.MutationHookOptions<AddTestimonialSectionMutation, AddTestimonialSectionMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AddTestimonialSectionMutation, AddTestimonialSectionMutationVariables>(AddTestimonialSectionDocument, options);
}

export function useUpdateTestimonialSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestimonialSectionMutation, UpdateTestimonialSectionMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateTestimonialSectionMutation, UpdateTestimonialSectionMutationVariables>(UpdateTestimonialSectionDocument, options);
}

export function useDeleteTestimonialSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTestimonialSectionMutation, DeleteTestimonialSectionMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteTestimonialSectionMutation, DeleteTestimonialSectionMutationVariables>(DeleteTestimonialSectionDocument, options);
}

export function useAddTestimonialSectionGalleryMutation(baseOptions?: Apollo.MutationHookOptions<AddTestimonialSectionGalleryMutation, AddTestimonialSectionGalleryMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AddTestimonialSectionGalleryMutation, AddTestimonialSectionGalleryMutationVariables>(AddTestimonialSectionGalleryDocument, options);
}

export function useUpdateTestimonialSectionGalleryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestimonialSectionGalleryMutation, UpdateTestimonialSectionGalleryMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateTestimonialSectionGalleryMutation, UpdateTestimonialSectionGalleryMutationVariables>(UpdateTestimonialSectionGalleryDocument, options);
}

export function useDeleteTestimonialSectionGalleryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTestimonialSectionGalleryMutation, DeleteTestimonialSectionGalleryMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<DeleteTestimonialSectionGalleryMutation, DeleteTestimonialSectionGalleryMutationVariables>(DeleteTestimonialSectionGalleryDocument, options);
}